/* eslint-disable indent */
/* eslint-disable max-len */
/* eslint-disable quotes */

export const English = {
  Feed: {
    'Alkalinity & ph': 'Alkalinity & pH',
    'Alkalinity is 0 when pH is below or equal to 4.5': 'Alkalinity is 0 when pH is below or equal to 4.5',
    'Anion': 'Anion',
    'Balance': 'Balance',
    'Bicarbonate & pH': 'Bicarbonate & pH',
    'Brackish Surfacewater (Conventional)': 'Brackish Surfacewater (Conventional)',
    'Brackish Surfacewater (MF/UF)': 'Brackish Surfacewater (MF/UF)',
    'Brackish Water': 'Brackish Water',
    'Brackish Wellwater': 'Brackish Wellwater',
    'CO2 & Bicarbonate': 'CO<sub>2</sub> & Bicarbonate',
    'Cancel': 'Cancel',
    'Cation': 'Cation',
    'Charge Balance': 'Charge Balance',
    'Clear Values': 'Clear Values',
    'Conductivity': 'Electrical Conductivity at 25°C',
    'Density': 'Density',
    'Density, kg/m3': 'Density, kg/m3',
    'Do you want clear all the values for the composition': 'Do you want clear all the values for the composition',
    'Do you want close the Feed input page': 'Do you want to close this form?',
    'EDI': 'EDI',
    'Failed to fetch default units': 'Failed to fetch default units',
    'Feed': 'Feed',
    'Feed Compositions must be a positive number': 'Feed Compositions must be a positive number',
    'Feed Water Analysis': 'Feed Water Analysis',
    'High ph RO 2nd pass': 'High pH RO 2nd Pass',
    'High ph RO (city/well)': 'High pH RO (City/Well)',
    'High ph RO Wastewater': 'High pH RO Wastewater',
    'Input': 'Input',
    'MBR Permeate': 'MBR Permeate',
    'OK': 'OK',
    'OR': 'Or',
    'Osmotic Pressure': 'Osmotic Pressure',
    'Parameters': 'Parameters',
    'Parameters should not be empty': 'The field should not be empty',
    'Please enter water composition': 'Please enter feed water composition',
    'Pressure': 'Pressure',
    'Pressure should not be empty': 'Pressure should not be empty',
    'RO Permeate': 'RO Permeate',
    'Saturation Data (Feed water)': 'Saturation Data (Feed Water)',
    'Sea Water': 'Sea Water',
    'Sea Wellwater': 'Sea Wellwater',
    'Select Ion for Charge Balance': 'Select Ion for Charge Balance',
    'Select Water Source': 'Select Water Source',
    'Select Water Type': 'Select Water Type',
    'Sour Water': 'Sour Water',
    'Stiff-Davis Index': 'Stiff & Davis Stability Index (SDSI)',
    'Struvite': 'Struvite',
    'Supply Pressure': 'Supply Pressure',
    'Surface Seawater (Conventional)': 'Surface Seawater (Conventional)',
    'Surface Seawater (MF/UF)': 'Surface Seawater (MF/UF)',
    'Surface Water': 'Surface Water',
    'Sweet Water': 'Sweet Water',
    'Temperature': 'Temperature',
    'Tertiary Treated Wastewater (Conventional)': 'Tertiary Treated Wastewater (Conventional)',
    'Tertiary Treated Wastewater (MF/UF)': 'Tertiary Treated Wastewater (MF/UF)',
    'Total Alkalinity (ppm CaCO3)': 'Total Alkalinity (ppm CaCO<sub>3</sub>)',
    'Total Alkalinity is required': 'Enter a value for the Total Alkalinity',
    'Total Anions': 'Total Anions',
    'Total Cations': 'Total Cations',
    'Total Organic Carbon': 'Total Organic Carbon',
    'Upload Water Analysis': 'Upload Water Analysis',
    'User Defined': 'User Defined',
    'Well Water': 'Well Water',
    'pH should not be between 0-14': 'pH should be between 0-14',
  },
  EDI: {
    '# of E-Cell EDI Stacks': '# of E-Cell EDI Stacks',
    'AC Energy (kWh/ m3)': 'AC Energy (kWh/ m3)',
    'AC Power Consumption (kW)': 'AC Power Consumption (kW)',
    'Apply': 'Apply',
    'Are you sure you want to close this form?': 'Do you want to close this form?',
    'Blower/Ventilation Sizing for Cl': 'Blower/Ventilation Sizing for Cl',
    'Blower/Ventilation Sizing for Cl2': 'Blower/Ventilation Sizing for Cl2',
    'Blower/Ventilation Sizing for H': 'Blower/Ventilation Sizing for H',
    'Calculated Output Parameters': 'Calculated Output Parameters',
    'Cancel': 'Cancel',
    'Co-Current': 'Co-Current',
    'Concentrate Bleed (m3/h)': 'Concentrate Bleed (m3/h)',
    'Current (Amps)': 'Current (Amps)',
    'DC power (kW)': 'DC power (kW)',
    'Design': 'Design',
    'Design Safety Factor': 'Design Safety Factor',
    'E-Factor': 'E-Factor',
    'Effluent Silica Gaurantee (3 Series)': 'Effluent Silica Guarantee (3, 5 Series)',
    'Effluent Silica Gaurantee (7 Series)': 'Effluent Silica Guarantee (9 Series)',
    'Electrode Bleed (m3/h)': 'Electrode Bleed (m3/h)',
    'Electrode Bleed': 'Electrode Bleed',
    'Electrode Gas Generation': 'Electrode Gas Generation',
    'Expected': 'Expected',
    'Explosion Limit of H2 in Air': 'Explosion Limit of H<sub>2</sub> in Air',
    'Explosion limit of H2 in Air': 'Explosion Limit of H<sub>2</sub> in Air',
    'Exposure Limit of Cl2 in Air': 'Exposure Limit of Cl<sub>2</sub> in Air',
    'Feed Guarantee Guide': 'Feed Guarantee Guide',
    'Feed Inlet (m3/h)': 'Feed Inlet (m3/h)',
    'Feed Pressure (bar)': 'Feed Pressure (bar)',
    'Feed TEA Limitations for Resistivity Gaurantee': 'Feed TEA Limitations for Resistivity Guarantee',
    'Feed Water Specification': 'Feed Water Specification',
    'Feedwater Parameters': 'Feed Water Output Parameters',
    'Flow Per Stack': 'Product Flow Rate per Stack',
    'Gas': 'Gas',
    'Input': 'Input',
    'Maximum': 'Maximum',
    'Maximum Allowable Recovery (%)': 'Maximum Allowable Recovery (%)',
    'Note': 'Note',
    'OK': 'OK',
    'Output': 'Output',
    'Please enter the required fields': 'Please enter the required fields',
    'Please enter the values within range': 'Please enter the values within range',
    'Predicted Boron Product (ppb B)': 'Predicted Boron Product (ppb B)',
    'Predicted Product Outlet Pressure (bar)': 'Predicted Product Outlet Pressure (bar)',
    'Predicted Product Silica Level (ppb SiO2)': 'Predicted Product Silica Level (ppb SiO<sub>2</sub <p>)',
    'Predicted Product Chloride Level (ppb Cl)': 'Predicted Product Chloride Level (ppb Cl)',
    'Product Flow Rate': 'Product Flow Rate',
    'Product Resistivity (MΩ.cm)': 'Product Resistivity (MΩ.cm)',
    'Product Silica Guarantee Level (ppb SiO2)': 'Product Silica Guarantee Level (ppb SiO<sub>2</sub <p>)',
    'Product Sodium Guarantee Level (ppb Na)': 'Predicted Product Sodium Level (ppb Na)',
    'Predicted Product Sulfate Level (ppb SO4)': 'Predicted Product Sulfate Level (ppb SO<sub>4</sub <p>)',
    'Range': 'Range',
    'Rectifier DC Output': 'Rectifier DC Output',
    'Rectifier DC output': 'Rectifier DC Output',
    'Rectifier DC Output (Volts)': 'Rectifier DC Output (Volts)',
    'Rectifier Efficiency': 'Rectifier Efficiency',
    'Rectifier efficiency': 'Rectifier efficiency',
    'Rectifier Efficiency %': 'Rectifier Efficiency %',
    'Select': 'Select',
    'Stack Model': 'Stack Model',
    'Status': 'Status',
    'System Parameters': 'System Output Parameters',
    'System Product Flow': 'System Product Flow',
    'Target Resistivity (MΩ.cm)': 'Target Resistivity (MΩ.cm)',
    'Target Resistivity': 'Target Resistivity',
    'Target Silica Gaurantee (ppb SiO2)': 'Target Silica Gaurantee (ppb SiO2)',
    'Target Silica Gaurantee': 'Target Silica Guarantee',
    'Target Silica guarantee': 'Target Silica Guarantee',
    'Units': 'Units',
    'Value': 'Value',
    'Ventilation Blower/Fan Size': 'Ventilation Blower/Fan Size',
    'Ventilation Sizing': 'Ventilation Sizing',
    'Voltage (Volts)': 'Voltage (Volts)',
    'Upstream Interconnecting Piping Pressure Loss': 'Upstream Interconnecting Piping Pressure Loss',
    'RO permeate pressure must be at least 0.34 bar | 5 psi higher than E-Cell feed pressure to account for pressure loss in piping between RO permeate and E-Cell feed': 'RO permeate pressure must be at least 0.34 bar | 5 psi higher than E-Cell feed pressure to account for pressure loss in piping between RO permeate and E-Cell feed',
    'Conductivity (µS/cm @ 25°C)': 'Conductivity (µS/cm @ 25°C)'
  },
  RO: {
    'Perm': 'Perm',
    'Recovery (%)': 'Recovery (%)',
    'Add New Row': 'Add Stage',
    '0.5 Means that the elements only gives half the permeate flow rate as of the nominal element': '0.5 means that the elements only give half the permeate flow rate as of the nominal specification',
    '1.5 means that the salt passage is 1.5 times higher than that of the nominal element': '1.5 means that the salt passage is 1.5 times of that of the nominal specification',
    'A-Value Factor': 'A-Value Factor',
    'Activate Argo Analyzer': 'Activate Argo Analyzer',
    'Aluminium in Conc (ppm)': 'Aluminium in Conc (ppm)',
    'Antiscalant Dosage': 'Antiscalant Dosage',
    'Application': 'Application',
    'Apply': 'Apply',
    'Area': 'Area',
    'Argo Analyzer': 'Argo Analyzer',
    'Array Recovery': 'Array Recovery',
    'Average Flux': 'Average Flux',
    'B-Value Factor': 'B-Value Factor',
    'Boost Energy Efficiency %': 'Boost Efficiency %',
    'Boost Energy Efficiency % must be in the range 10-100': 'Boost Efficiency % must be in the range 10-100',
    'CLRO Parameters': 'CLRO Parameters',
    'Cancel': 'Cancel',
    'Compare': 'Compare',
    'Concentrate composition calculated by Winflows': 'Concentrate composition calculated by Winflows',
    'Copy RO Machine Configuration': 'Copy RO Machine Configuration',
    'Design Guidelines': 'Design Guidelines',
    'Do you want to close the RO input page?': 'Do you want to close this form?',
    'Element Age (yr)': 'Element Age (yr)',
    'Element Age (yr) must be in the range 0-10': 'Element Age (yr) must be in the range of 0-10',
    'Element Age Calculator': 'Element Age Calculator',
    'Element Group': 'Element Group',
    'Element Info': 'Element Info',
    'Element Model': 'Element Model',
    'Elements per Vessel': 'Elements per Vessel',
    'Elements per Vessel must be in the range 0-8': 'Elements per Vessel must be in the range of 1-8',
    'Enter valid data in Pressure Vessels, Elements Per Vessel and Element Type': 'Enter valid data in Pressure Vessels, Elements Per Vessel and Element Type',
    'Feed Pressure': 'Feed Pressure',
    'Flux Annual % Change': 'Flux Annual % Change',
    'Input A Value Factor & B Value Factor': 'Input A-Value Factor & B-Value Factor',
    'InterStage Boost Pressure': 'Interstage Boost Pressure',
    'InterStage Pressure Loss': 'Interstage Pressure Loss',
    'InterStage Pressure Loss must be in the range': 'Interstage Pressure Loss must be in the range of',
    'Max Pressure': 'Max Pressure',
    'No options': 'No options',
    'Nominal Flow': 'Nominal Flow',
    'OK': 'OK',
    'OutPut': 'Output',
    'Permeate Flow Rate': 'Permeate Flow Rate',
    'Permeate Pressure': 'Permeate Pressure',
    'Permeate Pressure must be in the range': 'Permeate Pressure must be in the range of',
    'Please populate the previous row(s) !': 'Please populate the previous row(s) !',
    'Pressure Vessels': 'Pressure Vessels',
    'Pressure Vessels must be in the range 0-999': 'Pressure Vessels must be in the range of 1-999',
    'Pressure drop during brine purge': 'Pressure drop during Brine Purge',
    'Product TDS': 'Permeate TDS',
    'RO Element Data': 'Element Data',
    'RO Parameters': 'RO Parameters',
    'RO Permeate': 'RO Permeate',
    'RO Recovery': 'RO Recovery',
    'RO Recovery, %': 'RO Recovery, %',
    'Recovery Per Circuit must be in the range 0-100%': 'Recovery Per Circuit must be in the range of 0-100%',
    'Recovery must be in the range 0-100%': 'Recovery must be in the range of 0-100%',
    'Recovery per circuit': 'Recovery per Circuit',
    'Recycle Permeate from Last Stage to Feed Pump': 'Recycle Permeate from Last Stage to Feed Pump',
    'Rejection': 'Rejection',
    'Results': 'Results',
    'Salt Passage Annual % Change': 'Salt Passage Annual % Change',
    'Saturation Indices': 'Saturation Ratios',
    'Select Hypersperse Products': 'Select a Hypersperse product',
    'Select Region': 'Select Region',
    'Spacer per Vessel must be in the range 0-8': 'Spacer per Vessel must be in the range of 0-8',
    'Spacers per Vessel': 'Spacers per Vessel',
    'Spec File is not available for this Element.': 'Spec File is not available for this Element.',
    'Split Permeate (Upstream Part)': 'Split Permeate (Upstream Part)',
    'Stage': 'Stage',
    'Sum of Element per Vessel & Spacers per Vessel must be <= 8': 'Sum of Element per Vessel & Spacers per Vessel must be <= 8',
    'Test': 'Test',
    'Test Pressure': 'Test Pressure',
    'Total holdup Volume': 'Total holdup Volume',
    'Type': 'Type',
    'Use Element Age and Annual % Change': 'Use Element Age and Annual % Change',
    'Winflows Design Simulator RO Elements Design Guidelines': 'Winflows Design Simulator RO Elements Design Guidelines',
    'Winflows RO Elements Design Guidelines': 'Winflows RO Elements Design Guidelines',
    'by': 'by',
    'Winflows Report': 'Winflows Report',
    'Generate': 'Generate',
    'RO Permeate flow': 'RO Permeate flow',
    'RO Recovery rate': 'RO Recovery rate',
    'Recovery during brine purge': 'Recovery during brine purge',
    'Feed Flow (per PV) during brine purge': 'Feed Flow (per PV) during brine purge',
    'Recovery during brine purge should be between 0 – 20': 'Recovery during brine purge should be between 0 – 20'
  },
  Header: {
    'About': 'About',
    'Design Guidelines': 'Design Guidelines',
    'Element Cross Reference List': 'Element Cross Reference List',
    'Give File Name': 'Give File Name',
    'Help': 'Help',
    'Language': 'Language',
    'RO Design Guidelines Tips': 'RO Design Guidelines Tips',
  },
  Landing: {
    '# of Elements': '# of Elements',
    'All': 'All',
    'Application': 'Application',
    'Application Wizard': 'Application Wizard',
    'Apply': 'Apply',
    'Archive': 'Archive',
    'Are you sure you want to delete it?': 'Do you want to delete it?',
    'Array': 'Array',
    'Choose any one parameter': 'Choose any one parameter',
    'Choose any RO Machine to Display the Data': 'Choose any RO Machine to display the data',
    'Select Equipment Model': 'Select Equipment Model',
    'Clear All': 'Clear All',
    'Created On': 'Created On',
    'Current': 'Current',
    'Design Flowsheet': 'Design Flowsheet',
    'Element Model': 'Element Model',
    'Enter name to Search': 'Enter name to search',
    'Error while deleting file': 'Error while deleting file',
    'FactSheet': 'Fact Sheet',
    'Failed to fetch Ro Machine record': 'Failed to fetch RO Machine data',
    'Feed Flow': 'Feed Flow',
    'Feed Water': 'Feed Water',
    'File deleted succesfully': 'File deleted successfully',
    'File Name': 'File Name',
    'File shared successfully!.': 'File shared successfully',
    'Flow Sheet Details': 'Flowsheet Details',
    'Flow Sheet Type': 'Flowsheet Type',
    'Flux': 'Flux',
    'Integrated RO-EDI': 'EDI Flowsheets',
    'Last Edited On': 'Last Edited On',
    'Multi-Pass Design': 'Multi-Pass Design',
    'My Projects': 'My Projects',
    'No options': 'No options',
    'No Result Found!': 'No results found',
    'OR': 'OR',
    'Open': 'Open',
    'Open File': 'Open File',
    'Permeate Flow Rate': 'Permeate Flow Rate',
    'Permeate Flow Rate must not be empty': 'Permeate Flow Rate must not be empty',
    'Pre Treatment': 'Pretreatment',
    'Pre-Configured Design': 'Template Library',
    'Project Details (Quick view)': 'Project Details',
    'Project Name': 'Project Name',
    'Recent Files': 'Recent Files',
    'Recent Search': 'Recent Search',
    'Result': 'Results',
    'RO-EDI Equipment Selector': 'RO-EDI Machine Selector',
    'See Result': 'View Results',
    'Shared by': 'Shared by',
    'Shared Projects': 'Shared Projects',
    'Single-Pass Design': 'Single Pass Design',
    'Submit': 'Submit',
    'Template Library': 'Template Library',
    'Tutorial': 'Tutorial',
    'Type here…': 'Type here…',
    'Unread': 'Unread',
    'Welcome to': 'Welcome to',
    'Nominal Permeate Flow Rate': 'Nominal Product Flow Rate',
    'Choose any RO-EDI Equipment Model to Display the Data': 'Choose any RO-EDI Machine Selector to Display the Data',
    'Please use the RO-EDI Equipment Selector. Please consult Veolia for further support.': 'Please use the RO-EDI Machine Selector. Please consult Veolia for further support.',
    'Potable Water': 'Potable Water',
    'Beverage Production': 'Beverage Production',
    'Potable Water - Low Boron': 'Potable Water - Low Boron',
    'Demineralization': 'Demineralization',
    'Reuse': 'Reuse',
    'Reuse - High Purity': 'Reuse - High Purity',
    'Ultrapure Water': 'Ultrapure Water',
    'RO Permeate Polishing': 'RO Permeate Polishing',
    'Water Softening': 'Water Softening',
    'City Water': 'City Water',
    'Conventional': 'Conventional',
    'MF/UF': 'MF/UF',
    'Logout': 'Logout',
    'Winflows Design Simulator': 'Winflows Design Simulator',
    'Received Projects': 'Received Projects'
  },
  ProjectInfo: {
    'Email': 'Email',
    'Engineer': 'Designer',
    'Enter Notes here...': 'Enter Notes here...',
    'Location': 'Location',
    'Ok': 'Ok',
    'Phone': 'Phone',
    'Project Info': 'Project Info',
    'Project Name*': 'Project Name*',
  },
  Pump: {
    'Are you sure you want to close this form?': 'Do you want to close this form?',
    'Auto Efficiencies': 'Auto Efficiencies',
    'Average Discharge Pressure': 'Average Discharge Pressure',
    'Cancel': 'Cancel',
    'Discharge Pressure': 'Discharge Pressure',
    'Flow Rate': 'Flow Rate',
    'Inlet Pressure': 'Inlet Pressure',
    'Motor Efficiency': 'Motor Efficiency',
    'OK': 'OK',
    'Power': 'Power',
    'Pump Efficiency': 'Pump Efficiency',
    'Pump Specification': 'Pump Specification',
    'VFD Efficiency': 'VFD Efficiency',
    'Power Consumption': 'Power Consumption',
    'Combined Efficiency': 'Combined Efficiency',
    'RO/NF Unit Attached': 'RO/NF Unit Attached'
  },
  Cartridge: {
    'Actual Flow per TIE': 'Actual Flow per TIE',
    'Cancel': 'Cancel',
    'Cartridge Filter': 'Cartridge Filter',
    'Do you want to close the CF input page?': 'Do you want to close this form?',
    'Filter': 'Filter',
    'Filter DP': 'Pressure Drop',
    'Flow per TIE': 'Flow per TIE',
    'Flow Sheet is not available for this Element.': 'Fact Sheet is currently not available for the selected model',
    'Micron': 'Micron (???)',
    'Number of Filters': 'Number of Filters',
    'OK': 'OK',
    'View Fact Sheet': 'View Fact Sheet',
    'Flow Capacity': 'Flow Capacity',
    'Filter Type': 'Filter Type',
    'Design Flow Per TIE': 'Design Flow Per TIE',
    'Outlet Pressure': 'Outlet Pressure',
    'Pressure Drop': 'Pressure Drop'
  },
  Stripper: {
    'Activate': 'Activate',
    'Are you sure you want to close this form?': 'Do you want to close this form?',
    'Cancel': 'Cancel',
    'OK': 'OK',
    'Outlet CO2 concentration': 'Outlet CO<sub>2</sub> concentration',
    'Outlet H2S concentration': 'Outlet H<sub>2</sub>S concentration',
    'Outlet NH3 concentration': 'Outlet NH<sub>3</sub> concentration',
    'Stripper': 'Stripper',
  },
  MixSplit: {
    'Apply': 'Apply',
    'Are you sure you want to close this form?': 'Do you want to close this form?',
    'Cancel': 'Cancel',
    'Flow Rate': 'Flow Rate',
    'Note': 'Note',
    'Number of Outlet Streams': 'Number of Outlet Streams',
    'OK': 'OK',
    'Split Fraction': 'Split Fraction',
    'Split Fraction of individual streams should be in the range of 0-1 and sum of all split fractions should be 1.': 'Split Fraction of individual streams should be in the range of 0-1 and the sum of all split fractions should be 1',
    'Split fraction(s) must not be empty': 'Split fractions must not be empty',
    'Splitter': 'Splitter',
    'Stream Name': 'Stream Name',
    'Stream Values should be between 0 and 1': 'Split Fraction of individual streams should be in the range of 0-1',
    'Sum of Split fraction(s) is 1 or more. Please review your input': 'The sum of split fractions is not 1. Please review your input',
    'Sum of split fraction(s) should be 1.0': 'The sum of split fractions should be 1',
    'Total stream values must be between 0 and 1': 'Total stream values must be between 0 and 1',
  },
  ChemDose: {
    'Apply': 'Apply',
    'Are you sure you want to close this form?': 'Do you want to close this form?',
    'Average Consumption as Supplied': 'Average Consumption as supplied',
    'Average Consumption as metered': 'Average Consumption as metered',
    'Cancel': 'Cancel',
    'Carbon Dioxide': 'Carbon Dioxide (CO<sub>2</sub>)',
    // 'Caustic Soda': 'Caustic Soda (NaOH)',
    'Chemical': 'Chemical',
    'Chemical Dosing': 'Chemical Dosing',
    'Chemical Selection': 'Chemical Selection',
    'Close': 'Close',
    'Dosage Rate': 'Dosage Rate',
    'Dosage Rate must be positive': 'Dosage Rate must be a positive value',
    'Dosing Control': 'Dosing Control',
    'Hardness Leakage': 'Hardness Leakage',
    'Hardness Leakage must be positive': 'Hardness Leakage must be a positive value',
    'Hydrochloric Acid': 'Hydrochloric Acid (HCl)',
    'Input': 'Input',
    'LSI must be between -3 and 3': 'LSI must be between -3 and 3',
    'Mass flow Rate': 'Mass Flow Rate',
    'Mass Flow Rate': 'Mass Flow Rate',
    'Metered Concentration': 'Metered Concentration',
    'Metered Concentration must be between 0 and 100': 'Metered Concentration must be between 0 and 100',
    'Metered Gravity at Supplied Concentration must be a positive value': 'Metered Gravity at Supplied Concentration must be a positive value',
    'Nitric Acid': 'Nitric Acid (HNO<sub>3</sub>)',
    'OK': 'OK',
    'Output': 'Output',
    'Phosphoric Acid': 'Phosphoric Acid (H<sub>3</sub>PO<sub>4</sub>)',
    'Please enter the chemical name': 'Please select a chemical',
    'Please enter the required fields': 'Please enter the required fields',
    'Safety Factor': 'Safety Factor',
    'Safety Factor must be positive': 'Safety Factor must be greater than 1',
    'Select': 'Select',
    'Slaked Lime': 'Slaked Lime (Ca(OH)<sub>2</sub>)',
    'Sodium Sulfate': 'Sodium Sulfate (Na<sub>2</sub>SO<sub>4</sub>)',
    'Sodium Cycle Softener': 'Sodium Cycle Softener (Na<sub>2</sub>O.Al<sub>2</sub>O<sub>3</sub>.ySiO<sub>2</sub>.xH<sub>2</sub>O)',
    'Calcium Carbonate': 'Calcium Carbonate (CaCO<sub>3</sub>)',
    'Specific Gravity at metered Concentration': 'Specific Gravity at Metered Concentration',
    'Specific Gravity at supplied Concentration': 'Specific Gravity at Supplied Concentration',
    'Specific Gravity at supplied Concentration must be positive': 'Specific Gravity at Supplied Concentration must be positive',
    // 'Sulfuric Acid': 'Sulfuric Acid (H<sub>2</sub>SO<sub>4</sub>)',
    'Supplied Concentration': 'Supplied Concentration',
    'Supplied Concentration must be between 0 and 100': 'Supplied Concentration must be between 0 and 100',
    'Supplied Form': 'Supplied Form',
    'Supplied/Delivered consumption with safety factor': 'Supplied/Delivered consumption with Safety Factor',
    'Target Alkalinity': 'Target Alkalinity',
    'Target LSI': 'Target LSI',
    'Usage': 'Usage',
    'Usage must be between 0 and 100': 'Usage must be between 0 and 100',
    'Volume Flow Rate': 'Volume Flow Rate',
    'pH must be between 0 and 14': 'pH must be between 0 and 14',
    'Sodium Carbonate': 'Sodium Carbonate (Na<sub>2</sub>CO<sub>3</sub>)',
    'Ammonia': 'Ammonia (NH<sub>3</sub>)',
  },
  ERD: {
    'Are you sure you want to close this form?': 'Do you want to close this form?',
    'Circulation Pump Efficiency': 'Circulation Pump Efficiency',
    'Circulation Pump Motor Efficiencies': 'Circulation Pump Motor Efficiency',
    'Circulation Pump VFD Efficiencies': 'Circulation Pump VFD Efficiency',
    'Circulation/Booster Pump': 'Circulation/Booster Pump',
    'Cost of Power': 'Cost of Power',
    'Differential Pressure HP Side': 'Differential Pressure HP Side',
    'Differential Pressure LP Side': 'Differential Pressure LP Side',
    'Efficiency': 'Efficiency',
    'Energy Recovery Device': 'Energy Recovery Device',
    'Feedwater Salinity': 'Feed Water Salinity',
    'HP Power Consumed': 'HP Pump Power Consumption',
    'HP Pump Efficiency': 'HP Pump Efficiency',
    'HP Pump Motor Efficiency': 'HP Pump Motor Efficiency',
    'Input Parameters': 'Input Parameters',
    'Leakage (reject in HP out stream)': 'Leakage',
    'Lubrication Flow': 'Lubrication Flow',
    'Lubrication Per Array': 'Lubrication Flow Per Array',
    'Manual or Auto Efficiencies': 'Manual or Auto Efficiencies',
    'Membrane Differential Pressure': 'RO Differential Pressure',
    'Mixing at Membrane Feed': 'Mixing at Membrane Feed',
    'Model': 'Model',
    'Motor Efficiency': 'Motor Efficiency',
    'Number of Units': 'Number of Units',
    'OK': 'OK',
    'Parameter': 'Parameter',
    'Power Consumed': 'Power Consumption',
    'Power Consumption': 'Power Consumption',
    'Power Cost Saved': 'Power Cost Saved',
    'Power Savings': 'Power Saving',
    'Pressure Exchanger': 'Pressure Exchanger',
    'Pressure Exchanger Performance': 'Pressure Exchanger Performance',
    'Pressure Exchanger Power results': 'Pressure Exchanger Power Results',
    'Pump Efficiency': 'Pump Efficiency',
    'RO Feed Pressure': 'RO Feed Pressure',
    'RO Permeate Flow': 'RO Permeate Flow',
    'RO Recovery Rate': 'RO Recovery Rate',
    'Specific Power Consumption': 'Specific Power Consumption',
    'Total Power Consumption': 'Total Power Consumption',
    'Unit': 'Unit',
    'Unit Flow': 'Unit Flow',
    'VFD Efficiency': 'VFD Efficiency',
    'Values': 'Values',
    'Work Exchanger': 'Work Exchanger',
    'Work Exchanger Performance': 'Work Exchanger Performance',
    'Work Exchanger Power results': 'Work Exchanger Power Results',
  },
  PW: {
    'Are you sure you want to close this form?': 'Do you want to close this form?',
    'Cost of Power': 'Cost of Power',
    'Electricity Generated (Mechanical Energy Recovered)': 'Electricity Generated (Mechanical Energy Recovered)',
    'Feedwater Salinity': 'Feed Water Salinity',
    'HP Motor Electrical Power': 'HP Motor Electrical Power',
    'HP Motor Shaft Power': 'HP Motor Shaft Power',
    'HP Pump Efficiency': 'HP Pump Efficiency',
    'HP Pump Motor Efficiency': 'HP Pump Motor Efficiency',
    'HP Pump Shaft Power': 'HP Pump Shaft Power',
    'Input Parameters': 'Input Parameters',
    'Low P Discharge Pressure': 'LP Side Discharge Pressure',
    'Membrane Differential Pressure': 'RO Differential Pressure',
    'Net Transfer Efficiency': 'Net Transfer Efficiency',
    'OK': 'OK',
    'Parameter': 'Parameter',
    'Pelton Wheel': 'Pelton Wheel',
    'Pelton wheel Performance': 'Pelton Wheel Performance',
    'Power Cost Saved': 'Power Cost Saved',
    'Power Savings': 'Power Saving',
    'RO Feed Pressure': 'RO Feed Pressure',
    'RO Permeate Flow': 'RO Permeate Flow',
    'RO Recovery Rate': 'RO Recovery Rate',
    'Specific Power Consumption': 'Specific Power Consumption',
    'Total Power Consumption': 'Total Power Consumption',
    'Turbine Efficiency': 'Turbine Efficiency',
    'Unit': 'Unit',
    'Values': 'Values',
  },
  TC: {
    'Are you sure you want to close this form?': 'Do you want to close this form?',
    'Boost Pressure': 'Boost Pressure',
    'Cost of Power': 'Cost of Power',
    'Energy Recovered': 'Energy Recovered',
    'Feedwater Salinity': 'Feed Water Salinity',
    'HP Power Consumed': 'HP Power Consumption',
    'HP Pump Efficiency': 'HP Pump Efficiency',
    'HP Pump Motor Efficiency': 'HP Pump Motor Efficiency',
    'Input Parameters': 'Input Parameters',
    'Low P Discharge Pressure': 'LP Side Discharge Pressure',
    'Membrane Differential Pressure': 'RO Differential Pressure',
    'Net Transfer Efficiency': 'Net Transfer Efficiency',
    'OK': 'OK',
    'Parameter': 'Parameter',
    'Power Cost Saved': 'Power Cost Saved',
    'Power Savings': 'Power Saving',
    'RO Feed Pressure': 'RO Feed Pressure',
    'RO Permeate Flow': 'RO Permeate Flow',
    'RO Recovery Rate': 'RO Recovery Rate',
    'Specific Power Consumption': 'Specific Power Consumption',
    'Total Power Consumption': 'Total Power Consumption',
    'Turbo Charger': 'Turbocharger',
    'Turbo Charger Performance': 'Turbocharger Performance',
    'Turbo Charger Placement': 'Turbocharger Placement',
    'Turbo Inlet Pressure': 'Turbo Inlet Pressure',
    'Turbo Outlet Pressure': 'Turbo Outlet Pressure',
    'Unit': 'Unit',
    'Values': 'Values',
  },
  CIP: {
    'CIP Calculator': 'CIP Calculator',
    'CIP Report': 'CIP Report',
    'Calculator': 'Calculator',
    'Cleaner Strength': 'Cleaner Strength',
    'Cleaner Type': 'Cleaner Type',
    'Cleaning Step': 'Cleaning Step',
    'Cleaning Strategies based on Foulant type': 'Cleaning Strategies based on Foulant type',
    'Element': 'Element',
    'Element/Vessel': 'Element/Vessel',
    'Foulant Type': 'Foulant Type',
    'Get Report': 'Get Report',
    'Liquid': 'Liquid',
    'Maintenance Clean': 'Maintenance Clean',
    'Membrane Material': 'Membrane Material',
    'NSF Approved': 'NSF Approved',
    'No of RO Trains': 'No of RO Trains',
    'No of Stages': 'No of Stages',
    'No of Vessels': 'No of Vessels',
    'Powder': 'Powder',
    'Print': 'Print',
    'Pump Flow rate': 'Pump Flow rate',
    'Quantity of Cleaner': 'Quantity of Cleaner',
    'Registration': 'Registration',
    'Select': 'Select',
    'Single Product': 'Single Product',
    'Solution Volume': 'Solution Volume',
    'Stage': 'Stage',
    'Stages Cleaned in Parallel': 'Stages Cleaned in Parallel',
    'Stages Cleaned in Series': 'Stages Cleaned in Series',
    'Standard': 'Standard',
    'System Design': 'System Design',
    'Total': 'Total',
    'Vol in CIP piping': 'Vol in CIP piping',
    'Vol in CIP tank': 'Vol in CIP tank',
    'Text 1 CIP': 'Cleaning is a complex process that requires information about the actual foulant(s) to define the best CIP strategy and products to use. The recommendations provided in this selection tool are general guidelines to assist in product selection.',
    'Text 2 CIP': 'Ideally, a foulant analysis should be used in the cleaner selection process. If a foulant analysis is not available, consult the drop down menu above and make an educated guess.',
    'Text 3 CIP': 'The tool allows selection of only foulant at a time. For combinations of foulants, consult the “Recommended selection for mixed foulants” in the drop down menu.',
    'Text 4 CIP': 'For complex scenarios or if there has been difficulty achieving expected results, please contact the MemChem Product Applications team for assistance in identifying alternate options and products.'
  },
  Notification_Modal: {
    'Are you sure you want to close this form?': 'Do you want to close this form?',
    'Choose Report Options': 'Choose Report Options',
    'Custom': 'Custom',
    'Default units have been saved successfully.': 'Default units have been saved successfully',
    'Display Units': 'Display Units',
    'Do you want to clear the canvas?': 'Do you want to clear the canvas?',
    'Do you want to close the page?': 'Do you want to close the page?',
    'Do you want to delete this unitop?': 'Do you want to delete this unit?',
    'Do you want to save the file?': 'Do you want to save the file?',
    'Failed to load Default units.': 'Failed to load default units',
    'Failed to load win files': 'Failed to load win files',
    'Feed flow': 'Feed Flow',
    'Flow': 'Flow',
    'Flowsheet is either empty or incomplete...': 'Flowsheet is either empty or incomplete',
    'Flowsheet is solved successfully.': 'Flowsheet is solved successfully',
    'Flowsheet solved with errors.': 'Flowsheet solved with errors',
    'Flowsheet solving has failed.': 'Flowsheet solving has failed',
    'Flux': 'Flux',
    'Generate PDF': 'Generate PDF',
    'Generate Sheets': 'Generate Sheets',
    'International': 'International',
    'Ion Composition': 'Ion Composition',
    'Kindly enter valid filename!': 'Please enter a valid filename',
    'Kindly save the file before sharing!': 'Please save the file before sharing',
    'Load': 'Load',
    'Load Winflows Design Simulator file': 'Load Winflows Design Simulator file',
    'Loading Please wait...': 'Loading Please wait...',
    'My Files': 'My Files',
    'No': 'No',
    'OK': 'OK',
    'Please add/update specify flow values!': 'Please input/update the values under the Specify Flow form',
    'Power': 'Power',
    'Pressure': 'Pressure',
    'Product flow': 'Product Flow',
    'Product Flow': 'Product Flow',
    'Reminder': 'Reminder',
    'Saturation Data': 'Saturation Data',
    'Save as Default': 'Save as Default',
    'Select file to upload': 'Select file to upload',
    'Shared By Others': 'Shared By Others',
    'Solver Message': 'Solver Status',
    'Specify Flow': 'Specify Flow',
    'Stream Data': 'Stream Data',
    'Stream Properties': 'Stream Properties',
    'Streams': 'Streams',
    'System Recovery': 'System Recovery',
    'Temperature': 'Temperature',
    'US': 'US',
    'Upload File': 'Upload File',
    'Volume': 'Volume',
    'Yes': 'Yes',
    'You cannot share empty flowsheet !': 'An empty flowsheet cannot be shared',
    'Successfully Done': 'Successfully Done',
    'File saved successfully.': 'File saved successfully.',
    'File Share': 'File Share',
    'Subject': 'Subject',
    'Message': 'Message',
    'Share': 'Share',
    'Enter all input fields': 'Enter all input fields',
    'Enter any one input field': 'Enter any one input field',
    'Automate Stream ID': 'Automate Stream ID',
    'Quick Results': 'Quick Results',
    'ARGO Analyzer Report': 'ARGO Analyzer Report',
    'Notifications': 'Notifications',
    'Do you want to save the file ?': 'Do you want to save the file ?',
    'Please select your country from the list given.': 'Please select your country from the list given.',
    'This selection allows Winflows to provide you with region-specific antiscalant options.': 'This selection allows Winflows to provide you with region-specific antiscalant options.',
    'Important: Your country selection is permanent and cannot be changed after submission.': 'Important: Your country selection is permanent and cannot be changed after submission.',
    'Failed to load saved win file': 'Failed to load saved win file',
    'RO Machine not available': 'RO Machine not available',
    'Entered stream number is duplicated!': 'Entered stream number is duplicated!',
    'Failed to fetch Units': 'Failed to fetch Units',
    'Failed to fetch DB transaction record': 'Failed to fetch DB transaction record',
    'Failed to fetch feed input.': 'Failed to fetch feed input.',
    'File seems empty, please create the flowsheet!': 'File seems empty, please create the flowsheet!',
    'Failed to save flow file': 'Failed to save flow file',
    'Failed to fetch file list': 'Failed to fetch file list',
    'Failed to save feed input.': 'Failed to save feed input.',
    'Failed to load win-4 files': 'Failed to load win-4 files',
    'Somthing is wrong.': 'Somthing is wrong.',
    'failed to download the file': 'failed to download the file',
    'Something went wrong': 'Something went wrong',
    'Failed to fetch Flowsheet Selection record': 'Failed to fetch Flowsheet Selection record',
    'No Data Found': 'No Data Found',
    'Please enter valid filename': 'Please enter valid filename',
    'Please provide a new name for the unitop as the current one is already available on the flowsheet.': 'Please provide a new name for the unitop as the current one is already available on the flowsheet.',
    'connections are incomplete!': 'connections are incomplete!',
    'Unitop inputs are either incomplete or incorrect!': 'Unitop inputs are either incomplete or incorrect!',
    'Only one instance of Argo Analyzer can be used in a flowsheet.': 'Only one instance of Argo Analyzer can be used in a flowsheet.',
    'Winflows Design Simulator detects multiple feed sources on the current flowsheet. Please input the flow rate for the respective feed source.': 'Winflows Design Simulator detects multiple feed sources on the current flowsheet. Please input the flow rate for the respective feed source.',
    'Enter all input field values!': 'Enter all input field values!',
    'Permeate Flux': 'Permeate Flux',
    'Recovery': 'Recovery',
    'Explorer': 'Explorer',
    'Average': 'Average',
    'Element Max': 'Element Max',
    'Vessels': 'Vessels',
    'No. of Elements': 'No. of Elements',
    'Element Type': 'Element Type',
    'Conc. Flow': 'Conc. Flow',
    'Perm Flow': 'Perm Flow',
    'Age': 'Age',
    'Saturation Data(Concentrate)': 'Saturation Data(Concentrate)',
    'Last Element Beta': 'Last Element Beta',
    'Delta Pressure': 'Delta Pressure',
    'Avg.': 'Avg.',
    'Feed TDS': 'Feed TDS',
    'Perm TDS': 'Perm TDS',
    'A-Value ACP': 'A-Value ACP',
    'B-Value ACP': 'B-Value ACP',
    'A-Factor': 'A-Factor',
    'B-Factor': 'B-Factor',
    'Element No.': 'Element No.',
    'Net Pressure': 'Net Pressure',
    'Update': 'Update',
    'Ionic Composition': 'Ionic Composition',
    'Table Setting': 'Table Setting',
    'Stream Source': 'Stream Source',
    'Stream Destination': 'Stream Destination',
    'Export Table': 'Export Table',
    'Session has expired. Please login!': 'Session has expired. Please login!',
    'Your session will expire in 10 minutes. Please save your work and login again.': 'Your session will expire in 10 minutes. Please save your work and login again.',
    'Session Expiry Warning': 'Session Expiry Warning'
  },
  Help_Modal_Form: {
    '* or multiple of it': '* or multiple of it',
    'About': 'About',
    'Database Date': 'Database Date',
    'Database Version': 'Database Version',
    'Design Guidelines': 'Design Guidelines',
    'Determine approximate number of RO elements': 'Determine approximate number of RO elements',
    'Determine array.': 'Determine array.',
    'Determine number of element housings.': 'Determine number of element housings.',
    'Determine which RO elements to use.': 'Determine which RO elements to use.',
    'Housings in 1': 'Housings in 1',
    'OK': 'OK',
    'Permeate Recovery, %': 'Permeate Recovery, %',
    'Program Date': 'Program Date',
    'Run Winflows Design Simulator with the 24-12 array and look for': 'Run Winflows Design Simulator with the 24-12 array and look for',
    'stage': 'stage',
    'Text1': 'The below instructions are a guide how to design simple RO units where the flow rates are big enough so 18 or more elements are required, and the osmotic pressure of the feed small enough to make it possible to operate above 65 percent permeate recovery. In this case, the task is to design an RO unit that at 80 percent permeate recovery will produce 1.5x10',
    'Text10': 'The permeate flux (shown in Winflows Design Simulator Explorer) profile not too skewed (preferably, the flux of the last element should be at least half the flux of the leading element). It is possible that an interstage booster pump or permeate backpressure in the first stage is needed to balance the permeate flux between the stages.',
    'Text2': 'gpd permeate with below 200 mg/L TDS from deep well water with 2000 mg/L TDS.',
    'Text3': '8” diameter elements are chosen. Those are typically available in 365, 400 and 430 ft',
    'Text4': 'active membrane area versions. Typically, the more active membrane area, the thinner is the feed channel spacer, and the higher is the fouling tendency of the element. In this case, the feed is deep well water with low fouling tendency, so a 400-ft2-element model is chosen.',
    'Text5': 'Select the average permeate flux, for example from Design Guidelines. In this example, the feed water is deep well water with a very low fouling tendency, so 15 gfd average permeate flux is chosen.',
    'Text6': 'Calculate the number of elements required (N) from the permeate flow rate (Fp), average permeate flux (Jw), and the active membrane area per element (AA).',
    'Text7': 'Fp = N×AA×Jw, which in this case gives N = 250 elements.',
    'Text8': 'There are typically 6 or 7 elements per housing. In this case, 7 elements per housing is chosen, which gives 36 element housings.',
    'Text9': 'At 80 percent permeate recovery, a two-stage array will probably work fine, which means that about 2/3 of the housings will be in the first stage. Thus, try a 24-12 array.',
    'The below table is used to determine how to approximately arrange the housings.': 'The below table is used to determine how to approximately arrange the housings.',
    'The predicted permeate TDS should be below the maximum allowed.': 'The predicted permeate TDS should be below the maximum allowed.',
    'The pressure drop over the elements': 'The pressure drop over the elements',
    'Tips on Designing RO Units Operating on Natural Waters with Below 5000 mg/L TDS': 'Tips on Designing RO Units Operating on Natural Waters with Below 5000 mg/L TDS',
    'Typical array*': 'Typical array*',
    'Warnings': 'Warnings',
    'Winflows Design Simulator RO Elements Design Guidelines': 'Winflows Design Simulator RO Elements Design Guidelines',
  },
  Preface: {
    'Winflows': 'Winflows',
    'Design Simulator': 'Design Simulator',
    'Winflows Design Simulator': 'Winflows Design Simulator',
    'Projection Report': 'Projection Report',
    'WATER TECHNOLOGIES': 'WATER TECHNOLOGIES',
    'Project Info': 'Project Info',
    'Project Name': 'Project Name',
    'Customer Name': 'Customer Name',
    'Engineer': 'Designer',
    'Location': 'Location',
    'Mail ID': 'Email',
    'Phone No': 'Phone',
    'Specify Flow Option': 'Specify Flow Option',
    'Notes': 'Notes',
    'None detected in the current design': 'None detected in the current design',
    'Trademark of Veolia': '*Trademark of Veolia; may be registered in one or more countries. 2025 Veolia. All rights reserved',
    'Database': 'Database',
    'Description': 'Description',
    'Unit Op': 'Unit Op',
    'Total Number of Warnings': 'Total Number of Warnings',
    'Total Number of Errors': 'Total Number of Errors',
    'Disclaimer_text': 'Disclaimer: This projection is provided as a complimentary service and does not constitute a performance warranty.'
  },
  Flowsheet_Design_Summary: {
    'Flowsheet Diagram': 'Flowsheet Diagram',
    'Flowsheet Design Summary': 'Flowsheet Design Summary',
    'Flowsheet Design': 'Flowsheet Design',
    'Stream Property Summary': 'Stream Property Summary',
    'Stream Id': 'Stream Id',
    'Alkalinity': 'Alkalinity',
    'Alkalinity, ppm CaCO3': 'Alkalinity, ppm CaCO3',
    'Hardness, ppm as CaCO3': 'Hardness, ppm as CaCO3',
    'Hardness': 'Hardness',
    'Conductivity at 25°C': 'Conductivity at 25°C',
    'FSD Flow Balance': 'FSD Flow Balance',
    'Unit ID (Stream no.)': 'Unit ID (Stream no.)',
    'Overall Flow Sheet Recovery': 'Overall Flow Sheet Recovery',
    'Flow - Total': 'Flow - Total',
    'Incoming': 'Incoming',
    'Outgoing': 'Outgoing',
    'Product': 'Product',
    'Waste': 'Waste',
    'ID': 'ID',
    'Conc.': 'Conc.',
    'Bleed': 'Bleed',
    'Desalination_Demineralization': 'Desalination / Demineralization / Membrane Separator (MEMS) Unit-Level Flow Summary',
  },
  Feed_Product_Waste_Summary: {
    'Feed-Product-Waste Summary': 'Feed-Product-Waste Summary',
    'Overall Flowsheet Recovery': 'Overall Flowsheet Recovery',
    'Category': 'Category',
    'Information': 'Information',
    'Ion Concentration': 'Ion Concentration',
    'Stream Property': 'Stream Property',
    'Water Source': 'Water Source',
    'Ionic Strength': 'Ionic Strength',
    'Osm.Pressure': 'Osm. Pressure (Osmotic Pressure)',
    'Osm. Pressure': 'Osm. Pressure',
    'Softened Water': 'Softened Water',
    'Pump Unit Summary': 'Pump Unit Summary'
  },
  RO_NF_Unit_System_Level_Summary: {
    'RO/NF Unit System-Level Summary': 'RO/NF Unit System-Level Summary',
    'Docked Summary': 'Docked Summary',
    'Total Number of RO/NF Unit': 'Total Number of RO/NF Unit',
    'RO/NF Unit ID': 'RO/NF Unit ID',
    'Upstream unit': 'Upstream unit',
    'Downstream unit': 'Downstream unit',
    'Permeate Flow': 'Permeate Flow',
    'Concentrate Flow': 'Concentrate Flow',
    'RO/NF Unit Recovery': 'RO/NF Unit Recovery',
    'Breakdown by Stage': 'Breakdown by Stage',
    'Total Membrane Area': 'Total Membrane Area',
    'Feed Temperature': 'Feed Temperature',
    'Interstage Pressure': 'Interstage Pressure',
    'Product Pressure *': 'Product Pressure *',
    'Feed pH': 'Feed pH',
    'Permeate TDS': 'Permeate TDS',
    'Concentrate TDS': 'Concentrate TDS',
    'Concentrate pH': 'Concentrate pH',
    'Detailed Design': 'Detailed Design',
    'Array Design': 'Array Design',
    'Housing': 'Housing',
    'Elements': 'Elements',
    'Element Age(yr)': 'Element Age (yr)',
    'Pressure Change': 'Pressure Change',
    'Boost': 'Boost',
    'Loss': 'Loss',
    'Permeate P': 'Permeate P',
    'Permeate pH': 'Permeate pH',
    'A-Value ACP': 'A-Value ACP',
    'A-Factor': 'A-Factor',
    'B-Value ACP': 'B-Value ACP',
    'B-Factor': 'B-Factor',
  },
  RO_NF_Unit_Stage_Level_Summary: {
    'RO/NF Unit Stage-Level Summary': 'RO/NF Unit Stage-Level Summary',
    'Element Type': 'Element Type',
    'Perm': 'Perm (Permeate)',
    'dP': 'dP',
  },
  DSSRO_Section_Summary: {
    'DSSRO Section Summary': 'DSSRO Section Summary',
    'DSSRO Overview': 'DSSRO Overview',
    'Overview': 'Overview',
    'DSSRO mode': 'DSSRO mode',
    'CLRO': 'CLRO',
    'Elements per PV': 'Elements per PV',
    'Spacers per PV': 'Spacers per PV',
    'Length of PV': 'Length of PV',
    'CL Recovery': 'CL Recovery',
    'BP Recovery': 'BP Recovery',
    'CL Concentrate Flow': 'CL Concentrate Flow',
    'BP Concentrate Flow': 'BP Concentrate Flow',
    'CL Net Feed Flow': 'CL Net Feed Flow',
    'BP Feed Flow': 'BP Feed Flow',
    'CL Permeate Flow': 'CL Permeate Flow',
    'Total Circuits': 'Total Circuits',
    'BP Sequence Duration': 'BP Sequence Duration',
    'CL Sequence Duration': 'CL Sequence Duration',
    'Complete Cycle Duration': 'Complete Cycle Duration',
    'CL System Volume': 'CL System Volume',
    'S1 Volume': 'S1 Volume',
    'S2 Volume': 'S2 Volume',
    'S3 Volume': 'S3 Volume',
    'DSSRO Flow Summary (Element Level)': 'DSSRO Flow Summary (Element Level)',
    'Flow Summary': 'Flow Summary',
    'Circuit': 'Circuit',
    'Element': 'Element',
    'Feed Press': 'Feed Press',
    'Conc Flow': 'Conc Flow',
    'CL 1': 'CL 1',
    'CL Final': 'CL Final',
    'DSSRO Stream Composition': 'DSSRO Stream Composition',
    'Concentrations': 'Concentrations',
    'Concentrations (mg/L as ion)': 'Concentrations (mg/L as ion)',
    'Concentrate': 'Concentrate',
    'Permeate': 'Permeate',
    'Composition': 'Composition',
    'Schematic': 'Schematic',
    'Production Loop': 'Production Loop',
    'High Pressure Centrifugal Pump (P2)': 'High Pressure Centrifugal Pump (P2)',
    'Raw Feed Flow': 'Raw Feed Flow',
    'Feed Pump (P1)': 'Feed Pump (P1)',
    'RO Feed': 'RO Feed',
    'Cartridge Filter': 'Cartridge Filter',
    'Feed Pressure': 'Feed Pressure',
    'Delta Pressure': 'Delta Pressure',
    'Circulation pump (P3)': 'Circulation pump (P3)',
    'CL Conc Flow': 'CL Conc Flow',
    'CL Perm Flow': 'CL Perm Flow',
    'Brine Purge': 'Brine Purge',
    'Conc Recirculation Flow': 'Conc Recirculation Flow',
    'BP Conc Flow': 'BP Conc Flow',
    'Brine Disposal': 'Brine Disposal',
    'DSSRO Loop Summary': 'DSSRO Loop Summary',
    'Loop No': 'Loop No',
    'Permeate Stream (Loop wise) Summary': 'Permeate Stream (Loop wise) Summary',
    'Concentrate Stream (Loop wise) Summary': 'Concentrate Stream (Loop wise) Summary',
  },
  Pump_Summary: {
    'Pump Summary': 'Pump Summary',
    'Total Number of Pumps': 'Total Number of Pumps',
    'Pump Unit ID': 'Pump Unit ID',
    'RO/NF Unit Attached': 'RO/NF Unit Attached',
    'Combined Efficiency': 'Combined Efficiency',
    'Total Power Consumption': 'Total Power Consumption (kW)',
  }, Detailed_Stream_Data: {
    'Detailed Stream Data': 'Detailed Stream Data',
    'LSI': 'LSI',
    'SDSI': 'SDSI',
    'Concentrate': 'Concentrate',
    'Inlet': 'Inlet',
    'Downstream Permeate': 'Downstream Permeate',
    'Stream ID': 'Stream ID'
  }, EDI_Unit_System_Level_Summary: {
    'EDI Unit System-Level Summary': 'EDI Unit System-Level Summary',
    'Total Number of EDI Unit': 'Total Number of EDI Unit',
    'EDI Unit ID': 'EDI Unit ID',
    'System Product Flow Rate': 'System Product Flow Rate',
    'Electrode Bleed Flow': 'Electrode Bleed Flow',
    'EDI Unit Recovery': 'EDI Unit Recovery',
    'No. of E-Cell EDI Stacks': 'No. of E-Cell EDI Stacks',
    'Concentrate Pressure': 'Concentrate Pressure',
    'Product Outlet Pressure': 'Product Outlet Pressure',
    'Voltage': 'Voltage',
    'AC Power': 'AC Power',
    'DC Power': 'DC Power',
    'DC power': 'DC Power',
    'Flow Configuration': 'Flow Configuration',
    'Counter-Current/Co-Current': 'Counter-Current/Co-Current',
    'Counter-Current': 'Counter-Current',
    'Feed TDS': 'Feed TDS',
    'Feed pH': 'Feed pH',
    'Product Resistivity': 'Product Resistivity',
    'Product pH': 'Product pH',
    'Concentrate TDS': 'Concentrate TDS',
    'Concentrate pH': 'Concentrate pH',
    'Electrode Bleed TDS': 'Electrode Bleed TDS',
    'Electrode Bleed pH': 'Electrode Bleed pH',
    'H2': 'H2',
    'Cl2': 'Cl2',
    'Blower/Ventilation Sizing for H2': 'Blower/Ventilation Sizing for H2',
    'Ventilation Blower/Fan': 'Ventilation Blower/Fan',
    'Size': 'Size',
    'Electrode_stream_vented_hydrogen': 'The Electrode stream must be vented as it contains small quantities of hydrogen, oxygen and possibly chlorine gas (if there is chloride ion in the Electrode stream.)',
    'hydrogen_oxygen_gas_edi': 'A 2:1 mixture of hydrogen and oxygen gas is produced at a maximum rate of 11.4 ml/amp/minute/stack (dry gas at 25 °C, 1.0 bar), consisting of 7.6 ml of hydrogen and 3.8 ml of oxygen. Ensure ventilation maintains the hydrogen gas levels below 4%.',
    'EDI Design Parameters': 'EDI Design Parameters',
    'Product Flow Rate per Stack': 'Product Flow Rate per Stack',
    'Upstream Interconnecting Piping': 'Upstream Interconnecting Piping',
    'Pressure Loss': 'Pressure Loss',
    'TEA': 'TEA',
    'TEC': 'TEC',
    'Silica': 'Silica',
    'Conductvity': 'Conductivity',
    'Product Silica guarantee level': 'Product Silica guarantee level',
    'Predicted Product Silica Level': 'Predicted Product Silica Level',
    'Predicted Product Sodium level': 'Predicted Product Sodium level',
    'Predicted Product Chloride level': 'Predicted Product Chloride level',
    'Predicted Product Sulfate level': 'Predicted Product Sulfate level',
    'Maximum Allowable Recovery': 'Maximum Allowable Recovery',
    'AC power consumption': 'AC power consumption',
    'AC energy': 'AC energy',
    'Predicted Product outlet pressure': 'Predicted Product outlet pressure',
    'Feed Inlet': 'Feed Inlet',
    'Concentrate Outlet': 'Concentrate Outlet',
    'Electrode Bleed': 'Electrode Bleed',
    'EDI Schematic': 'EDI Schematic',
    'Current/Stack': 'Current/Stack',
    'Stack Voltage': 'Stack Voltage',
    'Energy Consumption': 'Energy Consumption',
    'Maximum Recovery': 'Maximum Recovery',
    'Max. Conc. outlet pressure': 'Max. Conc. outlet pressure',
    'Conc. Bleed flow': 'Conc. Bleed flow',
    'Product pressure': 'Product pressure',
    'Max. Conc. inlet pressure': 'Max. Conc. inlet pressure',
    'Max. Electrode Bleed Pressure': 'Max. Electrode Bleed Pressure',
    'Dilute': 'Dilute',
    'Concentrate': 'Concentrate',
    'Electrode': 'Electrode',
  },
  CF_Unit_Summary: {
    'CF Unit Summary': 'CF Unit Summary',
    'Total Number of CF Unit': 'Total Number of CF Unit',
    'CF Unit ID': 'CF Unit ID',
    'Flow Capacity': 'Flow Capacity',
    'Filter Type': 'Filter Type',
    'Design Flow Per TIE': 'Design Flow Per TIE',
    'Outlet Pressure': 'Outlet Pressure',
    'Pressure Drop': 'Pressure Drop',
  },
  Chemical_Dosing_Unit_Summary: {
    'Chemical Dosing Unit Summary': 'Chemical Dosing Unit Summary',
    'Total Number of Chemical Dosing': 'Total Number of Chemical Dosing',
    'Dosing Endpoint': 'Dosing Endpoint',
    'Target Value': 'Target Value',
    'Concentration as Metered': 'Concentration as Metered',
    'Specific Gravity as Metered': 'Specific Gravity as Metered',
    'Metered Flow Rate': 'Metered Flow Rate',
    'Avg Cons.As Metered': 'Avg Cons. As Metered',
    'Avg Cons.As Supplied': 'Avg Cons. As Supplied',
    'Avg Cons.As Supplied with SF': 'Avg Cons. As Supplied with SF',
    'Sulfuric Acid': 'Sulfuric Acid',
    'Hydrochloric Acid': 'Hydrochloric Acid',
    'Phosphoric Acid': 'Phosphoric Acid',
    'Nitric Acid': 'Nitric Acid',
    'Carbon Dioxide': 'Carbon Dioxide',
    'Ammonia': 'Ammonia',
    'Caustic Soda': 'Caustic Soda',
    'Slaked Lime': 'Slaked Lime',
    'Sodium Carbonate': 'Sodium Carbonate',
    'Calclium Carbonate': 'Calcium Carbonate',
    'Sodium Sulfate': 'Sodium Sulfate',
    'Sodium Cycle Softener': 'Sodium Cycle Softener',
    'Target pH': 'Target pH',
    'Total Number of Chemical Type': 'Total Number of Chemical Type',
    'Aggregated by Chemical Type – Supplied Form': 'Aggregated by Chemical Type – Supplied Form',
    'Chemical Type': 'Chemical Type',
    'Chemical Dosing Unit ID': 'Chemical Dosing Unit ID',
    'Concentration as Supplied': 'Concentration as Supplied',
    'Specific Gravity as Supplied': 'Specific Gravity as Supplied',
    'Total Consumption': 'Total Consumption',
    'As Supplied': 'As Supplied',
    'As Supplied with SF': 'As Supplied with SF',
  },
  Antiscalant_Dosage_Summary: {
    'Antiscalant Dosage Summary': 'Antiscalant Dosage Summary',
    'Dosed In': 'Dosed In',
    'Antiscalant': 'Antiscalant',
    'Dosage in Feed': 'Dosage in Feed'
  },
  ERD_Unit_Summary: {
    'ERD Unit Summary (WIP)': 'ERD Unit Summary (WIP)',
    'Total Number of ERD Unit': 'Total Number of ERD Unit',
    'ERD Unit ID': 'ERD Unit ID',
    'ERD Type': 'ERD Type',
    'RO/NF Unit Attached': 'RO/NF Unit Attached',
    'Installed Location': 'Installed Location',
    'LP Discharge Pressure': 'LP Discharge Pressure',
    'Net Transfer Efficiency': 'Net Transfer Efficiency',
    'Boost Pressure': 'Boost Pressure',
    'Leakage (Reject in HP OUT)': 'Leakage (Reject in HP OUT)',
    'Mixing at Membrane Feed': 'Mixing at Membrane Feed',
    'Total Power Consumption': 'Total Power Consumption',
    'HP Pump': 'HP Pump',
    'Circulation Pump': 'Circulation Pump',
    'Energy Recovered': 'Energy Recovered',
    'Power Saving': 'Power Saving',
    'Work Exchanger (WX)': 'Work Exchanger (WX)',
  },
  Mixer_Splitter_Unit_Summary: {
    'Mixer-Splitter Unit Summary': 'Mixer-Splitter Unit Summary',
    'Total Number of Mixer-Splitter': 'Total Number of Mixer-Splitter',
    'Mixer-Splitter Unit ID': 'Mixer-Splitter Unit ID',
    'Inlet Stream ID': 'Inlet Stream ID',
    'Outlet Stream ID': 'Outlet Stream ID',
    'Mode': 'Mode',
    'Mix Ratios': 'Mix Ratios',
    'Split Ratios': 'Split Ratios',
    'calculated': 'calculated',
    'user input': 'user input',
    'Mix only': 'Mix only',
    'Split only': 'Split only',
  },
  Detailed_RO_NF_Element_Level_Data: {
    'Detailed RO/NF Element-Level Data': 'Detailed RO/NF Element-Level Data',
    'Parameter': 'Parameter',
    'Stage No.': 'Stage No.',
    'Element Pos.': 'Element Pos.',
    'Other': 'Other',
    'Stream Property': 'Stream Property',
    'Permeate Ion Concentration': 'Permeate Ion Concentration',
    'Net Driving': 'Net Driving',
    'Delta Pressure': 'Delta Pressure',
    'Feed Osm. Pressure': 'Feed Osm. Pressure'
  },
  Winflows_Design_Simulator_Program_Details: {
    'Winflows Design Simulator Program Details': 'Winflows Design Simulator Program Details',
    'Program Version': 'Program Version',
    'Program Last Update': 'Program Last Update',
    'Database Last Update': 'Database Last Update',
    'Contact for Technical Support': 'Contact for Technical Support',
  },
  Stripper_Unit_Summary: {
    'Stripper Unit Summary': 'Stripper Unit Summary',
    'Total Number of Stripper': 'Total Number of Stripper',
    'Outlet CO2 Concentration': 'Outlet CO₂ Concentration',
    'Stripper Unit ID': 'Stripper Unit ID',
    'Outlet H2S Concentration': 'Outlet H₂S Concentration',
    'Outlet NH3 Concentration': 'Outlet NH₃ Concentration',
  },
  Notification: {
    'FATAL ERROR!! Transmembrane Pressure Limit Exceeded! in ROHP_1 of Stage 1 of element 1 at given temperature.\n\nPlease change design!\nThe applied feed pressure exceeds the limit recommended for at least one of the elements selected. Operation above the maximum pressure can result in element damage, specifically, collapsed permeate channels, which will result in loss of element permeate productivity. \nExcessive pressure can also cause central tube collapse and subsequent element failure. To reduce the operating pressure for the system 1) increase the number of elements in the system, 2) reduce the system recovery, 3) increase the system feed temperature.': 'FATAL ERROR!! Transmembrane Pressure Limit Exceeded! in ROHP_1 of Stage 1 of element 1 at given temperature.\n\nPlease change design!\nThe applied feed pressure exceeds the limit recommended for at least one of the elements selected. Operation above the maximum pressure can result in element damage, specifically, collapsed permeate channels, which will result in loss of element permeate productivity.\nExcessive pressure can also cause central tube collapse and subsequent element failure. To reduce the operating pressure for the system:\n1) increase the number of elements in the system,\n2) reduce the system recovery,\n3) increase the system feed temperature.'
  }
};
export const Chinese = {
  Feed: {
    'Alkalinity & ph': '碱度和 pH 值',
    'Alkalinity is 0 when pH is below or equal to 4.5': '当 pH 值小于或等于 4.5 时碱度为 0',
    'Anion': '阴离子',
    'Balance': '平衡',
    'Bicarbonate & pH': '碳酸氢盐和 pH',
    'Brackish Surfacewater (Conventional)': '苦咸地表水 (常规)',
    'Brackish Surfacewater (MF/UF)': '苦咸地表水 (MF/UF)',
    'Brackish Water': '苦咸水',
    'Brackish Wellwater': '苦咸水 (井取)',
    'CO2 & Bicarbonate': '二氧化碳和碳酸氢盐',
    'Cancel': '取消',
    'Cation': '阳离子',
    'Charge Balance': '电荷平衡',
    'Clear Values': '清除数值',
    'Conductivity': '电导率 (25℃)',
    'Density': '密度',
    'Density, kg/m3': '密度, kg/m3',
    'Do you want clear all the values for the composition': '您是否要清除水质数据？',
    'Do you want close the Feed input page': '您是否要关闭此页面？',
    'EDI': 'EDI',
    'Failed to fetch default units': '无法获取默认单位',
    'Feed': '进水',
    'Feed Compositions must be a positive number': '进水组分浓度必须为正值',
    'Feed Water Analysis': '进水分析',
    'High ph RO 2nd pass': '高pH RO (二级RO)',
    'High ph RO (city/well)': '高pH RO (自来水/井水)',
    'High ph RO Wastewater': '高pH RO (废水)',
    'Input': '输入',
    'MBR Permeate': 'MBR 产水',
    'OK': '确认',
    'OR': '或者',
    'Osmotic Pressure': '渗透压',
    'Parameters': '参数',
    'Parameters should not be empty': '参数不能为空',
    'Please enter water composition': '请输入进水组分',
    'Pressure': '压力',
    'Pressure should not be empty': '压力输入不能为空',
    'RO Permeate': 'RO 产水',
    'Saturation Data (Feed water)': '饱和度数据 (进水)',
    'Sea Water': '海水',
    'Sea Wellwater': '海水 (井取）',
    'Select Ion for Charge Balance': '选择以下特定离子 用于离子电荷平衡',
    'Select Water Source': '选择水源',
    'Select Water Type': '选择水类型',
    'Sour Water': '酸性水',
    'Stiff-Davis Index': '斯蒂夫戴维斯指数 (SDSI)',
    'Struvite': '鸟粪石',
    'Supply Pressure': '给水压力',
    'Surface Seawater (Conventional)': '地表海水 (常规)',
    'Surface Seawater (MF/UF)': '地表海水 (MF/UF)',
    'Surface Water': '地表水',
    'Sweet Water': '有机废水',
    'Temperature': '温度',
    'Tertiary Treated Wastewater (Conventional)': '三级处理废水 (常规)',
    'Tertiary Treated Wastewater (MF/UF)': '三级处理废水 (MF/UF)',
    'Total Alkalinity (ppm CaCO3)': '总碱度 (ppm，以CaCO3计)',
    'Total Alkalinity is required': '请输入总碱度',
    'Total Anions': '总阴离子',
    'Total Cations': '总阳离子',
    'Total Organic Carbon': '总有机碳 (TOC)',
    'Upload Water Analysis': '导入水质',
    'User Defined': '用户自定义',
    'Well Water': '井水',
    'pH should not be between 0-14': 'pH 值应介于 0-14 之间',
  },
  EDI: {
    '# of E-Cell EDI Stacks': 'E-Cell EDI 膜块数量',
    'AC Energy (kWh/ m3)': '交流电耗 (kWh/m3)',
    'AC Power Consumption (kW)': '交流功率 (kW)',
    'Apply': '应用',
    'Are you sure you want to close this form?': '您确定要关闭此页面吗？',
    'Blower/Ventilation Sizing for Cl': '鼓风机/通风设备尺寸 (Cl2核算)',
    'Blower/Ventilation Sizing for Cl2': '鼓风机/通风设备尺寸 (Cl2核算)',
    'Blower/Ventilation Sizing for H': '鼓风机/通风设备尺寸 (H2核算)',
    'Calculated Output Parameters': '计算结果输出',
    'Cancel': '取消',
    'Co-Current': '顺流',
    'Concentrate Bleed (m3/h)': '浓水排放流量 (m3/h)',
    'Current (Amps)': '电流 (A)',
    'DC power (kW)': '直流功率 (kW)',
    'Design': '设计',
    'Design Safety Factor': '设计安全系数',
    'E-Factor': 'E因子',
    'Effluent Silica Gaurantee (3 Series)': '产水SiO2含量保证值 (3系列)',
    'Effluent Silica Gaurantee (7 Series)': '产水SiO2含量保证值 (7系列)',
    'Electrode Bleed': '极水排放流量',
    'Electrode Bleed (m3/h)': '极水排放流量 (m3/h)',
    'Electrode Gas Generation': '电极气体生成',
    'Expected': '预测值',
    'Explosion Limit of H2 in Air': '空气中H2的爆炸极限',
    'Explosion limit of H2 in Air': '空气中H2的爆炸极限',
    'Exposure Limit of Cl2 in Air': '空气中Cl2的暴露限值',
    'Feed Guarantee Guide': '进水及保证指南',
    'Feed Inlet (m3/h)': '进水流量 (m3/h)',
    'Feed Pressure (bar)': '进水压力 (m3/h)',
    'Feed TEA Limitations for Resistivity Gaurantee': '进水TEA高限值',
    'Feed Water Specification': '进水水质要求',
    'Feedwater Parameters': '进水输出参数',
    'Flow Per Stack': '单模块产水流量',
    'Gas': '气体',
    'Input': '输入',
    'Maximum': '理论最大值',
    'Maximum Allowable Recovery (%)': '最大允许回收率 (%)',
    'Note': '注意事项',
    'OK': '确认',
    'Output': '输出',
    'Please enter the required fields': '请输入必填字段',
    'Please enter the values within range': '请输入范围内的值',
    'Predicted Boron Product (ppb B)': '预测产水硼含量 (ppb，以B计)',
    'Predicted Product Outlet Pressure (bar)': '预测产水压力 (bar)',
    'Predicted Product Silica Level (ppb SiO2)': '预测产水硅含量 (ppb，以SiO2计)',
    'Predicted Product Chloride Level (ppb Cl)': '产水氯化物保证值 (ppb，以Cl计）',
    'Product Flow Rate': '产水流量',
    'Product Resistivity (MΩ.cm)': '产水电阻率 (MΩ-cm)',
    'Product Silica Guarantee Level (ppb SiO2)': '产水硅保证值 (ppb，以SiO2计)',
    'Predicted Product Sodium Level (ppb Na)': '产水钠保证值 (ppb,以Na计)',
    'Predicted Product Sulfate Level (ppb SO4)': '产水硫酸盐保证值 (ppb，以SO42-计)',
    'Range': '范围',
    'Rectifier DC Output (Volts)': '整流器直流输出 (Volts)',
    'Rectifier DC Output': '整流器直流输出',
    'Rectifier DC output': '整流器直流输出',
    'Rectifier Efficiency %': '整流器效率 %',
    'Rectifier Efficiency': '整流器效率',
    'Rectifier efficiency': '整流器效率',
    'Select': '选择',
    'Stack Model': '模块型号',
    'Status': '状态',
    'System Parameters': '系统输出参数',
    'Target Resistivity (MΩ.cm)': '目标电阻率 (MΩ.cm)',
    'Target Resistivity': '目标电阻率',
    'Target Silica Gaurantee (ppb SiO2)': '目标产水硅保证值 (ppb SiO2)',
    'Target Silica Gaurantee': '目标产水硅保证值',
    'Target Silica guarantee': '目标硅含量保证',
    'Units': '单位',
    'Value': '值',
    'Ventilation Blower/Fan Size': '鼓风机/风扇尺寸',
    'Ventilation Sizing': '通风设备尺寸',
    'Voltage (Volts)': '电压（V）',
    'Upstream Interconnecting Piping Pressure Loss': '上游連接管道壓力損失',
    'RO permeate pressure must be at least 0.34 bar | 5 psi higher than E-Cell feed pressure to account for pressure loss in piping between RO permeate and E-Cell feed': 'RO 滲透壓力必須比 E-Cell 進料壓力至少高 0.34 bar | 5 psi，以彌補 RO 滲透和 E-Cell 進料之間管道的壓力損失',
    'System Product Flow': '系統產品流程',
    'Conductivity (µS/cm @ 25°C)': '電導率（µS/cm @ 25°C）'
  },
  RO: {
    'Perm': '',
    'Recovery (%)': '回收率 (%)',
    'Add New Row': '添加段',
    '0.5 Means that the elements only gives half the permeate flow rate as of the nominal element': '0.5表示膜元件产水量只有标称值的一半',
    '1.5 means that the salt passage is 1.5 times higher than that of the nominal element': '1.5表示膜元件透盐率为标称值的1.5倍',
    'A-Value Factor': 'A 值因子',
    'Activate Argo Analyzer': '启动 Argo 分析',
    'Aluminium in Conc (ppm)': '浓水中铝浓度 (ppm)',
    'Antiscalant Dosage': '阻垢剂加药量',
    'Application': '产品分类',
    'Apply': '应用',
    'Area': '膜面积',
    'Argo Analyzer': 'Argo分析器',
    'Array Recovery': '膜堆回收率',
    'Average Flux': '平均通量',
    'B-Value Factor': 'B 值因子',
    'Boost Energy Efficiency %': '段间增压泵效率 (%)',
    'Boost Energy Efficiency % must be in the range 10-100': '段间增压泵效率 (%) 必须在10-100范围内',
    'CLRO Parameters': 'CLRO 参数',
    'Cancel': '取消',
    'Compare': '比较',
    'Concentrate composition calculated by Winflows': '通过Winflow计算的浓水组分',
    'Copy RO Machine Configuration': '复制RO整机膜堆排列',
    'Design Guidelines': '设计指南',
    'Do you want to close the RO input page?': '您是否要关闭此页面？',
    'Element Age (yr)': '膜元件寿命 (年)',
    'Element Age (yr) must be in the range 0-10': '膜元件寿命 (年) 必须在0-10范围内',
    'Element Age Calculator': '膜元件寿命计算器',
    'Element Group': '膜元件分类',
    'Element Info': '膜元件信息',
    'Element Model': '膜元件型号',
    'Elements per Vessel': '单支膜壳膜元件数',
    'Elements per Vessel must be in the range 0-8': '单支膜壳膜元件数必须在1-8范围内',
    'Enter valid data in Pressure Vessels, Elements Per Vessel and Element Type': '在膜壳数、单支膜壳膜元件数及膜元 件类型中输入有效数据',
    'Feed Pressure': '进水压力',
    'Flux Annual % Change': '通量年变化率',
    'Input A Value Factor & B Value Factor': '输入A值因子和B值因子',
    'InterStage Boost Pressure': '段间增压',
    'InterStage Pressure Loss': '段间压损',
    'InterStage Pressure Loss must be in the range': '段间压损值必须在xx范围内',
    'Max Pressure': '最大压力',
    'No options': '暂无其他选项',
    'Nominal Flow': '标称流量',
    'OK': '确认',
    'OutPut': '输出',
    'Permeate Flow Rate': '产水流量',
    'Permeate Pressure': '产水压力',
    'Permeate Pressure must be in the range': '产水压力必须在xx范围内',
    'Please populate the previous row(s) !': '请先填写前段数据',
    'Pressure Vessels': '膜壳',
    'Pressure Vessels must be in the range 0-999': '膜壳数必须在1-999范围内',
    'Pressure drop during brine purge': '浓水排放阶段压降',
    'Product TDS': '产水TDS',
    'RO Element Data': '膜元件数据',
    'RO Parameters': 'RO 参数',
    'RO Permeate': 'RO产水',
    'RO Recovery': 'RO回收率',
    'RO Recovery, %': 'RO 回收率 (%)',
    'Recovery Per Circuit must be in the range 0-100%': '单个回路回收率必须在0-100%范围内',
    'Recovery must be in the range 0-100%': '回收率范围必须在0-100%范围内',
    'Recovery per circuit': '单个回路回收率',
    'Recycle Permeate from Last Stage to Feed Pump': '最后一段产水回流至进水泵前',
    'Rejection': '截留率',
    'Results': '结果',
    'Salt Passage Annual % Change': '透盐率年变化率 (%)',
    'Saturation Indices': '饱和度',
    'Select Hypersperse Products': '选择一款Hypersperse产品',
    'Select Region': '选择地区',
    'Spacer per Vessel must be in the range 0-8': '单支膜壳中膜元件数必须在1-8范围内',
    'Spacers per Vessel': '单支膜壳中膜元件数',
    'Spec File is not available for this Element.': '该膜元件规格表不可用',
    'Split Permeate (Upstream Part)': '产水分流 (上游部分)',
    'Stage': '段',
    'Sum of Element per Vessel & Spacers per Vessel must be <= 8': '每个膜壳的膜元件和间隔管 (或空白膜元件) 总数必须小于等于 8',
    'Test': '测试',
    'Test Pressure': '测试压力',
    'Total holdup Volume': '总滞留体积',
    'Type': '类型',
    'Use Element Age and Annual % Change': '采用膜元件使用时间 (年) 和年变化率 (%)',
    'Winflows Design Simulator RO Elements Design Guidelines': 'Winflows 设计模拟器 RO 元素设计指南',
    'Winflows RO Elements Design Guidelines': 'Winflows 膜系统设计指南',
    'by': '通过',
    'Winflows Report': 'Winflows报告',
    'Generate': '生成',
    'RO Permeate flow': '产水流量',
    'RO Recovery rate': '回收率',
    'Recovery during brine purge': '盐水清洗过程中的恢复',
    'Feed Flow (per PV) during brine purge': '盐水清洗期间的进料流量（每个PV)',
    'Recovery during brine purge should be between 0 – 20': '盐水清洗过程中的恢复应在 0 到 20 之间'
  },
  Header: {
    'About': '关于软件',
    'Design Guidelines': '设计指南',
    'Element Cross Reference List': 'RO膜元件交叉对照表',
    'Give File Name': '给出文件名',
    'Help': '帮助',
    'Language': '语言',
    'RO Design Guidelines Tips': 'RO设计指南小贴士',
  },
  Landing: {
    '# of Elements': '膜元件数量',
    'All': '全部',
    'Application': '应用',
    'Application Wizard': '应用程序向导',
    'Apply': '应用',
    'Archive': '归档',
    'Are you sure you want to delete it?': '您确定要删除吗？',
    'Array': '膜堆',
    'Choose any one parameter': '选择任意一个参数',
    'Choose any RO Machine to Display the Data': '选择任意RO整机以显示数据',
    'Select Equipment Model': '选择设备型号',
    'Clear All': '清除全部',
    'Created On': '创建于',
    'Current': '当前的',
    'Design Flowsheet': '设计流程图',
    'Element Model': '膜元件型号',
    'Enter name to Search': '输入名称进行搜索',
    'Error while deleting file': '删除文件时发生错误',
    'FactSheet': '规格书',
    'Failed to fetch Ro Machine record': '无法读取RO整机数据',
    'Feed Flow': '进水流量',
    'Feed Water': '进水',
    'File deleted succesfully': '文件刪除成功',
    'File Name': '文件名',
    'File shared successfully!.': '文件共享成功！',
    'Flow Sheet Details': '流程图详情',
    'Flow Sheet Type': '流程图类型',
    'Flux': '通量',
    'Integrated RO-EDI': 'RO-EDI装置',
    'Last Edited On': '最后编辑日期',
    'Multi-Pass Design': '多级设计',
    'My Projects': '我的项目',
    'No options': '暂无其他选项',
    'No Result Found!': '未找到结果！',
    'OR': '或者',
    'Open': '打开',
    'Open File': '打开文件',
    'Permeate Flow Rate': '产水流量',
    'Permeate Flow Rate must not be empty': '产水流量不能为空',
    'Pre Treatment': '预处理',
    'Pre-Configured Design': '模板库',
    'Project Details (Quick view)': '项目详情',
    'Project Name': '项目名',
    'Recent Files': '最近的文件',
    'Recent Search': '最近搜索',
    'Result': '结果',
    'RO-EDI Equipment Selector': 'RO-EDI整机设备',
    'See Result': '查看结果',
    'Shared by': '分享者',
    'Shared Projects': '共享项目',
    'Single-Pass Design': '单级设计',
    'Submit': '提交',
    'Template Library': '模板库',
    'Tutorial': '教程',
    'Type here…': '在此输入',
    'Unread': '未读',
    'Welcome to': '欢迎使用',
    'Nominal Permeate Flow Rate': '标称产水量',
    'Choose any RO-EDI Equipment Model to Display the Data': '选择任意RO-EDI整机设备显示数据',
    'Please use the RO-EDI Equipment Selector. Please consult Veolia for further support.': '请使用 RO-EDI 整机设备 。请咨询威立雅以获得进一步支持。',
    'Potable Water': '饮用水',
    'Beverage Production': '饮料生产',
    'Potable Water - Low Boron': '饮用水 - 低硼',
    'Demineralization': '脱盐水',
    'Reuse': '再生水',
    'Reuse - High Purity': '再生水 - 高纯度',
    'Ultrapure Water': '超纯水',
    'RO Permeate Polishing': 'RO产水抛光处理',
    'Water Softening': '水软化',
    'City Water': '城市供水',
    'Conventional': '传统的',
    'MF/UF': '微滤/超滤',
    'Logout': '退出',
    'Winflows Design Simulator': 'Winflows设计模拟器',
    'Received Projects': '收到的項目',
  },
  ProjectInfo: {
    'Email': '电子邮件',
    'Engineer': '设计者',
    'Enter Notes here...': '在此输入注释',
    'Location': '地点',
    'Ok': '确认',
    'Phone': '电话',
    'Project Info': '项目信息',
    'Project Name*': '项目名称*',
  },
  Pump: {
    'Are you sure you want to close this form?': '您确定要关闭此页面吗？',
    'Auto Efficiencies': '默认效率值',
    'Average Discharge Pressure': '平均出口压力',
    'Cancel': '取消',
    'Discharge Pressure': '出口压力',
    'Flow Rate': '流速',
    'Inlet Pressure': '入口压力',
    'Motor Efficiency': '电机效率',
    'OK': '确认',
    'Power': '功率',
    'Pump Efficiency': '泵效率',
    'Pump Specification': '泵参数',
    'VFD Efficiency': '变频器 (VFD) 效率',
    'Power Consumption': '功耗',
    'Combined Efficiency': '综合效率',
    'RO/NF Unit Attached': '反渗透/纳滤装置已连接'
  },
  Cartridge: {
    'Actual Flow per TIE': '每10英寸实际流量',
    'Cancel': '取消',
    'Cartridge Filter': '保安过滤器',
    'Do you want to close the CF input page?': '您确定要关闭此页面吗？',
    'Filter': '过滤器',
    'Filter DP': '压差',
    'Flow per TIE': '每10英寸设计流量',
    'Flow Sheet is not available for this Element.': '该型号产品规格表不可用',
    'Micron': '微米 (μm)',
    'Number of Filters': '滤芯数量',
    'OK': '确认',
    'View Fact Sheet': '查看规格表',
    'Flow Capacity': '流量容量',
    'Filter Type': '过滤器类型',
    'Design Flow Per TIE': '每个TIE的设计流量',
    'Outlet Pressure': '出口压力',
    'Pressure Drop': '压降'
  },
  Stripper: {
    'Activate': '激活',
    'Are you sure you want to close this form?': '您确定要关闭此页面吗？',
    'Cancel': '取消',
    'OK': '好的',
    'Outlet CO2 concentration': '出口二氧化碳浓度',
    'Outlet H2S concentration': '出口H2S浓度',
    'Outlet NH3 concentration': '出口NH3浓度',
    'Stripper': '脱气装置',
  },
  MixSplit: {
    'Apply': '应用',
    'Are you sure you want to close this form?': '您确定要关闭此页面吗？',
    'Cancel': '取消',
    'Flow Rate': '流速',
    'Note': '备注',
    'Number of Outlet Streams': '出水流股数',
    'OK': '确认',
    'Split Fraction': '分流比例',
    'Split Fraction of individual streams should be in the range of 0-1 and sum of all split fractions should be 1.': '各流股分流比例应在0-1之间且之和为1',
    'Split fraction(s) must not be empty': '分流比例不能为空',
    'Splitter': '分流器',
    'Stream Name': '流股名称',
    'Stream Values should be between 0 and 1': '各流股分流比例_应小于1_且大于0',
    'Sum of Split fraction(s) is 1 or more. Please review your input': '各流股分流比例之和大于1，请检查输入参数',
    'Sum of split fraction(s) should be 1.0': '各流股分流比例之和应等于1',
    'Total stream values must be between 0 and 1': '总流值__应小于1_且大于0',
  },
  ChemDose: {
    'Apply': '应用',
    'Are you sure you want to close this form?': '您确定要关闭此页面吗？',
    'Average Consumption as Supplied': '原液供应量',
    'Average Consumption as metered': '稀释液供应量',
    'Cancel': '取消',
    'Carbon Dioxide': '二氧化碳',
    // 'Caustic Soda': '烧碱 (NaOH)',
    'Chemical': '化学药剂',
    'Chemical Dosing': '化学药剂投加',
    'Chemical Selection': '化学药剂选择',
    'Close': '关闭',
    'Dosage Rate': '加药浓度',
    'Dosage Rate must be positive': '加药量必须为正值',
    'Dosing Control': '加药控制',
    'Hardness Leakage': '硬度泄漏',
    'Hardness Leakage must be positive': '硬度泄漏必须为正值',
    'Hydrochloric Acid': '盐酸 (HCl)',
    'Input': '输入',
    'LSI must be between -3 and 3': 'LSI 必须介于 -3 和 3 之间',
    'Mass flow Rate': '加药量',
    'Mass Flow Rate': '加药量',
    'Metered Concentration': '稀释液浓度',
    'Metered Concentration must be between 0 and 100': '稀释液浓度必须在0-100之间',
    'Metered Gravity at supplied Concentration must be positive': '所供浓度下的计量重力必须为正值',
    'Nitric Acid': '硝酸 (HNO3)',
    'OK': '确认',
    'Output': '输出',
    'Phosphoric Acid': '磷酸 (H3PO4)',
    'Please enter the chemical name': '请选择化学药剂名称',
    'Please enter the required fields': '请输入必填字段',
    'Safety Factor': '安全系数',
    'Safety Factor must be positive': '安全系数必须大于1',
    'Select': '选择',
    'Slacked Lime': '熟石灰 (Ca(OH)2)',
    'Sodium Cycle Softener': '钠离子交换器',
    'Specific Gravity at metered Concentration': '稀释液比重',
    'Specific Gravity at supplied Concentration': '原液比重',
    'Specific Gravity at supplied Concentration must be positive': '原液比重必须为正值',
    // 'Sulfuric Acid': '硫酸 (H2SO4)',
    'Supplied Concentration': '原液浓度',
    'Supplied Concentration must be between 0 and 100': '原液浓度数值必须介于0-100之间',
    'Supplied Form': '供应形式',
    'Supplied/Delivered consumption with safety factor': '考虑安全系数后的消耗量',
    'Target Alkalinity': '目标碱度',
    'Target LSI': '目标LSI',
    'Usage': '产能利用率',
    'Usage must be between 0 and 100': '产能利用率必须介于0到100%之间',
    'Volume Flow Rate': '体积流量',
    'pH must be between 0 and 14': 'pH 值必须介于 0 至 14 之间',
  },
  ERD: {
    'Are you sure you want to close this form?': '您确定要关闭此页面吗？',
    'Circulation Pump Efficiency': '循环泵效率',
    'Circulation Pump Motor Efficiencies': '循环泵电机效率',
    'Circulation Pump VFD Efficiencies': '循环泵变频器 (VFD) 效率',
    'Circulation/Booster Pump': '循环/增压泵',
    'Cost of Power': '电费 ($/kWh)',
    'Differential Pressure HP Side': '高压侧压差',
    'Differential Pressure LP Side': '低压侧压差',
    'Efficiency': '效率',
    'Energy Recovery Device': '能量回收装置',
    'Feedwater Salinity': '进水盐浓度',
    'HP Power Consumed': '高压泵功率',
    'HP Pump Efficiency': '高压泵效率',
    'HP Pump Motor Efficiency': '高压泵电机效率',
    'Input Parameters': '输入参数',
    'Leakage (reject in HP out stream)': '泄露',
    'Lubrication Flow': '润滑流量',
    'Lubrication Per Array': '单位润滑流量',
    'Manual or Auto Efficiencies': '手动设定或自动效率',
    'Membrane Differential Pressure': '膜系统压降',
    'Mixing at Membrane Feed': '膜进料混合',
    'Model': '型号',
    'Motor Efficiency': '电机效率',
    'Number of Units': '单元数',
    'OK': '确认',
    'Parameter': '参数',
    'Power Consumed': '能耗',
    'Power Cost Saved': '节省电费',
    'Power Savings': '节省电耗',
    'Pressure Exchanger': '压力交换器',
    'Pressure Exchanger Performance': '压力交换器性能',
    'Pressure Exchanger Power results': '压力交换器功率结果',
    'Pump Efficiency': '泵效率',
    'RO Feed Pressure': 'RO进水压力',
    'RO Permeate Flow': 'RO产水流量',
    'RO Recovery Rate': 'RO 回收率',
    'Specific Power Consumption': '单位产水能耗',
    'Total Power Consumption': '总能耗',
    'Unit': '单位',
    'Unit Flow': '单位流量',
    'VFD Efficiency': '变频器 (VFD) 效率',
    'Values': '值',
    'Work Exchanger': '功交换器',
    'Work Exchanger Performance': '功交换器性能',
    'Work Exchanger Power results': '功交换器功率结果',
  },
  PW: {
    'Are you sure you want to close this form?': '您确定要关闭此页面吗？',
    'Cost of Power': '电费($/kWh)',
    'Electricity Generated (Mechanical Energy Recovered)': '发电量（回收机械能）',
    'Feedwater Salinity': '进水盐浓度',
    'HP Motor Electrical Power': '高压泵电机功率',
    'HP Motor Shaft Power': '高压泵电机轴功率',
    'HP Pump Efficiency': '高压泵效率',
    'HP Pump Motor Efficiency': '高压泵电机效率',
    'HP Pump Shaft Power': '高压泵电机轴功率',
    'Input Parameters': '输入参数',
    'Low P Discharge Pressure': '低压侧出口压力',
    'Membrane Differential Pressure': '膜系统压降',
    'Net Transfer Efficiency': '能量转移效率',
    'OK': '确认',
    'Parameter': '参数',
    'Pelton Wheel': 'Pelton水轮机',
    'Pelton wheel Performance': 'Pelton水轮机性能',
    'Power Cost Saved': '节省电费',
    'Power Savings': '节省能耗',
    'RO Feed Pressure': 'RO进水压力',
    'RO Permeate Flow': 'RO产水流量',
    'RO Recovery Rate': 'RO 回收率',
    'Specific Power Consumption': '单位产水能耗',
    'Total Power Consumption': '总能耗',
    'Turbine Efficiency': '涡轮效率',
    'Unit': '单位',
    'Values': '值',
  },
  TC: {
    'Are you sure you want to close this form?': '您确定要关闭此页面吗？',
    'Boost Pressure': '增压',
    'Cost of Power': '电费 ($/kWh)',
    'Energy Recovered': '回收能量',
    'Feedwater Salinity': '进水盐浓度',
    'HP Power Consumed': '高压泵功率',
    'HP Pump Efficiency': '高压泵效率',
    'HP Pump Motor Efficiency': '高压泵电机效率',
    'Input Parameters': '输入参数',
    'Low P Discharge Pressure': '低压侧出口压力',
    'Membrane Differential Pressure': '膜系统压降',
    'Net Transfer Efficiency': '能量转移效率',
    'OK': '确认',
    'Parameter': '参数',
    'Power Cost Saved': '节省电费',
    'Power Savings': '节能电耗',
    'RO Feed Pressure': 'RO进水压力',
    'RO Permeate Flow': 'RO产水流量',
    'RO Recovery Rate': 'RO 回收率',
    'Specific Power Consumption': '单位产水能耗',
    'Total Power Consumption': '总能耗',
    'Turbo Charger': '涡轮增压器',
    'Turbo Charger Performance': '涡轮增压器性能',
    'Turbo Charger Placement': '涡轮增压器安装位置',
    'Turbo Inlet Pressure': '涡轮增压器入口压力',
    'Turbo Outlet Pressure': '涡轮增压器出口压力',
    'Unit': '单位',
    'Values': '值',
  },
  CIP: {
    'CIP Calculator': 'CIP计算器',
    'CIP Report': 'CIP 报告',
    'Calculator': '计算器',
    'Cleaner Strength': '清洗剂强度',
    'Cleaner Type': '清洗剂类型',
    'Cleaning Step': '清洗步骤',
    'Cleaning Strategies based on Foulant type': '基于污堵类型的清洗策略',
    'Element': '膜元件',
    'Element/Vessel': '单膜壳膜元件数',
    'Foulant Type': '污堵类型',
    'Get Report': '获取报告',
    'Liquid': '液体',
    'Maintenance Clean': '维护性清洗',
    'Membrane Material': '膜材料',
    'NSF Approved': 'NSF认证',
    'No of RO Trains': 'RO套数',
    'No of Stages': '段数',
    'No of Vessels': '膜壳数',
    'Powder': '固体',
    'Print': '打印',
    'Pump Flow rate': '泵流量',
    'Quantity of Cleaner': '清洗剂用量',
    'Registration': '注册认证',
    'Select': '选择',
    'Single Product': '单一药剂',
    'Solution Volume': '溶液体积',
    'Stage': '段数',
    'Stages Cleaned in Parallel': '并联清洗',
    'Stages Cleaned in Series': '串联清洗',
    'Standard': '标准',
    'System Design': '系统设计',
    'Total': '全部的',
    'Vol in CIP piping': 'CIP回路中的体积',
    'Vol in CIP tank': 'CIP水箱中的体积',
    'Text 1 CIP': '化学清洗是一个复杂的过程，需要有关实际污染物的信息来确定最佳的 CIP 策略和要使用的产品。该选择工具中提供的建议是帮助选择产品的一般性指南。',
    'Text 2 CIP': '理想情况下，在化学清洗药剂选择过程中应结合污染物分析。如果无法进行污染物分析，请查阅上面的下拉菜 单并做出有根据的猜测。',
    'Text 3 CIP': '该工具仅允许选择单一污染物。对于复合污染物，请参阅下拉菜单中的“复合污染物推荐“选项。',
    'Text 4 CIP': '对于复杂的情况或如果难以达到预期结果，请联系膜药剂产品应用团队寻求帮助以确定替代选项和产品。',
  },
  Notification_Modal: {
    'Are you sure you want to close this form?': '您确定要关闭此页面吗？',

    'Choose Report Options': '选择报告选项',

    'Custom': '自定义',

    'Default units have been saved successfully.': '默认单位已成功保存。',

    'Display Units': '显示单位',

    'Do you want to clear the canvas?': '您确定要清除画布吗？',

    'Do you want to close the page?': '您确定要关闭此页面吗？',

    'Do you want to delete this unitop?': '您确定要删除此单元吗？',

    'Do you want to save the file?': '您是否要保存文件？',

    'Failed to load Default units.': '无法加载默认单位。',

    'Failed to load win files': '无法加载 win 文件',

    'Feed flow': '进水流量',

    'Flow': '流量',

    'Flowsheet is either empty or incomplete...': '工艺流程为空或不完整',

    'Flowsheet is solved successfully.': '工艺流程已成功求解',

    'Flowsheet solved with errors.': '工艺流程已求解，但有错误',

    'Flowsheet solving has failed.': '工艺流程求解失败',

    'Flux': '通量',

    'Generate PDF': '生成 PDF',

    'Generate Sheets': '生成表格',

    'International': '国际单位制',

    'Ion Composition': '离子成分',

    'Kindly enter valid filename!': '请输入有效的文件名！',

    'Kindly save the file before sharing!': '分享之前请保存该文件！',

    'Load': '加载',

    'Load Winflows 5 file': '加载 Winflows 5 文件',

    'Loading Please wait...': '加载中请稍候…',

    'My Files': '我的文件',

    'No': '否',

    'OK': '确认',

    'Please add/update specify flow values!': '请输入/更新指定流量值',

    'Power': '功率',

    'Pressure': '压力',

    'Product flow': '产水流量',
    'Product Flow': '产水流量',
    'Reminder': '提醒',

    'Saturation Data': '饱和度数据',

    'Save as Default': '保存为默认值',

    'Select file to upload': '选择要上传的文件',

    'Shared By Others': '他人分享的文件',

    'Solver Message': '求解器状态',

    'Specify Flow': '指定流量',

    'Stream Data': '流股数据',

    'Stream Properties': '流股性质',

    'Streams': '流股',

    'System Recovery': '系统回收率',

    'Temperature': '温度',

    'US': '美制',

    'Upload File': '上传文件',

    'Volume': '体积',

    'Yes': '确认',

    'You cannot share empty flowsheet !': '您不能分享空的流程图！',

    'Successfully Done': '成功完成',

    'File saved successfully.': '文件保存成功。',

    'File Share': '文件共享',

    'Subject': '主题',

    'Message': '信息',

    'Share': '分享',

    'Enter all input fields': '输入所有输入字段',

    'Enter any one input field': '输入任一输入字段',

    'Automate Stream ID': '流股自动编号',

    'Quick Results': '结果速览',

    'ARGO Analyzer Report': 'Argo分析报告',

    'Notifications': '通知',

    'Do you want to save the file ?': '您想保存文件吗？',

    'Please select your country from the list given.': '请从给出的列表中选择您所在的国家/地区。',

    'This selection allows Winflows to provide you with region-specific antiscalant options.': '此选择允许 Winflows 为您提供特定区域的阻垢剂选项。',

    'Important: Your country selection is permanent and cannot be changed after submission.': '重要提示：您选择的国 家/地区是永久性的，提交后无法更改。',

    'Failed to load saved win file': '无法加载保存的 win 文件',

    'RO Machine not available': 'RO整机不可用',

    'Entered stream number is duplicated!': '输入的流股编号重复！',

    'Failed to fetch Units': '获取单位失败',

    'Failed to fetch DB transaction record': '读取数据库失败',

    'Failed to fetch feed input.': '无法获取进水输入',

    'File seems empty, please create the flowsheet!': '文件似乎为空，请创建流程图！',

    'Failed to save flow file': '保存文件失败',

    'Failed to fetch file list': '读取文件列表失败',

    'Failed to save feed input.': '无法保存进水表格',

    'Failed to load win-4 files': '加载 Winflows 4.0文件失败',

    'Somthing is wrong.': '出错了',

    'failed to download the file': '下载文件失败',

    'Something went wrong': '出错了',

    'Failed to fetch Flowsheet Selection record': '获取流程选择记录失败',

    'No Data Found': '没有找到数据',

    'Please enter valid filename': '请输入有效的文件名',

    'Please provide a new name for the unitop as the current one is already available on the flowsheet.': '命名重复 ，请重新命名。',

    'connections are incomplete!': '连接不完整！',

    'Unitop inputs are either incomplete or incorrect!': '单元参数输入不完整或不正确！',

    'Only one instance of Argo Analyzer can be used in a flowsheet.': '流程图中只能在一处加Argo 分析器。',
    'Winflows Design Simulator detects multiple feed sources on the current flowsheet. Please input the flow rate for the respective feed source.': 'Winflows 设计模拟器检测当前流程图上的多个源。请输入相应进料源的流量。.',

    'Enter all input field values!': '输入所有输入字段值！',
    'Permeate Flux': '滲透通量',
    'Recovery': '恢復',
    'Explorer': '探險家',
    'Average': '平均的',
    'Element Max': '元素最大',
    'Vessels': '船隻',
    'No. of Elements': '元素數量',
    'Element Type': '元素類型',
    'Conc. Flow': '濃度流動',
    'Perm Flow': '燙髮流',
    'Age': '年齡',
    'Saturation Data(Concentrate)': '飽和度數據（濃縮液）',
    'Last Element Beta': '最後一個元素測試版',
    'Delta Pressure': '壓力差',
    'Avg.': '平均。',
    'Feed TDS': '飼料總固體溶解度',
    'Perm TDS': '彼爾姆 TDS',
    'A-Value ACP': 'A 值 ACP',
    'B-Value ACP': 'B 值 ACP',
    'A-Factor': 'A因素',
    'B-Factor': 'B因素',
    'Element No.': '元件編號',
    'Net Pressure': '淨壓力',
    'Update': '更新',
    'Ionic Composition': '離子成分',
    'Table Setting': '餐桌佈置',
    'Stream Source': '碼流來源',
    'Stream Destination': '串流媒體目的地',
    'Export Table': '匯出表',
    'Session has expired. Please login!': '会话已过期。请登录',
    'Your session will expire in 10 minutes. Please save your work and login again.': '您的会话将在 10 分钟后过期。请保存您的工作并重新登录。',
    'Session Expiry Warning': '會話到期警告'
  },
  Help_Modal_Form: {

    '* or multiple of it': '* 或其倍数',

    'About': '关于',

    'Database Date': '数据库日期',

    'Database Version': '数据库版本',

    'Design Guidelines': '设计指南',

    'Determine approximate number of RO elements': '确定RO膜元件的大致数量',

    'Determine array.': '确定膜堆排列',

    'Determine number of element housings.': '确定膜壳数量',

    'Determine which RO elements to use.': '确定膜元件类型',

    'Housings in 1': '一段膜壳数',

    'OK': '确认',

    'Permeate Recovery, %': '回收率，%',

    'Program Date': '程序更新日期',

    'Run Winflows 5 with the 24-12 array and look for': '使用 24-12 膜堆排列运行 Winflows 5 并查找',

    'stage': '段',

    'Text1': '以下说明是设计简单RO系统的指南，其中流量足够大以使用不少于18支膜元件，且进水渗透压足够低以满足回收大于65%。在该案例中，任务是设计一套RO系统满足系统回收率80%、产水量满足1.5×10',

    'Text10': '产水通量（Winflows 5资源管理器中）分布不均衡（末支膜元件通量最好是达到首支膜元件一半以上通量）。可能 需要增设段间增压泵或产水压力以平衡各段通量。',

    'Text2': 'gpd、TDS自2000mg/L（深井水）降至200mg/L。',

    'Text3': '8寸膜元件已选定。通常的尺寸有365, 400和440平方英尺',

    'Text4': '有效膜面积差异。通常，有效膜面积越大，进水隔网越窄，膜元件污染倾向越严重。在该案例中，进水是低污染倾向的深井水，因此选择400平方英尺的膜元件。',

    'Text5': '选择合适的平均通量，如参考设计指南中给出的示例。在该案例中，进水为很低污染倾向的深井水，因此通量选择了15GFD',

    'Text6': '根据产水量(Fp)、平均通量(Jw)和单支膜面积(AA)计算所需膜支数(N)',

    'Text7': 'Fp = N×AA×Jw，在该案例中，所需膜总数量N = 251支。',

    'Text8': '通常单膜壳膜元件数为6或7支（称6芯或7芯）。该案例中，选择7芯，故共需要36支膜壳。',

    'Text9': '在该应用场景下，通常80%回收率的系统采用两段膜排列即可，意味着大概2/3膜壳在一段中，因此选择24-12排列。',

    'The below table is used to determine how to approximately arrange the housings.': '下表用于确定如何大致排列膜壳。',

    'The predicted permeate TDS should be below the maximum allowed.': '预测产水TDS值应该低于最大允许值。',

    'The pressure drop over the elements': '膜元件压降',

    'Tips on Designing RO Units Operating on Natural Waters with Below 5000 mg/L TDS': 'TDS低于5000 mg/L的自然水RO系统设计技巧',

    'Typical array*': '典型膜堆排列',

    'Warnings': '警告',

    'Winflows 5 RO Elements Design Guidelines': 'Winflow 5 RO膜系统设计指南',

  },
  Preface: {
    'Winflows': 'Winflows',
    'Design Simulator': '设计模拟器',
    'Winflows Design Simulator': 'Winflows设计模拟器',
    'Projection Report': '计算书报告',
    'WATER TECHNOLOGIES': '水处理技术',
    'Project Info': '项目信息',
    'Project Name': '项目名称',
    'Customer Name': '客户名称',
    'Engineer': '设计者',
    'Location': '地点',
    'Mail ID': '电子邮件',
    'Phone No': '电话',
    'Specify Flow Option': '进水流量',
    'Notes': '备注',
    'Notifications': '通知',
    'None detected in the current design': '当前设计中未检测到任何问题',
    'Trademark of Veolia': '*Veolia 的商标；可能在一个或多个国家注册。2025 Veolia 版权所有',
    'Database': '数据库',
    'Description': '描述',
    'Unit Op': '单元操作',
    'Total Number of Errors': '错误总数',
    'Total Number of Warnings': '警告总数',
    'Disclaimer_text': '免责声明：该模拟计算只是作为一项免费服务提供给客户，不含任何性能质保。',
  },
  Flowsheet_Design_Summary: {
    'Flowsheet Design Summary': '流程图设计总结',
    'Flowsheet Design': '流程图设计',
    'Stream Property Summary': '流股 性质总结',
    'Stream Id': '流股 编号',
    'Alkalinity, ppm CaCO3': '碱度, ppm CaCO3',
    'Hardness, ppm as CaCO3': '硬度, ppm as CaCO3',
    'Alkalinity': '碱度',
    'Hardness': '硬度',
    'Conductivity at 25°C': '电导率(25°C)',
    'FSD Flow Balance': 'FSD 流量平衡',
    'Unit ID (Stream no.)': '单元编号（流股编号）',
    'Overall Flow Sheet Recovery': '总流程-回收率',
    'Flow - Total': '流量 - 总计',
    'Incoming': '来水',
    'Outgoing': '出水',
    'Product': '产水',
    'Waste': '浓水',
    'ID': '编号',
    'Conc.': '浓水',
    'Bleed': '排放',
    'Desalination_Demineralization': '膜分离器单元级汇总',
  },
  Feed_Product_Waste_Summary: {
    'Feed-Product-Waste Summary': '进水-产水-浓水 数据汇总',

    'Overall Flowsheet Recovery': '总流程-回收率',

    'Category ': '类别',

    'Information': '信息',

    'Ion Concentration': '离子浓度',

    'Stream Property': '流股性质',

    'Water Source': '水源类型',

    'Ionic Strength': '离子强度',

    'Osm.Pressure': '渗透压',
    'Softened Water': '软化水',
    'Pump Unit Summary': '泵组概要'
  },
  RO_NF_Unit_System_Level_Summary: {
    'RO/NF Unit System-Level Summary': 'RO/NF单元 系统参数汇总',
    'Docked Summary': '摘要',
    'Total Number of RO/NF Unit': 'RO/NF 单元总数',
    'RO/NF Unit ID': 'RO/NF 单元编号',
    'Upstream unit': '上游单元',
    'Downstream unit': '下游单元',
    'Permeate Flow': '产水流量',
    'Concentrate Flow': '浓水流量',
    'RO/NF Unit Recovery': 'RO/NF 单元回收率',
    'Breakdown by Stage': '分段平均通量',
    'Total Membrane Area': '总膜面积',
    'Feed Temperature': '进水温度',
    'Interstage Pressure': '段间压力',
    'Product Pressure *': '产水压力',
    'Feed pH': '进水 pH',
    'Permeate TDS': '产水 TDS',
    'Concentrate TDS': '浓水 TDS',
    'Concentrate pH': '浓水 pH',
    'Detailed Design': '详细设计',
    'Array Design': '膜堆排列 设计参数',
    'Housing': '膜壳数',
    'Elements': '膜元件数(单个膜壳 )',
    'Element Age(yr)': '膜元件使用年限（年）',
    'Pressure Change': '压力变化',
    'Boost': '段间增压',
    'Loss': '段间(额外)损失',
    'Permeate P': '产水压力',
    'A-Value ACP': 'A值 每年衰减率(%)',
    'A-Factor': 'A值系数',
    'B-Value ACP': 'B值 每年衰减率(%)',
    'B-Factor': 'B值系数',
  },
  RO_NF_Unit_Stage_Level_Summary: {
    'RO/NF Unit Stage-Level Summary': 'RO/NF单元_各段_数据汇总',
    'Element Type': '元件类型',
    'Perm': '产水',
    'dP': '压降',
  },
  DSSRO_Section_Summary: {
    'DSSRO Section Summary': 'DSSRO 部分汇总',
    'DSSRO Overview': 'DSSRO 概述',
    'Overview': '概述',
    'DSSRO mode': 'DSSRO 模式',
    'CLRO': 'CLRO',
    'Elements per PV': '每个 膜壳 的元件数',
    'Spacers per PV': '每个 膜壳 的隔片数',
    'Length of PV': '膜壳 长度',
    'CL Recovery': 'CL 回收率',
    'BP Recovery': 'BP 回收率',
    'CL Concentrate Flow': 'CL 浓水流量',
    'BP Concentrate Flow': 'BP 浓水流量',
    'CL Net Feed Flow': 'CL 净进水流量',
    'BP Feed Flow': 'BP 进水流量',
    'CL Permeate Flow': 'CL 产水流量',
    'Total Circuits': '总回路数',
    'BP Sequence Duration': 'BP 序列持续时间',
    'CL Sequence Duration': 'CL 序列持续时间',
    'Complete Cycle Duration': '完整循环持续时间',
    'CL System Volume': 'CL 系统体积',
    'S1 Volume': 'S1 体积',
    'S2 Volume': 'S2 体积',
    'S3 Volume': 'S3 体积',
    'DSSRO Flow Summary (Element Level)': 'DSSRO 流量汇总（膜元件级）',
    'Flow Summary': '流量汇总',
    'Circuit': '回路',
    'Element': '元件',
    'Feed Press': '进水压力',
    'Conc Flow': '浓水流量',
    'CL 1': 'CL 1',
    'CL Final': 'CL 最终',
    'DSSRO Stream Composition': 'DSSRO 流股组成',
    'Concentrations': '浓度',
    'Concentrations (mg/L as ion)': '浓度（mg/L）',
    'Concentrate': '浓水',
    'Permeate': '产水',
    'Composition': '组成',
    'Schematic': '示意图',
    'Production Loop': '产水回路',
    'High Pressure Centrifugal Pump (P2)': '高压离心泵 (P2)',
    'Raw Feed Flow': '原水进水流量',
    'Feed Pump (P1)': '进水泵 (P1)',
    'RO Feed': 'RO 进水',
    'Cartridge Filter': '滤芯过滤器',
    'Feed Pressure': '进水压力',
    'Delta Pressure': '压差',
    'Circulation pump (P3)': '循环泵 (P3)',
    'CL Conc Flow': 'CL 浓水流量',
    'CL Perm Flow': 'CL 产水流量',
    'Brine Purge': '排盐',
    'Conc Recirculation Flow': '浓水回流流量',
    'BP Conc Flow': 'BP 浓水流量',
    'Brine Disposal': '盐水排放',
    'DSSRO Loop Summary': 'DSSRO循环摘要',
    'Loop No': '循环回路编号',
    'Permeate Stream (Loop wise) Summary': '产水流股（按循环）摘要',
    'Concentrate Stream (Loop wise) Summary': '浓水流股（按循环）摘要',
  },
  Pump_Summary: {
    'Pump Summary': '水泵汇总',
    'Total Number of Pumps': '水泵总数',
    'Pump Unit ID': '水泵单元编号',
    'RO/NF Unit Attached': 'RO/NF单元名称',
    'Combined Efficiency': '总效率',
    'Total Power Consumption': '总功率 (kW)',
  },
  Detailed_Stream_Data: {
    'Detailed Stream Data': '更详细的流股数据',
    'LSI': 'LSI',
    'SDSI': 'SDSI',
    'Concentrate': '浓水',
    'Inlet': '入口',
    'Downstream Permeate': '下游 产水',
    'Stream ID': '流股 编号',
  },
  EDI_Unit_System_Level_Summary: {
    'EDI Unit System-Level Summary': 'EDI 单元系统参数汇总',
    'Total Number of EDI Unit': 'EDI 单元总数',
    'EDI Unit ID': 'EDI 单元编号',
    'System Product Flow Rate': '产水流量',
    'Electrode Bleed Flow': '极水流量',
    'EDI Unit Recovery': 'EDI 单元回收率',
    'No. of E-Cell EDI Stacks': 'E-Cell EDI 模块数量',
    'Concentrate Pressure': '浓水压力',
    'Product Outlet Pressure': '产水压力',
    'Voltage': '电压',
    'AC Power': '交流功率',
    'DC Power': '直流功率',
    'Flow Configuration': '运行模式（逆流/顺流）',
    'Counter-Current/Co-Current': '逆流/顺流',
    'Counter-Current': '逆流',
    'Feed TDS': '进水 TDS',
    'Feed pH': '进水 pH',
    'Product Resistivity': '产水电阻率',
    'Product pH': '产水 pH',
    'Concentrate TDS': '浓水 TDS',
    'Concentrate pH': '浓水 pH',
    'Electrode Bleed TDS': '极水 TDS',
    'Electrode Bleed pH': '极水 pH',
    'H2': 'H₂（氢气）',
    'Cl2': 'Cl₂（氯气）',
    'Blower/Ventilation Sizing for H2': '鼓风机/通风设备尺寸-H₂（氢气）',
    'Ventilation Blower/Fan': '鼓风机/通风设备',
    'Size': '尺寸',
    'The Electrode stream must be vented as it contains small quantities of hydrogen, oxygen and possibly chlorine gas (if there is chloride ion in the Electrode stream.)': '极水流须有通风口，因为它含有少量氢气、氧气，若极水流中含有氯离子，则还可能含有微量氯气 。',
    'A 2:1 mixture of hydrogen and oxygen gas is produced at a maximum rate of 11.4 ml/amp/minute/stack (dry gas at 25 °C, 1.0 bar), consisting of 7.6 ml of hydrogen and 3.8 ml of oxygen. Ensure ventilation maintains the hydrogen gas levels below 4%.': '氢气和氧气会以2:1比例混合，混合气体产生的最大速率约为11.4 mL/A/min（干燥气体，温度25℃，1.0 atm），其中氢气 7.6 mL/A/min，氧气 3.8 mL/A/min，须通风良好确保 氢气含量低于4%。',
    'EDI Design Parameters': 'EDI 设计参数',
    'Product Flow Rate per Stack': '单模块产水量',
    'Upstream Interconnecting Piping': '上有连接管路',
    'Pressure Loss': '压力损失',
    'TEA': 'TEA（总可交换阴离子量）',
    'TEC': 'TEC（总可交换阳离子量）',
    'Silica': '二氧化硅（硅）',
    'Conductvity': '电导率',
    'Product Silica guarantee leve': '产水二氧化硅保证值',
    'Predicted Product Silica Level': '预测产水二氧化硅含量',
    'Predicted Product Sodium level': '预测产水钠含量',
    'Predicted Product Chloride level': '预测产水氯离子含量',
    'Predicted Product Sulfate level': '预测产水硫酸根含量',
    'Maximum Allowable Recovery': '最大允许回收率',
    'AC power consumption': '交流功率',
    'AC energy': '吨产水交流能耗',
    'Predicted Product outlet pressure': '预测产水压力',
    'Feed Inlet': '进水流量',
    'Concentrate Outlet': '浓水出水流量',
    'Electrode Bleed': '极水流量',
    'EDI Schematic': 'EDI 示意图',
    'Current/Stack': '电流/模块',
    'Stack Voltage': '模块电压',
    'Energy Consumption': '能耗',
    'Maximum Recovery': '最大回收率',
    'Max. Conc. outlet pressure': '浓水出水最大压力',
    'Conc. Bleed flow': '浓水出水流量',
    'Product pressure': '产水压力',
    'Max. Conc. inlet pressure': '浓水进水最大压力',
    'Max. Electrode Bleed Pressure': '极水最大压力',
    'Dilute': '淡水室',
    'Concentrate': '浓水室',
    'Electrode': '极水室',
  },
  CF_Unit_Summary: {
    'CF Unit Summary': '过滤器单元汇总',
    'Total Number of CF Unit': '过滤器单元总数',
    'CF Unit ID': '过滤器单元编号',
    'Flow Capacity': '流量',
    'Filter Type': '滤芯类型',
    'Design Flow Per TIE': '设计流量（10英寸当量）',
    'Outlet Pressure': '出口压力',
    'Pressure Drop': '压降',
  },
  Chemical_Dosing_Unit_Summary: {
    'Chemical Dosing Unit Summary': '化学加药单元摘要',
    'Total Number of Chemical Dosing': '化学加药总数',
    'Dosing Endpoint': '加药终点',
    'Target Value': '目标值',
    'Concentration as Metered': '实际计量浓度',
    'Specific Gravity as Metered': '实际计量比重',
    'Metered Flow Rate': '实际计量流速',
    'Avg Cons.As Metered': '平均消耗(按计量)',
    'Avg Cons.As Supplied': '平均消耗(按供应)',
    'Avg Cons.As Supplied with SF': '平均消耗(按供应,带安全系数）',
    'Sulfuric Acid': '硫酸',
    'Hydrochloric Acid': '盐酸',
    'Phosphoric Acid': '磷酸',
    'Nitric Acid': '硝酸',
    'Carbon Dioxide': '二氧化碳',
    'Ammonia': '氨',
    'Caustic Soda': '烧碱',
    'Slaked Lime': '熟石灰',
    'Sodium Carbonate': '碳酸钠',
    'Calclium Carbonate': '碳酸钙',
    'Sodium Sulfate': '硫酸钠',
    'Sodium Cycle Softener': '钠循环软化剂',
    'Target pH': '目标 pH',
    'Total Number of Chemical Type': '化学品种类汇总',
    'Aggregated by Chemical Type – Supplied Form': '按化学品种类汇总-供应形式',
    'Chemical Type': '化学品种类',
    'Chemical Dosing Unit ID': '化学加药单元编号',
    'Concentration as Supplied': '供应浓度',
    'Specific Gravity as Supplied': '供应比重',
    'Total Consumption': '总消耗量',
    'As Supplied': '按供应形式',
    'As Supplied with SF': '按供应形式（带安全系数）',
  },
  Antiscalant_Dosage_Summary: {
    'Antiscalant Dosage Summary': '阻垢剂投加汇总',
    'Dosed In ': '投加点',
    'Antiscalant': '阻垢剂',
    'Dosage in Feed': '进水 加药量',
  },
  ERD_Unit_Summary: {
    'ERD Unit Summary (WIP)': 'ERD 单元汇总',
    'Total Number of ERD Unit': 'ERD 单元总数',
    'ERD Unit ID': 'ERD 单元编号',
    'ERD Type': 'ERD 类型',
    'RO/NF Unit Attached': 'RO/NF单元',
    'Installed Location': '安装位置',
    'LP Discharge Pressure': '低压侧排放压力',
    'Net Transfer Efficiency': '净传递效率',
    'Boost Pressure': '增压压力',
    'Leakage (Reject in HP OUT)': '泄漏率',
    'Mixing at Membrane Feed': '进膜侧混合比例',
    'Total Power Consumption': '总功耗',
    'HP Pump': '高压泵',
    'Circulation Pump': '循环泵',
    'Energy Recovered': '回收能量',
    'Power Saving': '能耗节省',
    'Work Exchanger (WX)': '功交换器 (WX)',
  },
  Mixer_Splitter_Unit_Summary: {
    'Mixer-Splitter Unit Summary': '混合-分流器 单元汇总',
    'Total Number of Mixer-Splitter': '混合-分流器 总数',
    'Mixer-Splitter Unit ID': '混合-分流器 单元编号',
    'Inlet Stream ID': '流入 流股 编号',
    'Outlet Stream ID': '流出 流股 编号',
    'Mode': '模式',
    'Mix Ratios': '混合比例',
    'Split Ratios': '分流比例',
    'calculated': '计算得出',
    'user input': '用户输入',
    'Mix only': '仅混合',
    'Split only': '仅分流',
  },
  Detailed_RO_NF_Element_Level_Data: {
    'Detailed RO/NF Element-Level Data': '更详细的膜元件数据',
    'Parameter': '参数',
    'Stage No': '段编号',
    'Element Pos.': '膜元件位置',
    'Other': '其他',
    'Stream Property': '流股 性质',
    'Permeate Ion Concentration': '产水离子浓度',
    'Net Driving': '净驱动压',
    'Delta Pressure': '压差',
  },
  Winflows_Design_Simulator_Program_Details: {
    'Winflows Design Simulator Program Details': 'Winflows设计模拟器 详细信息',
    'Program Version': '程序版本',
    'Program Last Update': '程序更新日期',
    'Database Last Update': '数据库更新日期',
    'Contact for Technical Support': '请联系我们_以获取更多技术支持',
  },
  Stripper_Unit_Summary: {
    'Stripper Unit Summary': '脱气单元摘要',
    'Total Number of Stripper': '脱气器总数',
    'Outlet CO2 Concentration': '出口二氧化碳浓度',
    'Stripper Unit ID': '脱气单元编号',
    'Outlet H2S Concentration': '出口硫化氢浓度',
    'Outlet NH3 Concentration': '出口氨浓度'
  },
  Notification: {
    'FATAL ERROR!! Transmembrane Pressure Limit Exceeded! in ROHP_1 of Stage 1 of element 1 at given temperature.\n\nPlease change design!\nThe applied feed pressure exceeds the limit recommended for at least one of the elements selected. Operation above the maximum pressure can result in element damage, specifically, collapsed permeate channels, which will result in loss of element permeate productivity. \nExcessive pressure can also cause central tube collapse and subsequent element failure. To reduce the operating pressure for the system 1) increase the number of elements in the system, 2) reduce the system recovery, 3) increase the system feed temperature.': '致命错误！跨膜压力超出限制！ 在 ROHP_1 的第 1 阶段第 1 元件处于给定温度下。\n\n请更改设计！\n施加的进水压力超过了所选元件的推荐上限。超过最大压力可能导致元件损坏，尤其是渗透通道塌陷，从而导致产水能力下降。\n过高的压力还可能导致中心管塌陷和元件失效。为降低系统运行压力：\n1）增加系统中的元件数量，\n2）降低系统回收率，\n3）提高系统进水温度。'
  }
};
export const Spanish = {
  Feed: {
    'Alkalinity & ph': 'Alcalinidad y pH',
    'Alkalinity is 0 when pH is below or equal to 4.5': 'La alcalinidad es 0 cuando el ph es inferior o igual a 4,5',
    'Anion': 'Anión',
    'Balance': 'Balance',
    'Bicarbonate & pH': 'Bicarbonato y pH',
    'Brackish Surfacewater (Conventional)': 'Agua Superficial Salobre (Convencional)',
    'Brackish Surfacewater (MF/UF)': 'Agua Superficial Salobre (MF/UF)',
    'Brackish Water': 'Agua salobre',
    'Brackish Wellwater': 'Agua de pozo salobre',
    'CO2 & Bicarbonate': 'CO2 y bicarbonato',
    'Cancel': 'Cancelar',
    'Cation': 'Catión',
    'Charge Balance': 'Saldo de carga',
    'Clear Values': 'Borrar valores',
    'Conductivity': 'Conductividad',
    'Density': 'Densidad',
    'Density, kg/m3': 'Densidad, kg/m3',
    'Do you want clear all the values for the composition': '¿Quieres borrar todos los valores de la composición?',
    'Do you want close the Feed input page': '¿Quieres cerrar la página de entrada de feeds?',
    'EDI': 'EDI',
    'Failed to fetch default units': 'No se pudieron recuperar las unidades predeterminadas',
    'Feed': 'Alimentar',
    'Feed Compositions must be a positive number': 'Las composiciones de piensos deben ser un número positivo.',
    'Feed Water Analysis': 'Análisis del agua de alimentación',
    'High ph RO 2nd pass': 'RO de ph alto 2do paso',
    'High ph RO (city/well)': 'RO de alto ph (ciudad/pozo)',
    'High ph RO Wastewater': 'Aguas residuales RO de alto pH',
    'Input': 'Aporte',
    'MBR Permeate': 'Permeado MBR',
    'OK': 'DE ACUERDO',
    'OR': 'O',
    'Osmotic Pressure': 'Presión osmótica',
    'Parameters': 'Parámetros',
    'Parameters should not be empty': 'Los parámetros no deben estar vacíos.',
    'Please enter water composition': 'Por favor introduzca las composiciones de agua.',
    'Pressure': 'Presión',
    'Pressure should not be empty': 'La presión no debe estar vacía.',
    'RO Permeate': 'Permeado RO',
    'Saturation Data (Feed water)': 'Datos de saturación (agua de alimentación)',
    'Sea Water': 'Agua de mar',
    'Sea Wellwater': 'Agua de pozo de mar',
    'Select Ion for Charge Balance': 'Seleccione Ion para el saldo de carga',
    'Select Water Source': 'Seleccionar fuente de agua',
    'Select Water Type': 'Seleccione el tipo de agua',
    'Sour Water': 'Agua Amarga',
    'Stiff-Davis Index': 'Índice Stiff-Davis',
    'Struvite': 'estruvita',
    'Supply Pressure': 'Presión de suministro',
    'Surface Seawater (Conventional)': 'Agua de mar superficial (convencional)',
    'Surface Seawater (MF/UF)': 'Agua de mar superficial (MF/UF)',
    'Surface Water': 'Superficie del agua',
    'Sweet Water': 'Agua dulce',
    'Temperature': 'Temperatura',
    'Tertiary Treated Wastewater (Conventional)': 'Aguas Residuales con Tratamiento Terciario (Convencional)',
    'Tertiary Treated Wastewater (MF/UF)': 'Aguas Residuales con Tratamiento Terciario (MF/UF)',
    'Total Alkalinity (ppm CaCO3)': 'Alcalinidad total (ppm CaCO3)',
    'Total Alkalinity is required': 'Se requiere alcalinidad total',
    'Total Anions': 'Aniones totales',
    'Total Cations': 'Cationes totales',
    'Total Organic Carbon': 'Carbono organico total',
    'Upload Water Analysis': 'Cargar Análisis de Agua',
    'User Defined': 'Usuario definido',
    'Well Water': 'agua de pozo',
    'pH should not be between 0-14': 'El pH no debe estar entre 0-14',
  },
  EDI: {
    '# of E-Cell EDI Stacks': '# de pilas EDI de E-Cell',
    'AC Energy (kWh/ m3)': 'Energía CA (kWh/m3)',
    'AC Power Consumption (kW)': 'Consumo de energía CA (kW)',
    'Apply': 'Aplicar',
    'Are you sure you want to close this form?': '¿Estás seguro de que deseas cerrar este formulario?',
    'Blower/Ventilation Sizing for Cl': 'Dimensionamiento del soplador/ventilación para Cl',
    'Blower/Ventilation Sizing for Cl2': 'Dimensionamiento del soplador/ventilación para Cl2',
    'Blower/Ventilation Sizing for H': 'Dimensionamiento del soplador/ventilación para H',
    'Calculated Output Parameters': 'Parámetros de salida calculados',
    'Cancel': 'Cancelar',
    'Co-Current': 'Co-corriente',
    'Concentrate Bleed (m3/h)': 'Purga de concentrado (m3/h)',
    'Current (Amps)': 'Corriente (amperios)',
    'DC power (kW)': 'Potencia CC (kW)',
    'Design': 'Diseño',
    'Design Safety Factor': 'Factor de seguridad de diseño',
    'E-Factor': 'Factor E',
    'Effluent Silica Gaurantee (3 Series)': 'Garantía de sílice efluente (Serie 3, 5)',
    'Effluent Silica Gaurantee (7 Series)': 'Garantía de sílice efluente (Serie 9)',
    'Electrode Bleed': 'Purga del electrodo',
    'Electrode Bleed (m3/h)': 'Purga del electrodo (m3/h)',
    'Electrode Gas Generation': 'Generación de gas para electrodos',
    'Expected': 'Esperado',
    'Explosion Limit of H2 in Air': 'Límite de explosión del H2 en el aire',
    'Explosion limit of H2 in Air': 'Límite de explosión del H2 en el aire',
    'Exposure Limit of Cl2 in Air': 'Límite de exposición de Cl2 en el aire',
    'Feed Guarantee Guide': 'Guía de alimentación y garantía',
    'Feed Inlet (m3/h)': 'Entrada de alimentación (m3/h)',
    'Feed Pressure (bar)': 'Presión de alimentación (bar)',
    'Feed TEA Limitations for Resistivity Gaurantee': 'Limitaciones de alimentación de TEA para garantía de resistividad',
    'Feed Water Specification': 'Especificación del agua de alimentación',
    'Feedwater Parameters': 'Parámetros de salida del agua de alimentación',
    'Flow Per Stack': 'Flujo por pila',
    'Gas': 'Gas',
    'Input': 'Aporte',
    'Maximum': 'Máximo',
    'Maximum Allowable Recovery (%)': 'Recuperación máxima permitida (%)',
    'Note': 'Nota',
    'OK': 'DE ACUERDO',
    'Output': 'Producción',
    'Please enter the required fields': 'Por favor introduzca los campos requeridos',
    'Please enter the values within range': 'Por favor ingrese los valores dentro del rango',
    'Predicted Boron Product (ppb B)': 'Producto de boro previsto (ppb B)',
    'Predicted Product Outlet Pressure (bar)': 'Presión de salida del producto prevista (bar)',
    'Predicted Product Silica Level (ppb SiO2)': 'Producto de sílice previsto (ppb SiO2)',
    'Predicted Product Chloride Level (ppb Cl)': 'Producto Nivel de garantía de cloruro (ppb Cl)',
    'Product Flow Rate': 'Caudal del producto',
    'Product Resistivity (MΩ.cm)': 'Resistividad del producto (MΩ.cm)',
    'Product Silica Guarantee Level (ppb SiO2)': 'Nivel de garantía de sílice del producto (ppb SiO2)',
    'Predicted Product Sodium Level (ppb Na)': 'Nivel de garantía de sodio del producto (ppb Na)',
    'Predicted Product Sulfate Level (ppb SO4)': 'Nivel de Garantía de Sulfato del Producto (ppb SO4)',
    'Range': 'Rango',
    'Rectifier DC Output (Volts)': 'Salida CC del rectificador (Volts)',
    'Rectifier DC Output': 'Salida CC del rectificador',
    'Rectifier DC output': 'Salida CC del rectificador',
    'Rectifier Efficiency %': 'Eficiencia del rectificador %',
    'Rectifier Efficiency': 'Eficiencia del rectificador',
    'Rectifier efficiency': 'Eficiencia del rectificador',
    'Select': 'Seleccionar',
    'Stack Model': 'Modelo de pila',
    'Status': 'Estado',
    'System Parameters': 'Parámetros de salida del sistema',
    'Target Resistivity (MΩ.cm)': 'Resistividad objetivo (MΩ.cm)',
    'Target Resistivity': 'Resistividad objetivo',
    'Target Silica Gaurantee (ppb SiO2)': 'Garantía de sílice objetivo (ppb SiO2)',
    'Target Silica Gaurantee': 'Garantía de sílice objetivo',
    'Target Silica guarantee': 'Garantía de sílice objetivo',
    'Units': 'Unidades',
    'Value': 'Valor',
    'Ventilation Blower/Fan Size': 'Tamaño del ventilador/ventilador',
    'Ventilation Sizing': 'Dimensionamiento de la ventilación',
    'Voltage (Volts)': 'Voltaje (voltios)',
    'Upstream Interconnecting Piping Pressure Loss': 'Pérdida de presión en tuberías de interconexión aguas arriba',
    'RO permeate pressure must be at least 0.34 bar | 5 psi higher than E-Cell feed pressure to account for pressure loss in piping between RO permeate and E-Cell feed': 'La presión del permeado de RO debe ser al menos 0,34 bar | 5 psi más alta que la presión de alimentación de la celda E para tener en cuenta la pérdida de presión en las tuberías entre el permeado de RO y la alimentación de la celda E.',
    'System Product Flow': 'Flujo de producto del sistema',
    'Conductivity (µS/cm @ 25°C)': 'Conductividad (µS/cm a 25 °C)'
  },
  RO: {
    'Recovery (%)': 'Recuperación (%)',
    'Add New Row': 'Agregar nueva fila',
    '0.5 Means that the elements only gives half the permeate flow rate as of the nominal element': '0,5 Significa que los elementos solo dan la mitad del caudal de permeado que el elemento nominal.',
    '1.5 means that the salt passage is 1.5 times higher than that of the nominal element': '1,5 significa que el paso de sal es 1,5 veces mayor que el del elemento nominal',
    'A-Value Factor': 'Factor de valor A',
    'Activate Argo Analyzer': 'Activar el analizador Argo',
    'Aluminium in Conc (ppm)': 'Aluminio en concentración (ppm)',
    'Antiscalant Dosage': 'Dosis de antiincrustante',
    'Application': 'Solicitud',
    'Apply': 'Aplicar',
    'Area': 'Área',
    'Argo Analyzer': 'Analizador Argo',
    'Array Recovery': 'Recuperación de matriz',
    'Average Flux': 'Flujo promedio',
    'B-Value Factor': 'Factor de valor B',
    'Boost Energy Efficiency %': 'Impulsar el % de eficiencia energética',
    'Boost Energy Efficiency % must be in the range 10-100': 'El porcentaje de aumento de eficiencia energética debe estar en el rango de 10 a 100',
    'CLRO Parameters': 'Parámetros CLRO',
    'Cancel': 'Cancelar',
    'Compare': 'Comparar',
    'Concentrate composition calculated by Winflows': 'Composición del concentrado calculada por Winflows',
    'Copy RO Machine Configuration': 'Copiar la configuración de la máquina RO',
    'Design Guidelines': 'Guía de diseño',
    'Do you want to close the RO input page?': '¿Quiere cerrar la página de entrada de RO?',
    'Element Age (yr)': 'Edad del elemento (años)',
    'Element Age (yr) must be in the range 0-10': 'La edad del elemento (año) debe estar en el rango de 0 a 10',
    'Element Age Calculator': 'Calculadora de edad del elemento',
    'Element Group': 'Grupo de elementos',
    'Element Info': 'Información del elemento',
    'Element Model': 'Modelo de elementos',
    'Elements per Vessel': 'Elementos por Vaso',
    'Elements per Vessel must be in the range 0-8': 'Los elementos por recipiente deben estar en el rango 0-8',
    'Enter valid data in Pressure Vessels, Elements Per Vessel and Element Type': 'Ingrese datos válidos en Recipientes a presión, Elementos por recipiente y Tipo de elemento',
    'Feed Pressure': 'Presión de alimentación',
    'Flux Annual % Change': 'Cambio % anual de flujo',
    'Input A Value Factor & B Value Factor': 'Ingrese el factor de valor A y el factor de valor B',
    'InterStage Boost Pressure': 'Presión de refuerzo entre etapas',
    'InterStage Pressure Loss': 'Pérdida de presión entre etapas',
    'InterStage Pressure Loss must be in the range': 'La pérdida de presión entre etapas debe estar en el rango',
    'Max Pressure': 'Presión máxima',
    'No options': 'Sin opciones',
    'Nominal Flow': 'Flujo Nominal',
    'OK': 'DE ACUERDO',
    'OutPut': 'Producción',
    'Permeate Flow Rate': 'Tasa de flujo de permeado',
    'Permeate Pressure': 'Presión de permeado',
    'Permeate Pressure must be in the range': 'La presión del permeado debe estar en el rango',
    'Please populate the previous row(s) !': '¡Rellene las filas anteriores!',
    'Pressure Vessels': 'Recipientes a presión',
    'Pressure Vessels must be in the range 0-999': 'Los recipientes a presión deben estar en el rango 0-999',
    'Pressure drop during brine purge': 'Caída de presión durante la purga de salmuera',
    'Product TDS': 'TDS del producto',
    'RO Element Data': 'Datos del elemento RO',
    'RO Parameters': 'Parámetros de RO',
    'RO Permeate': 'Permeado RO',
    'RO Recovery': 'Recuperación de RO',
    'RO Recovery, %': 'Recuperación de RO, %',
    'Recovery Per Circuit must be in the range 0-100%': 'La recuperación por circuito debe estar en el rango 0-100%',
    'Recovery must be in the range 0-100%': 'La recuperación debe estar en el rango 0-100%',
    'Recovery per circuit': 'Recuperación por circuito',
    'Recycle Permeate from Last Stage to Feed Pump': 'Recicle el permeado de la última etapa a la bomba de alimentación',
    'Rejection': 'Rechazo',
    'Results': 'Resultados',
    'Salt Passage Annual % Change': 'Cambio % anual del paso de sal',
    'Saturation Indices': 'Índices de saturación',
    'Select Hypersperse Products': 'Seleccione productos hiperdispersos',
    'Select Region': 'Seleccione región',
    'Spacer per Vessel must be in the range 0-8': 'El espaciador por recipiente debe estar en el rango 0-8',
    'Spacers per Vessel': 'Espaciadores por recipiente',
    'Spec File is not available for this Element.': 'El archivo de especificaciones no está disponible para este elemento.',
    'Split Permeate (Upstream Part)': 'Permeado dividido (parte aguas arriba)',
    'Stage': 'Escenario',
    'Sum of Element per Vessel & Spacers per Vessel must be <= 8': 'La suma de elementos por recipiente y espaciadores por recipiente debe ser <= 8',
    'Test': 'Prueba',
    'Test Pressure': 'Presión de prueba',
    'Total holdup Volume': 'Volumen total de atraco',
    'Type': 'Tipo',
    'Use Element Age and Annual % Change': 'Utilice la edad del elemento y el porcentaje de cambio anual',
    'Winflows Design Simulator RO Elements Design Guidelines': 'Pautas de diseño de elementos RO del simulador de diseño de Winflows',
    'Winflows RO Elements Design Guidelines': 'Pautas de diseño de elementos RO de Winflows',
    'by': 'por',
    'Winflows Report': 'Informe de flujo de Winflows',
    'Generate': 'Generar',
    'RO Permeate flow': 'Flujo de permeado RO',
    'RO Recovery rate': 'Tasa de recuperación de RO',
    'Recovery during brine purge': 'Recuperación durante la purga de salmuera',
    'Feed Flow (per PV) during brine purge': 'Flujo de alimentación (por PV) durante la purga de salmuera',
    'Recovery during brine purge should be between 0 – 20': 'La recuperación durante la purga de salmuera debe estar entre 0 y 20'
  },
  Header: {
    'About': 'Acerca de',
    'Design Guidelines': 'Guía de diseño',
    'Element Cross Reference List': 'Lista de referencias cruzadas de elementos',
    'Give File Name': 'Dar nombre de archivo',
    'Help': 'Ayuda',
    'Language': 'Idioma',
    'RO Design Guidelines Tips': 'Consejos para las pautas de diseño de RO',
  },
  Landing: {
    '# of Elements': '# de elementos',
    'All': 'Todo',
    'Application': 'Solicitud',
    'Application Wizard': 'Asistente de aplicaciones',
    'Apply': 'Aplicar',
    'Archive': 'Archivo',
    'Are you sure you want to delete it?': '¿Estás segura de que quieres eliminarlo?',
    'Array': 'Formación',
    'Choose any one parameter': 'Elija cualquier parámetro',
    'Choose any RO Machine to Display the Data': 'Elija cualquier máquina RO para mostrar los datos',
    'Select Equipment Model': 'Seleccionar modelo de equipo',
    'Clear All': 'Limpiar todo',
    'Created On': 'Creado en',
    'Current': 'Actual',
    'Design Flowsheet': 'Diagrama de flujo de diseño',
    'Element Model': 'Modelo de elemento',
    'Enter name to Search': 'Ingrese el nombre para buscar',
    'Error while deleting file': 'Error al eliminar el archivo',
    'FactSheet': 'Hoja de hechos',
    'Failed to fetch Ro Machine record': 'No se pudo recuperar el registro de Ro Machine',
    'Feed Flow': 'Flujo de alimentación',
    'Feed Water': 'Agua de alimentación',
    'File deleted succesfully': 'Archivo eliminado con éxito',
    'File Name': 'Nombre del archivo',
    'File shared successfully!.': '¡Archivo compartido exitosamente!.',
    'Flow Sheet Details': 'Detalles del diagrama de flujo',
    'Flow Sheet Type': 'Tipo de diagrama de flujo',
    'Flux': 'Flujo',
    'Integrated RO-EDI': 'RO-EDI integrado',
    'Last Edited On': 'Última edición el',
    'Multi-Pass Design': 'Diseño de múltiples pasadas',
    'My Projects': 'Mis proyectos',
    'No options': 'Sin opciones',
    'No Result Found!': '¡No se han encontrado resultados!',
    'OR': 'O',
    'Open': 'Abierto',
    'Open File': 'Abrir documento',
    'Permeate Flow Rate': 'Tasa de flujo de permeado',
    'Permeate Flow Rate must not be empty': 'El caudal de permeado no debe estar vacío',
    'Pre Treatment': 'Pretratamiento',
    'Pre-Configured Design': 'Diseño preconfigurado',
    'Project Details (Quick view)': 'Detalles del proyecto (vista rápida)',
    'Project Name': 'Nombre del proyecto',
    'Recent Files': 'Archivos recientes',
    'Recent Search': 'Búsqueda reciente',
    'Result': 'Resultado',
    'RO-EDI Equipment Selector': 'Selector de equipos RO-EDI',
    'See Result': 'Ver resultado',
    'Shared by': 'Compartido por',
    'Shared Projects': 'Proyectos compartidos',
    'Single-Pass Design': 'Diseño de una sola pasada',
    'Submit': 'Entregar',
    'Template Library': 'Biblioteca de plantillas',
    'Tutorial': 'Tutorial',
    'Type here…': 'Escriba aquí…',
    'Unread': 'No leído',
    'Welcome to': 'Bienvenido a',
    'Nominal Permeate Flow Rate': 'Caudal nominal de permeado',
    'Choose any RO-EDI Equipment Model to Display the Data': 'Elija cualquier modelo de equipo RO-EDI para mostrar los datos',
    'Please use the RO-EDI Equipment Selector. Please consult Veolia for further support.': 'Utilice el selector de equipos RO-EDI. Consulte con Veolia para obtener más ayuda.',
    'Potable Water': 'Agua Potable',
    'Beverage Production': 'Producción de bebidas',
    'Potable Water - Low Boron': 'Agua Potable - Baja en Boro',
    'Demineralization': 'Desmineralización',
    'Reuse': 'Reutilizar',
    'Reuse - High Purity': 'Reutilización: alta pureza',
    'Ultrapure Water': 'Agua ultrapura',
    'RO Permeate Polishing': 'Pulido de permeado RO',
    'Water Softening': 'Ablandamiento de agua',
    'City Water': 'Agua de la ciudad',
    'Conventional': 'Convencional',
    'MF/UF': 'MF/UF',
    'Logout': 'Cerrar sesión',
    'Winflows Design Simulator': 'Simulador de diseño de Winflows',
    'Received Projects': 'Proyectos recibidos'
  },
  ProjectInfo: {
    'Email': 'Correo electrónico',
    'Engineer': 'Ingeniero',
    'Enter Notes here...': 'Introduzca notas aquí...',
    'Location': 'Ubicación',
    'Ok': 'De acuerdo',
    'Phone': 'Teléfono',
    'Project Info': 'Información del proyecto',
    'Project Name*': 'Nombre del proyecto*',
  },
  Pump: {
    'Are you sure you want to close this form?': '¿Estás seguro de que deseas cerrar este formulario?',
    'Auto Efficiencies': 'Eficiencias Automotrices',
    'Average Discharge Pressure': 'Presión de descarga promedio',
    'Cancel': 'Cancelar',
    'Discharge Pressure': 'Presión de descarga',
    'Flow Rate': 'Tasa de flujo',
    'Inlet Pressure': 'Presión de entrada',
    'Motor Efficiency': 'Eficiencia del motor',
    'OK': 'DE ACUERDO',
    'Power': 'Fuerza',
    'Pump Efficiency': 'Eficiencia de la bomba',
    'Pump Specification': 'Especificación de la bomba',
    'VFD Efficiency': 'Eficiencia del variador de frecuencia',
    'Power Consumption': 'Consumo de Energía',
    'Combined Efficiency': 'Eficiencia Combinada',
    'RO/NF Unit Attached': 'Unidad RO/NF Conectada'
  },
  Cartridge: {
    'Actual Flow per TIE': 'Flujo real por TIE',
    'Cancel': 'Cancelar',
    'Cartridge Filter': 'Filtro de cartucho',
    'Do you want to close the CF input page?': '¿Quiere cerrar la página de entrada de CF?',
    'Filter': 'Filtrar',
    'Filter DP': 'Filtro DP',
    'Flow per TIE': 'Flujo por TIE',
    'Flow Sheet is not available for this Element.': 'El diagrama de flujo no está disponible para este elemento.',
    'Micron': 'Micrón',
    'Number of Filters': 'Número de filtros',
    'OK': 'DE ACUERDO',
    'View Fact Sheet': 'Ver hoja informativa',
    'Flow Capacity': 'Capacidad de Flujo',
    'Filter Type': 'Tipo de Filtro',
    'Design Flow Per TIE': 'Flujo de Diseño por TIE',
    'Outlet Pressure': 'Presión de Salida',
    'Pressure Drop': 'Caída de Presión'
  },
  Stripper: {
    'Activate': 'Activar',
    'Are you sure you want to close this form?': '¿Estás seguro de que deseas cerrar este formulario?',
    'Cancel': 'Cancelar',
    'OK': 'DE ACUERDO',
    'Outlet CO2 concentration': 'Concentración de CO2 de salida',
    'Outlet H2S concentration': 'Concentración de H2S en la salida',
    'Outlet NH3 concentration': 'Concentración de NH3 en la salida',
    'Stripper': 'Estriptista',
  },
  MixSplit: {
    'Apply': 'Aplicar',
    'Are you sure you want to close this form?': '¿Estás seguro de que deseas cerrar este formulario?',
    'Cancel': 'Cancelar',
    'Flow Rate': 'Tasa de flujo',
    'Note': 'Nota',
    'Number of Outlet Streams': 'Número de flujos de salida',
    'OK': 'DE ACUERDO',
    'Split Fraction': 'fracción dividida',
    'Split Fraction of individual streams should be in the range of 0-1 and sum of all split fractions should be 1.': 'La fracción dividida de transmisiones individuales debe estar en el rango de 0 a 1 y la suma de todas las fracciones divididas debe ser 1.',
    'Split fraction(s) must not be empty': 'Las fracciones divididas no deben estar vacías',
    'Splitter': 'Disidente',
    'Stream Name': 'Nombre de la transmisión',
    'Stream Values should be between 0 and 1': 'Los valores de transmisión deben estar entre 0 y 1',
    'Sum of Split fraction(s) is 1 or more. Please review your input': 'La suma de las fracciones divididas es 1 o más. Por favor revise su entrada',
    'Sum of split fraction(s) should be 1.0': 'La suma de las fracciones divididas debe ser 1,0',
    'Total stream values must be between 0 and 1': 'Los valores totales de la transmisión deben estar entre 0 y 1',
  },
  ChemDose: {
    'Apply': 'Aplicar',
    'Are you sure you want to close this form?': '¿Estás seguro de que deseas cerrar este formulario?',
    'Average Consumption as Supplied': 'Consumo promedio tal como se suministra',
    'Average Consumption as metered': 'Consumo promedio medido',
    'Cancel': 'Cancelar',
    'Carbon Dioxide': 'Dióxido de carbono',
    // 'Caustic Soda': 'Soda caustica',
    'Chemical': 'Químico',
    'Chemical Dosing': 'Dosificación de químicos',
    'Chemical Selection': 'Selección química',
    'Close': 'Cerca',
    'Dosage Rate': 'Tasa de dosificación',
    'Dosage Rate must be positive': 'La tasa de dosificación debe ser positiva.',
    'Dosing Control': 'Control de dosificación',
    'Hardness Leakage': 'Fuga de dureza',
    'Hardness Leakage must be positive': 'La fuga de dureza debe ser positiva.',
    'Hydrochloric Acid': 'Ácido clorhídrico',
    'Input': 'Aporte',
    'LSI must be between -3 and 3': 'LSI debe estar entre -3 y 3',
    'Mass flow Rate': 'Tasa de flujo másico',
    'Mass Flow Rate': 'Tasa de flujo másico',
    'Metered Concentration': 'Concentración medida',
    'Metered Concentration must be between 0 and 100': 'La concentración medida debe estar entre 0 y 100',
    'Metered Gravity at supplied Concentration must be positive': 'La gravedad medida en la concentración suministrada debe ser positiva',
    'Nitric Acid': 'Ácido nítrico',
    'OK': 'DE ACUERDO',
    'Output': 'Producción',
    'Phosphoric Acid': 'Ácido fosfórico',
    'Please enter the chemical name': 'Por favor ingrese el nombre químico',
    'Please enter the required fields': 'Por favor introduzca los campos requeridos',
    'Safety Factor': 'Factor de seguridad',
    'Safety Factor must be positive': 'El factor de seguridad debe ser positivo.',
    'Select': 'Seleccionar',
    'Slacked Lime': 'Lima apagada',
    'Sodium Cycle Softener': 'Suavizante de ciclo de sodio',
    'Specific Gravity at metered Concentration': 'Gravedad específica a concentración medida',
    'Specific Gravity at supplied Concentration': 'Gravedad específica a la concentración suministrada',
    'Specific Gravity at supplied Concentration must be positive': 'La gravedad específica a la concentración suministrada debe ser positiva',
    // 'Sulfuric Acid': 'Ácido sulfúrico',
    'Supplied Concentration': 'Concentración suministrada',
    'Supplied Concentration must be between 0 and 100': 'La concentración suministrada debe estar entre 0 y 100',
    'Supplied Form': 'Formulario suministrado',
    'Supplied/Delivered consumption with safety factor': 'Consumo suministrado/entregado con factor de seguridad',
    'Target Alkalinity': 'Alcalinidad objetivo',
    'Target LSI': 'LSI objetivo',
    'Usage': 'Uso',
    'Usage must be between 0 and 100': 'El uso debe estar entre 0 y 100.',
    'Volume Flow Rate': 'Caudal volumétrico',
    'pH must be between 0 and 14': 'El pH debe estar entre 0 y 14.',
  },
  ERD: {
    'Are you sure you want to close this form?': '¿Estás seguro de que deseas cerrar este formulario?',
    'Circulation Pump Efficiency': 'Eficiencia de la bomba de circulación',
    'Circulation Pump Motor Efficiencies': 'Eficiencias del motor de la bomba de circulación',
    'Circulation Pump VFD Efficiencies': 'Eficiencias del VFD de la bomba de circulación',
    'Circulation/Booster Pump': 'Bomba de circulación/refuerzo',
    'Cost of Power': 'Costo de la energía',
    'Differential Pressure HP Side': 'Presión diferencial lado HP',
    'Differential Pressure LP Side': 'Lado LP de presión diferencial',
    'Efficiency': 'Eficiencia',
    'Energy Recovery Device': 'Dispositivo de recuperación de energía',
    'Feedwater Salinity': 'Salinidad del agua de alimentación',
    'HP Power Consumed': 'HP de energía consumida',
    'HP Pump Efficiency': 'Eficiencia de la bomba HP',
    'HP Pump Motor Efficiency': 'Eficiencia del motor de la bomba HP',
    'Input Parameters': 'Parámetros de entrada',
    'Leakage (reject in HP out stream)': 'Fuga (rechazo en flujo de salida de HP)',
    'Lubrication Flow': 'Flujo de lubricación',
    'Lubrication Per Array': 'Lubricación por matriz',
    'Manual or Auto Efficiencies': 'Eficiencias manuales o automáticas',
    'Membrane Differential Pressure': 'Presión diferencial de membrana',
    'Mixing at Membrane Feed': 'Mezclado en alimentación de membrana',
    'Model': 'Modelo',
    'Motor Efficiency': 'Eficiencia del motor',
    'Number of Units': 'Número de unidades',
    'OK': 'DE ACUERDO',
    'Parameter': 'Parámetro',
    'Power Consumed': 'Energía consumida',
    'Power Consumption': 'Energía consumida',
    'Power Cost Saved': 'Costo de energía ahorrado',
    'Power Savings': 'Ahorro de energía',
    'Pressure Exchanger': 'Intercambiador de presión',
    'Pressure Exchanger Performance': 'Rendimiento del intercambiador de presión',
    'Pressure Exchanger Power results': 'Resultados de potencia del intercambiador de presión',
    'Pump Efficiency': 'Eficiencia de la bomba',
    'RO Feed Pressure': 'Presión de alimentación RO',
    'RO Permeate Flow': 'Flujo de permeado RO',
    'RO Recovery Rate': 'Tasa de recuperación de RO',
    'Specific Power Consumption': 'Consumo de energía específico',
    'Total Power Consumption': 'Consumo total de energía',
    'Unit': 'Unidad',
    'Unit Flow': 'Flujo unitario',
    'VFD Efficiency': 'Eficiencia del variador de frecuencia',
    'Values': 'Valores',
    'Work Exchanger': 'Intercambiador de Trabajo',
    'Work Exchanger Performance': 'Desempeño del Intercambiador de Trabajo',
    'Work Exchanger Power results': 'Resultados de potencia del intercambiador de trabajo',
  },
  PW: {
    'Are you sure you want to close this form?': '¿Estás seguro de que deseas cerrar este formulario?',
    'Cost of Power': 'Costo de la energía',
    'Electricity Generated (Mechanical Energy Recovered)': 'Electricidad Generada (Energía Mecánica Recuperada)',
    'Feedwater Salinity': 'Salinidad del agua de alimentación',
    'HP Motor Electrical Power': 'Potencia eléctrica del motor HP',
    'HP Motor Shaft Power': 'Potencia del eje del motor HP',
    'HP Pump Efficiency': 'Eficiencia de la bomba HP',
    'HP Pump Motor Efficiency': 'Eficiencia del motor de la bomba HP',
    'HP Pump Shaft Power': 'Potencia del eje de la bomba HP',
    'Input Parameters': 'Parámetros de entrada',
    'Low P Discharge Pressure': 'Baja presión de descarga de P',
    'Membrane Differential Pressure': 'Presión diferencial de membrana',
    'Net Transfer Efficiency': 'Eficiencia de transferencia neta',
    'OK': 'DE ACUERDO',
    'Parameter': 'Parámetro',
    'Pelton Wheel': 'Rueda Pelton',
    'Pelton wheel Performance': 'Rendimiento de la rueda Pelton',
    'Power Cost Saved': 'Costo de energía ahorrado',
    'Power Savings': 'Ahorro de energía',
    'RO Feed Pressure': 'Presión de alimentación RO',
    'RO Permeate Flow': 'Flujo de permeado RO',
    'RO Recovery Rate': 'Tasa de recuperación de RO',
    'Specific Power Consumption': 'Consumo de energía específico',
    'Total Power Consumption': 'Consumo total de energía',
    'Turbine Efficiency': 'Eficiencia de la turbina',
    'Unit': 'Unidad',
    'Values': 'Valores',
  },
  TC: {
    'Are you sure you want to close this form?': '¿Estás seguro de que deseas cerrar este formulario?',
    'Boost Pressure': 'Impulso de presión',
    'Cost of Power': 'Costo de la energía',
    'Energy Recovered': 'Energía recuperada',
    'Feedwater Salinity': 'Salinidad del agua de alimentación',
    'HP Power Consumed': 'HP de energía consumida',
    'HP Pump Efficiency': 'Eficiencia de la bomba HP',
    'HP Pump Motor Efficiency': 'Eficiencia del motor de la bomba HP',
    'Input Parameters': 'Parámetros de entrada',
    'Low P Discharge Pressure': 'Baja presión de descarga de P',
    'Membrane Differential Pressure': 'Presión diferencial de membrana',
    'Net Transfer Efficiency': 'Eficiencia de transferencia neta',
    'OK': 'DE ACUERDO',
    'Parameter': 'Parámetro',
    'Power Cost Saved': 'Costo de energía ahorrado',
    'Power Savings': 'Ahorro de energía',
    'RO Feed Pressure': 'Presión de alimentación RO',
    'RO Permeate Flow': 'Flujo de permeado RO',
    'RO Recovery Rate': 'Tasa de recuperación de RO',
    'Specific Power Consumption': 'Consumo de energía específico',
    'Total Power Consumption': 'Consumo total de energía',
    'Turbo Charger': 'Turbocompresor',
    'Turbo Charger Performance': 'Rendimiento del turbocompresor',
    'Turbo Charger Placement': 'Colocación del turbocompresor',
    'Turbo Inlet Pressure': 'Presión de entrada del turbo',
    'Turbo Outlet Pressure': 'Presión de salida del turbo',
    'Unit': 'Unidad',
    'Values': 'Valores',
  },
  CIP: {
    'CIP Calculator': 'Calculadora CIP',
    'CIP Report': 'Informe del CIP',
    'Calculator': 'Calculadora',
    'Cleaner Strength': 'Fuerza más limpia',
    'Cleaner Type': 'Tipo de limpiador',
    'Cleaning Step': 'Paso de limpieza',
    'Cleaning Strategies based on Foulant type': 'Estrategias de limpieza según el tipo de suciedad',
    'Element': 'Elemento',
    'Element/Vessel': 'Elemento/Vaso',
    'Foulant Type': 'Escriba completamente',
    'Get Report': 'Obtener informe',
    'Liquid': 'Líquido',
    'Maintenance Clean': 'Mantenimiento Limpio',
    'Membrane Material': 'Material de la membrana',
    'NSF Approved': 'Aprobado por la NSF',
    'No of RO Trains': 'Número de trenes RO',
    'No of Stages': 'No de Etapas',
    'No of Vessels': 'Número de buques',
    'Powder': 'Polvo',
    'Print': 'Imprimir',
    'Pump Flow rate': 'Caudal de la bomba',
    'Quantity of Cleaner': 'Cantidad de limpiador',
    'Registration': 'Registro',
    'Select': 'Seleccionar',
    'Single Product': 'Producto único',
    'Solution Volume': 'Volumen de la solución',
    'Stage': 'Escenario',
    'Stages Cleaned in Parallel': 'Etapas limpiadas en paralelo',
    'Stages Cleaned in Series': 'Etapas limpiadas en serie',
    'Standard': 'Estándar',
    'System Design': 'Diseño de sistemas',
    'Total': 'Total',
    'Vol in CIP piping': 'Volumen en tuberías CIP',
    'Vol in CIP tank': 'Volumen en el tanque CIP',
    'Text 1 CIP': 'La limpieza es un proceso complejo que requiere información sobre los contaminantes reales para definir la mejor estrategia CIP y los mejores productos a utilizar. Las recomendaciones proporcionadas en esta herramienta de selección son pautas generales para ayudar en la selección de productos.',
    'Text 2 CIP': 'Idealmente, se debería utilizar un análisis de contaminantes en el proceso de selección del limpiador. Si no hay un análisis de contaminantes disponible, consulte el menú desplegable de arriba y haga una suposición fundamentada.',
    'Text 3 CIP': 'La herramienta permite seleccionar solo contaminantes a la vez. Para combinaciones de incrustantes, consulte la “Selección recomendada para incrustantes mixtos” en el menú desplegable.',
    'Text 4 CIP': 'Para escenarios complejos o si ha habido dificultades para lograr los resultados esperados, comuníquese con el equipo de aplicaciones de productos de MemChem para obtener ayuda para identificar opciones y productos alternativos.'
  },
  Notification_Modal: {
    'Are you sure you want to close this form?': '¿Estás seguro de que deseas cerrar este formulario?',
    'Choose Report Options': 'Elija opciones de informe',
    'Custom': 'Costumbre',
    'Default units have been saved successfully.': 'Las unidades predeterminadas se han guardado correctamente.',
    'Display Units': 'Unidades de visualización',
    'Do you want to clear the canvas?': '¿Quieres limpiar el lienzo?',
    'Do you want to close the page?': '¿Quieres cerrar la página?',
    'Do you want to delete this unitop?': '¿Quieres eliminar este unitop?',
    'Do you want to save the file?': '¿Quieres guardar el archivo?',
    'Failed to load Default units.': 'No se pudieron cargar las unidades predeterminadas.',
    'Failed to load win files': 'No se pudieron cargar los archivos win',
    'Feed flow': 'Flujo de alimentación',
    'Flow': 'Fluir',
    'Flowsheet is either empty or incomplete...': 'El diagrama de flujo está vacío o incompleto...',
    'Flowsheet is solved successfully.': 'El diagrama de flujo se resuelve con éxito.',
    'Flowsheet solved with errors.': 'Diagrama de flujo resuelto con errores.',
    'Flowsheet solving has failed.': 'La resolución del diagrama de flujo ha fallado.',
    'Flux': 'Flujo',
    'Generate PDF': 'Generar PDF',
    'Generate Sheets': 'Generar hojas',
    'International': 'Internacional',
    'Ion Composition': 'Composición de iones',
    'Kindly enter valid filename!': '¡Por favor ingrese un nombre de archivo válido!',
    'Kindly save the file before sharing!': '¡Guarde el archivo antes de compartirlo!',
    'Load': 'Carga',
    'Load Winflows Design Simulator file': 'Cargar el archivo del simulador de diseño de Winflows',
    'Loading Please wait...': 'Cargando por favor espere...',
    'My Files': 'Mis archivos',
    'No': 'No',
    'OK': 'DE ACUERDO',
    'Please add/update specify flow values!': '¡Agregue/actualice los valores de flujo especificados!',
    'Power': 'Fuerza',
    'Pressure': 'Presión',
    'Product flow': 'Flujo de producto',
    'Product Flow': 'Flujo de producto',
    'Reminder': 'Recordatorio',
    'Saturation Data': 'Datos de saturación',
    'Save as Default': 'Guardar por defecto',
    'Select file to upload': 'Seleccione el archivo para cargar',
    'Shared By Others': 'Compartido por otros',
    'Solver Message': 'Mensaje del solucionador',
    'Specify Flow': 'Especificar flujo',
    'Stream Data': 'Transmitir datos',
    'Stream Properties': 'Propiedades de la corriente',
    'Streams': 'Corrientes',
    'System Recovery': 'Recuperación del sistema',
    'Temperature': 'Temperatura',
    'US': 'A NOSOTROS',
    'Upload File': 'Subir archivo',
    'Volume': 'Volumen',
    'Yes': 'Sí',
    'You cannot share empty flowsheet !': '¡No puedes compartir un diagrama de flujo vacío!',
    'Successfully Done': 'Hecho con éxito',
    'File saved successfully.': 'Archivo guardado exitosamente.',
    'File Share': 'Compartir archivos',
    'Subject': 'Sujeto',
    'Message': 'Mensaje',
    'Share': 'Compartir',
    'Enter all input fields': 'Ingrese todos los campos de entrada',
    'Enter any one input field': 'Ingrese cualquier campo de entrada',
    'Automate Stream ID': 'Automatizar la identificación de la transmisión',
    'Quick Results': 'Resultados rápidos',
    'ARGO Analyzer Report': 'Informe del analizador ARGO',
    'Notifications': 'Notificaciones',
    'Do you want to save the file ?': '¿Quieres guardar el archivo?',
    'Please select your country from the list given.': 'Seleccione su país de la lista proporcionada.',
    'This selection allows Winflows to provide you with region-specific antiscalant options.': 'Esta selección permite a Winflows brindarle opciones antiescalantes específicas de la región.',
    'Important: Your country selection is permanent and cannot be changed after submission.': 'Importante: la selección de su país es permanente y no se puede cambiar después del envío.',
    'Failed to load saved win file': 'No se pudo cargar el archivo win guardado',
    'RO Machine not available': 'Máquina RO no disponible',
    'Entered stream number is duplicated!': '¡El número de transmisión ingresado está duplicado!',
    'Failed to fetch Units': 'No se pudieron recuperar las unidades',
    'Failed to fetch DB transaction record': 'No se pudo recuperar el registro de transacción de la base de datos',
    'Failed to fetch feed input.': 'No se pudo recuperar la entrada del feed.',
    'File seems empty, please create the flowsheet!': 'El archivo parece vacío, ¡cree el diagrama de flujo!',
    'Failed to save flow file': 'No se pudo guardar el archivo de flujo',
    'Failed to fetch file list': 'No se pudo recuperar la lista de archivos',
    'Failed to save feed input.': 'No se pudo guardar la entrada del feed.',
    'Failed to load win-4 files': 'No se pudieron cargar archivos win-4',
    'Somthing is wrong.': 'Algo anda mal.',
    'failed to download the file': 'no se pudo descargar el archivo',
    'Something went wrong': 'algo salió mal',
    'Failed to fetch Flowsheet Selection record': 'No se pudo recuperar el registro de selección del diagrama de flujo',
    'No Data Found': 'No se encontraron datos',
    'Please enter valid filename': 'Por favor ingrese un nombre de archivo válido',
    'Please provide a new name for the unitop as the current one is already available on the flowsheet.': 'Proporcione un nuevo nombre para el unitop ya que el actual ya está disponible en el diagrama de flujo.',
    'connections are incomplete!': '¡Las conexiones están incompletas!',
    'Unitop inputs are either incomplete or incorrect!': '¡Las entradas de Unitop están incompletas o son incorrectas!',
    'Only one instance of Argo Analyzer can be used in a flowsheet.': 'Solo se puede utilizar una instancia de Argo Analyzer en un diagrama de flujo.',
    'Winflows Design Simulator detects multiple feed sources on the current flowsheet. Please input the flow rate for the respective feed source.': 'El simulador de diseño de Winflows detecta múltiples fuentes de alimentación en el diagrama de flujo actual. Ingrese el caudal para la fuente de alimentación respectiva.',
    'Enter all input field values!': '¡Ingrese todos los valores del campo de entrada!',
    'Permeate Flux': 'Flujo de permeado',
    'Recovery': 'Recuperación',
    'Explorer': 'Exploradora',
    'Average': 'Promedio',
    'Element Max': 'Elemento máximo',
    'Vessels': 'Buques',
    'No. of Elements': 'Número de elementos',
    'Element Type': 'Tipo de elemento',
    'Conc. Flow': 'Conc. Fluir',
    'Perm Flow': 'Flujo permanente',
    'Age': 'Edad',
    'Saturation Data(Concentrate)': 'Datos de saturación (concentrado)',
    'Last Element Beta': 'Beta del último elemento',
    'Delta Pressure': 'Presión delta',
    'Avg.': 'Promedio',
    'Feed TDS': 'Alimentar TDS',
    'Perm TDS': 'TDS permanente',
    'A-Value ACP': 'Valor A ACP',
    'B-Value ACP': 'Valor B ACP',
    'A-Factor': 'Factor A',
    'B-Factor': 'Factor B',
    'Element No.': 'Elemento No.',
    'Net Pressure': 'Presión neta',
    'Update': 'Actualizar',
    'Ionic Composition': 'Composición iónica',
    'Table Setting': 'Configuración de la mesa',
    'Stream Source': 'Fuente de transmisión',
    'Stream Destination': 'Destino de la transmisión',
    'Export Table': 'Exportar tabla',
    'Session has expired. Please login!': 'La sesión ha expirado. ¡Por favor inicie sesión!',
    'Your session will expire in 10 minutes. Please save your work and login again.': 'Tu sesión expirará en 10 minutos. Guarda tu trabajo y vuelve a iniciar sesión.',
    'Session Expiry Warning': 'Advertencia de expiración de sesión'
  },
  Help_Modal_Form: {
    '* or multiple of it': '* o múltiplo de él',
    'About': 'Acerca de',
    'Database Date': 'Fecha de la base de datos',
    'Database Version': 'Versión de la base de datos',
    'Design Guidelines': 'Guía de diseño',
    'Determine approximate number of RO elements': 'Determinar el número aproximado de elementos RO',
    'Determine array.': 'Determinar la matriz.',
    'Determine number of element housings.': 'Determine el número de carcasas de elementos.',
    'Determine which RO elements to use.': 'Determine qué elementos de RO utilizar.',
    'Housings in 1': 'Viviendas en 1',
    'OK': 'DE ACUERDO',
    'Permeate Recovery, %': 'Recuperación de permeado, %',
    'Program Date': 'Fecha del programa',
    'Run Winflows Design Simulator with the 24-12 array and look for': 'Ejecute Winflows Design Simulator con la matriz 24-12 y busque',
    'stage': 'escenario',
    'Text1': 'Las siguientes instrucciones son una guía sobre cómo diseñar unidades de OI simples donde los caudales son lo suficientemente grandes como para que se requieran 18 o más elementos, y la presión osmótica de la alimentación lo suficientemente pequeña como para permitir operar por encima del 65 por ciento de recuperación de permeado. En este caso, la tarea es diseñar una unidad de OI que con una recuperación de permeado del 80 por ciento producirá 1,5x10',
    'Text10': 'El perfil del flujo de permeado (que se muestra en Winflows Design Simulator Explorer) no está demasiado sesgado (preferiblemente, el flujo del último elemento debe ser al menos la mitad del flujo del elemento principal). Es posible que se necesite una bomba de refuerzo entre etapas o contrapresión de permeado en la primera etapa para equilibrar el flujo de permeado entre las etapas.',
    'Text2': 'permeado de gpd con menos de 200 mg/L de TDS de agua de pozo profundo con 2000 mg/L de TDS.',
    'Text3': 'Se eligen elementos de 8” de diámetro. Por lo general, están disponibles en 365, 400 y 440 pies.',
    'Text4': 'Versiones con área de membrana activa. Normalmente, cuanto más activa sea el área de la membrana, más delgado será el espaciador del canal de alimentación y mayor será la tendencia a ensuciarse del elemento. En este caso, la alimentación es agua de pozo profundo con baja tendencia al ensuciamiento, por lo que se elige un modelo de elemento de 400 pies2.',
    'Text5': 'Seleccione el flujo de permeado promedio, por ejemplo de las Pautas de diseño. En este ejemplo, el agua de alimentación es agua de pozo profundo con una tendencia muy baja a la contaminación, por lo que se elige un flujo de permeado promedio de 15 gfd.',
    'Text6': 'Calcule el número de elementos necesarios (N) a partir del caudal de permeado (Fp), el flujo de permeado promedio (Jw) y el área de membrana activa por elemento (AA).',
    'Text7': 'Fp = N×AA×Jw, que en este caso da N = 250 elementos.',
    'Text8': 'Normalmente hay 6 o 7 elementos por vivienda. En este caso se eligen 7 elementos por carcasa, lo que da como resultado carcasas de 36 elementos.',
    'Text9': 'Con una recuperación del permeado del 80 por ciento, un conjunto de dos etapas probablemente funcionará bien, lo que significa que aproximadamente 2/3 de las carcasas estarán en la primera etapa. Por lo tanto, pruebe con una matriz 24-12.',
    'The below table is used to determine how to approximately arrange the housings.': 'La siguiente tabla se utiliza para determinar cómo organizar aproximadamente las carcasas.',
    'The predicted permeate TDS should be below the maximum allowed.': 'El TDS del permeado previsto debe estar por debajo del máximo permitido.',
    'The pressure drop over the elements': 'La caída de presión sobre los elementos.',
    'Tips on Designing RO Units Operating on Natural Waters with Below 5000 mg/L TDS': 'Consejos para diseñar unidades de ósmosis inversa que funcionen en aguas naturales con menos de 5000 mg/l de TDS',
    'Typical array*': 'Matriz típica*',
    'Warnings': 'Advertencias',
    'Winflows Design Simulator RO Elements Design Guidelines': 'Pautas de diseño de elementos RO del simulador de diseño de Winflows',
  },
  Preface: {
    "Winflows": "Winflows",
    "Design Simulator": "Simulador de diseño",
    "Winflows Design Simulator": "Simulador de diseño Winflows",
    "Projection Report": "Informe de proyección",
    "WATER TECHNOLOGIES": "TECNOLOGÍAS DEL AGUA",
    "Project Info": "Información del proyecto",
    "Project Name": "Nombre del proyecto",
    "Customer Name": "Nombre del cliente",
    "Engineer": "Diseñador",
    "Location": "Ubicación",
    "Mail ID": "Correo electrónico",
    "Phone No": "Teléfono",
    "Specify Flow Option": "Especificar opción de flujo",
    "Notes": "Notas",
    "Notifications": "Notificaciones",
    "None detected in the current design": "No se detectó nada en el diseño actual",
    "Trademark of Veolia": "*Marca registrada de Veolia; puede estar registrada en uno o más países. 2025 Veolia. Todos los derechos reservados",
    "Database": "Base de datos",
    "Description": "Descripción",
    "Unit Op": "Operación de unidad",
    'Total Number of Warnings': 'Número total de advertencias',
    'Total Number of Errors': 'Número total de errores',
    'Disclaimer_text': 'Descargo de responsabilidad: Esta proyección se proporciona como un servicio complementario y no constituye una garantía de rendimiento.'
  },
  Flowsheet_Design_Summary: {
    'Flowsheet Diagram': 'Diagrama de Flujo',
    'Flowsheet Design Summary': 'Resumen del diseño del diagrama de flujo',
    'Flowsheet Design': 'Diseño de diagrama de flujo',
    'Stream Property Summary': 'Resumen de propiedades de transmisión',
    'Stream Id': 'ID de flujo',
    'Alkalinity, ppm CaCO3': 'Alcalinidad, ppm CaCO3',
    'Hardness, ppm as CaCO3': 'Dureza, ppm as CaCO3',
    'Alkalinity': 'Alcalinidad',
    'Hardness': 'Dureza',
    'Conductivity at 25°C': 'Conductividad a 25 °C',
    'FSD Flow Balance': 'Balance de flujo FSD',
    'Unit ID (Stream no.)': 'ID de unidad (n.º de corriente)',
    'Overall Flow Sheet Recovery': 'Recuperación global de la hoja de flujo',
    'Flow - Total': 'Flujo - Total',
    'Incoming': 'Entrante',
    'Outgoing': 'Saliente',
    'Product': 'Producto',
    'Waste': 'Residuo',
    'ID': 'ID',
    'Conc.': 'Concentración',
    'Bleed': 'Purga',
    'Desalination_Demineralization': 'Resumen de flujo a nivel de unidad de desalinización / desmineralización / separador de membrana (MEMS)',
  },
  Feed_Product_Waste_Summary: {
    'Feed-Product-Waste Summary': 'Resumen de alimentación-producto-residuo',
    'Overall Flowsheet Recovery': 'Recuperación global de la hoja de flujo',
    'Category': 'Categoría',
    'Information': 'Información',
    'Ion Concentration': 'Concentración de iones',
    'Stream Property': 'Propiedad de la corriente',
    'Water Source': 'Fuente de agua',
    'Ionic Strength': 'Fuerza iónica',
    'Osm.Pressure': 'Presión osmótica',
    'Osm. Pressure': 'Presión osmótica',
    'Softened Water': 'Agua ablandada',
    'Pump Unit Summary': 'Resumen de la unidad de bomba'
  },
  RO_NF_Unit_System_Level_Summary: {
    'RO/NF Unit System-Level Summary': 'Resumen a nivel de sistema de unidad RO/NF',
    'Docked Summary': 'Resumen acoplado',
    'Total Number of RO/NF Unit': 'Número total de unidades RO/NF',
    'RO/NF Unit ID': 'ID de unidad RO/NF',
    'Upstream unit': 'Unidad aguas arriba',
    'Downstream unit': 'Unidad aguas abajo',
    'Permeate Flow': 'Caudal de permeado',
    'Concentrate Flow': 'Caudal de concentrado',
    'RO/NF Unit Recovery': 'Recuperación de la unidad RO/NF',
    'Breakdown by Stage': 'Desglose por etapa',
    'Total Membrane Area': 'Área total de membrana',
    'Feed Temperature': 'Temperatura de alimentación',
    'Interstage Pressure': 'Presión entre etapas',
    'Product Pressure *': 'Presión del producto*',
    'Feed pH': 'pH de alimentación',
    'Permeate TDS': 'TDS del permeado',
    'Concentrate TDS': 'TDS del concentrado',
    'Concentrate pH': 'pH del concentrado',
    'Detailed Design': 'Diseño detallado',
    'Array Design': 'Diseño de arreglo',
    'Housing': 'Carcasa',
    'Elements': 'Elementos',
    'Element Age(yr)': 'Antigüedad del elemento (años)',
    'Pressure Change': 'Cambio de presión',
    'Boost': 'Impulso',
    'Loss': 'Pérdida',
    'Permeate P': 'Presión de permeado',
    'Permeate pH': 'pH del permeado',
    'A-Value ACP': 'Valor A ACP',
    'A-Factor': 'Factor A',
    'B-Value ACP': 'Valor B ACP',
    'B-Factor': 'Factor B',
  },
  RO_NF_Unit_Stage_Level_Summary: {
    'RO/NF Unit Stage-Level Summary': 'Resumen a nivel de etapa de unidad RO/NF',
    'Element Type': 'Tipo de elemento',
    'Perm': 'Permeado',
    'dP': 'dP',
  },
  DSSRO_Section_Summary: {
    'DSSRO Section Summary': 'Resumen de sección DSSRO',
    'DSSRO Overview': 'Descripción general DSSRO',
    'Overview': 'Descripción general',
    'DSSRO mode': 'Modo DSSRO',
    'CLRO': 'CLRO',
    'Elements per PV': 'Elementos por PV',
    'Spacers per PV': 'Espaciadores por PV',
    'Length of PV': 'Longitud de PV',
    'CL Recovery': 'Recuperación CL',
    'BP Recovery': 'Recuperación BP',
    'CL Concentrate Flow': 'Caudal de concentrado CL',
    'BP Concentrate Flow': 'Caudal de concentrado BP',
    'CL Net Feed Flow': 'Caudal neto de alimentación CL',
    'BP Feed Flow': 'Caudal de alimentación BP',
    'CL Permeate Flow': 'Caudal de permeado CL',
    'Total Circuits': 'Circuitos totales',
    'BP Sequence Duration': 'Duración de secuencia BP',
    'CL Sequence Duration': 'Duración de secuencia CL',
    'Complete Cycle Duration': 'Duración de ciclo completo',
    'CL System Volume': 'Volumen del sistema CL',
    'S1 Volume': 'Volumen S1',
    'S2 Volume': 'Volumen S2',
    'S3 Volume': 'Volumen S3',
    'DSSRO Flow Summary (Element Level)': 'Resumen de flujo DSSRO (nivel de elemento)',
    'Flow Summary': 'Resumen de flujo',
    'Circuit': 'Circuito',
    'Element': 'Elemento',
    'Feed Press': 'Presión de alimentación',
    'Conc Flow': 'Caudal de concentrado',
    'CL 1': 'CL 1',
    'CL Final': 'CL final',
    'DSSRO Stream Composition': 'Composición de corriente DSSRO',
    'Concentrations': 'Concentraciones',
    'Concentrations (mg/L as ion)': 'Concentraciones (mg/L como ion)',
    'Concentrate': 'Concentrado',
    'Permeate': 'Permeado',
    'Composition': 'Composición',
    'Schematic': 'Esquema',
    'Production Loop': 'Bucle de producción',
    'High Pressure Centrifugal Pump (P2)': 'Bomba centrífuga de alta presión (P2)',
    'Raw Feed Flow': 'Caudal de alimentación bruta',
    'Feed Pump (P1)': 'Bomba de alimentación (P1)',
    'RO Feed': 'Alimentación RO',
    'Cartridge Filter': 'Filtro de cartucho',
    'Feed Pressure': 'Presión de alimentación',
    'Delta Pressure': 'Presión diferencial',
    'Circulation pump (P3)': 'Bomba de circulación (P3)',
    'CL Conc Flow': 'Caudal de concentrado CL',
    'CL Perm Flow': 'Caudal de permeado CL',
    'Brine Purge': 'Purga de salmuera',
    'Conc Recirculation Flow': 'Caudal de recirculación de concentrado',
    'BP Conc Flow': 'Caudal de concentrado BP',
    'Brine Disposal': 'Eliminación de salmuera',
    'DSSRO Loop Summary': 'Resumen del circuito DSSRO',
    'Loop No': 'Número de circuito',
    'Permeate Stream (Loop wise) Summary': 'Resumen del flujo de permeado (por circuito)',
    'Concentrate Stream (Loop wise) Summary': 'Resumen del flujo de concentrado (por circuito)',
  },
  Pump_Summary: {
    'Pump Summary': 'Resumen de bombas',
    'Total Number of Pumps': 'Número total de bombas',
    'Pump Unit ID': 'ID de unidad de bomba',
    'RO/NF Unit Attached': 'Unidad RO/NF adjunta',
    'Combined Efficiency': 'Eficiencia combinada',
    'Total Power Consumption': 'Consumo total de energía (kW)',
  }, Detailed_Stream_Data: {
    'Detailed Stream Data': 'Datos detallados de corriente',
    'LSI': 'LSI',
    'SDSI': 'SDSI',
    'Concentrate': 'Concentrado',
    'Inlet': 'Entrada',
    'Downstream Permeate': 'Permeado aguas abajo',
    'Stream ID': 'ID de flujo'
  },
  EDI_Unit_System_Level_Summary: {
    'EDI Unit System-Level Summary': 'Resumen a nivel de sistema de unidad EDI',
    'Total Number of EDI Unit': 'Número total de unidades EDI',
    'EDI Unit ID': 'ID de unidad EDI',
    'System Product Flow Rate': 'Caudal de producto del sistema',
    'Electrode Bleed Flow': 'Caudal de purga de electrodos',
    'EDI Unit Recovery': 'Recuperación de la unidad EDI',
    'No. of E-Cell EDI Stacks': 'N.º de pilas E-Cell EDI',
    'Concentrate Pressure': 'Presión de concentrado',
    'Product Outlet Pressure': 'Presión de salida del producto',
    'Voltage': 'Voltaje',
    'AC Power': 'Potencia CA',
    'DC Power': 'Potencia CC',
    'DC power': 'Potencia CC',
    'Flow Configuration': 'Configuración de flujo',
    'Counter-Current/Co-Current': 'Contracorriente/Cocorriente',
    'Counter-Current': 'Contracorriente',
    'Feed TDS': 'TDS de alimentación',
    'Feed pH': 'pH de alimentación',
    'Product Resistivity': 'Resistividad del producto',
    'Product pH': 'pH del producto',
    'Concentrate TDS': 'TDS del concentrado',
    'Concentrate pH': 'pH del concentrado',
    'Electrode Bleed TDS': 'TDS de purga de electrodos',
    'Electrode Bleed pH': 'pH de purga de electrodos',
    'H2': 'H2',
    'Cl2': 'Cl2',
    'Blower/Ventilation Sizing for H2': 'Dimensionamiento de soplador/ventilación para H2',
    'Ventilation Blower/Fan': 'Soplador/ventilador de ventilación',
    'Size': 'Tamaño',
    'Electrode_stream_vented_hydrogen': 'La corriente de electrodos debe ventearse porque contiene pequeñas cantidades de hidrógeno, oxígeno y posiblemente cloro (si hay ion cloruro).',
    'hydrogen_oxygen_gas_edi': 'Se produce una mezcla 2:1 de hidrógeno y oxígeno a un caudal máximo de 11,4 ml/A/min/pila (gas seco a 25 °C, 1,0 bar), compuesta por 7,6 ml de H2 y 3,8 ml de O2. Asegure que la ventilación mantenga el hidrógeno por debajo del 4%.',
    'EDI Design Parameters': 'Parámetros de diseño de EDI',
    'Product Flow Rate per Stack': 'Caudal de producto por pila',
    'Upstream Interconnecting Piping': 'Tubería interconectada aguas arriba',
    'Pressure Loss': 'Pérdida de presión',
    'TEA': 'TEA',
    'TEC': 'TEC',
    'Silica': 'Sílice',
    'Conductvity': 'Conductividad',
    'Product Silica guarantee level': 'Nivel garantizado de sílice del producto',
    'Predicted Product Silica Level': 'Nivel previsto de sílice del producto',
    'Predicted Product Sodium level': 'Nivel previsto de sodio del producto',
    'Predicted Product Chloride level': 'Nivel previsto de cloruro del producto',
    'Predicted Product Sulfate level': 'Nivel previsto de sulfato del producto',
    'Maximum Allowable Recovery': 'Recuperación máxima permitida',
    'AC power consumption': 'Consumo de potencia CA',
    'AC energy': 'Energía CA',
    'Predicted Product outlet pressure': 'Presión de salida prevista del producto',
    'Feed Inlet': 'Entrada de alimentación',
    'Concentrate Outlet': 'Salida de concentrado',
    'Electrode Bleed': 'Purga de electrodos',
    'EDI Schematic': 'Esquema EDI',
    'Current/Stack': 'Corriente/pila',
    'Stack Voltage': 'Voltaje de la pila',
    'Energy Consumption': 'Consumo de energía',
    'Maximum Recovery': 'Recuperación máxima',
    'Max. Conc. outlet pressure': 'Presión máx. de salida de concentrado',
    'Conc. Bleed flow': 'Caudal de purga de concentrado',
    'Product pressure': 'Presión del producto',
    'Max. Conc. inlet pressure': 'Presión máx. de entrada de concentrado',
    'Max. Electrode Bleed Pressure': 'Presión máxima de purga de electrodos',
    'Dilute': 'Diluido',
    'Concentrate': 'Concentrado',
    'Electrode': 'Electrodo',
  },
  CF_Unit_Summary: {
    'CF Unit Summary': 'Resumen de la unidad CF',
    'Total Number of CF Unit': 'Número total de unidades CF',
    'CF Unit ID': 'ID de unidad CF',
    'Flow Capacity': 'Capacidad de flujo',
    'Filter Type': 'Tipo de filtro',
    'Design Flow Per TIE': 'Caudal de diseño por TIE',
    'Outlet Pressure': 'Presión de salida',
    'Pressure Drop': 'Caída de presión',
  },
  Chemical_Dosing_Unit_Summary: {
    'Chemical Dosing Unit Summary': 'Resumen de unidad de dosificación química',
    'Total Number of Chemical Dosing': 'Número total de dosificaciones químicas',
    'Dosing Endpoint': 'Punto final de dosificación',
    'Target Value': 'Valor objetivo',
    'Concentration as Metered': 'Concentración medida',
    'Specific Gravity as Metered': 'Gravedad específica medida',
    'Metered Flow Rate': 'Caudal medido',
    'Avg Cons.As Metered': 'Consumo promedio medido',
    'Avg Cons.As Supplied': 'Consumo promedio suministrado',
    'Avg Cons.As Supplied with SF': 'Consumo promedio con factor de seguridad',
    'Sulfuric Acid': 'Ácido sulfúrico',
    'Hydrochloric Acid': 'Ácido clorhídrico',
    'Phosphoric Acid': 'Ácido fosfórico',
    'Nitric Acid': 'Ácido nítrico',
    'Carbon Dioxide': 'Dióxido de carbono',
    'Ammonia': 'Amoníaco',
    'Caustic Soda': 'Sosa cáustica',
    'Slaked Lime': 'Cal apagada',
    'Sodium Carbonate': 'Carbonato de sodio',
    'Calclium Carbonate': 'Carbonato de calcio',
    'Sodium Sulfate': 'Sulfato de sodio',
    'Sodium Cycle Softener': 'Suavizante de ciclo de sodio',
    'Target pH': 'pH objetivo',
    'Total Number of Chemical Type': 'Número total de tipos químicos',
    'Aggregated by Chemical Type – Supplied Form': 'Agregado por tipo químico – Forma suministrada',
    'Chemical Type': 'Tipo químico',
    'Chemical Dosing Unit ID': 'ID de unidad de dosificación química',
    'Concentration as Supplied': 'Concentración suministrada',
    'Specific Gravity as Supplied': 'Gravedad específica suministrada',
    'Total Consumption': 'Consumo total',
    'As Supplied': 'Según forma suministrada',
    'As Supplied with SF': 'Según forma suministrada con factor de seguridad',
  },
  Antiscalant_Dosage_Summary: {
    'Antiscalant Dosage Summary': 'Resumen de dosificación de antincrustante',
    'Dosed In ': 'Dosificado en',
    'Antiscalant': 'Antiincrustante',
    'Dosage in Feed': 'Dosificación en alimentación',
  },
  ERD_Unit_Summary: {
    'ERD Unit Summary (WIP)': 'Resumen de unidad ERD (en proceso)',
    'Total Number of ERD Unit': 'Número total de unidades ERD',
    'ERD Unit ID': 'ID de unidad ERD',
    'ERD Type': 'Tipo de ERD',
    'RO/NF Unit Attached': 'Unidad RO/NF adjunta',
    'Installed Location': 'Ubicación instalada',
    'LP Discharge Pressure': 'Presión de descarga LP',
    'Net Transfer Efficiency': 'Eficiencia neta de transferencia',
    'Boost Pressure': 'Presión de refuerzo',
    'Leakage (Reject in HP OUT)': 'Fuga (rechazo en salida HP)',
    'Mixing at Membrane Feed': 'Mezcla en alimentación de membrana',
    'Total Power Consumption': 'Consumo total de energía',
    'HP Pump': 'Bomba de alta presión',
    'Circulation Pump': 'Bomba de circulación',
    'Energy Recovered': 'Energía recuperada',
    'Power Saving': 'Ahorro de energía',
    'Work Exchanger (WX)': 'Intercambiador de trabajo (WX)',
  },
  Mixer_Splitter_Unit_Summary: {
    'Mixer-Splitter Unit Summary': 'Resumen de la unidad Mezclador-Divididor',
    'Total Number of Mixer-Splitter': 'Número total de Mezclador-Divididor',
    'Mixer-Splitter Unit ID': 'ID de unidad Mezclador-Divididor',
    'Inlet Stream ID': 'ID de corriente de entrada',
    'Outlet Stream ID': 'ID de corriente de salida',
    'Mode': 'Modo',
    'Mix Ratios': 'Proporciones de mezcla',
    'Split Ratios': 'Proporciones de división',
    'calculated': 'calculado',
    'user input': 'entrada del usuario',
    'Mix only': 'Solo mezclar',
    'Split only': 'Solo dividir',
  },
  Detailed_RO_NF_Element_Level_Data: {
    'Detailed RO/NF Element-Level Data': 'Datos detallados por elemento RO/NF',
    'Parameter': 'Parámetro',
    'Stage No': 'Número de etapa',
    'Element Pos.': 'Posición del elemento',
    'Other': 'Otro',
    'Stream Property': 'Propiedad del flujo',
    'Permeate Ion Concentration': 'Concentración de iones en el permeado',
    'Net Driving': 'Impulso neto',
    'Delta Pressure': 'Presión diferencial',
  },
  Winflows_Design_Simulator_Program_Details: {
    'Winflows Design Simulator Program Details': 'Detalles del programa simulador Winflows Design',
    'Program Version': 'Versión del programa',
    'Program Last Update': 'Última actualización del programa',
    'Database Last Update': 'Última actualización de la base de datos',
    'Contact for Technical Support': 'Contacto para soporte técnico',
  },
  Stripper_Unit_Summary: {
    'Stripper Unit Summary': 'Resumen de unidad de desgasificación',
    'Total Number of Stripper': 'Número total de desgasificadores',
    'Outlet CO2 Concentration': 'Concentración de CO₂ en salida',
    'Stripper Unit ID': 'ID de unidad de desgasificación',
    'Outlet H2S Concentration': 'Concentración de H₂S en salida',
    'Outlet NH3 Concentration': 'Concentración de NH₃ en salida',
    'Feed Osm. Pressure': 'Pression osmotique d’alimentation',
  },
  Notification: {
    'FATAL ERROR!! Transmembrane Pressure Limit Exceeded! in ROHP_1 of Stage 1 of element 1 at given temperature.\n\nPlease change design!\nThe applied feed pressure exceeds the limit recommended for at least one of the elements selected. Operation above the maximum pressure can result in element damage, specifically, collapsed permeate channels, which will result in loss of element permeate productivity. \nExcessive pressure can also cause central tube collapse and subsequent element failure. To reduce the operating pressure for the system 1) increase the number of elements in the system, 2) reduce the system recovery, 3) increase the system feed temperature.': '¡ERROR FATAL! ¡Límite de presión transmembrana excedido! en ROHP_1 de la etapa 1 del elemento 1 a la temperatura dada.\n\n¡Cambie el diseño!\nLa presión de alimentación aplicada excede el límite recomendado para al menos uno de los elementos seleccionados. Operar por encima de la presión máxima puede causar daños al elemento, especialmente el colapso de los canales de permeado, lo que resultará en pérdida de productividad.\nLa presión excesiva también puede causar el colapso del tubo central y la falla del elemento. Para reducir la presión de operación:\n1) aumente el número de elementos en el sistema,\n2) reduzca la recuperación del sistema,\n3) aumente la temperatura de alimentación.'
  }
};
export const French = {
  Feed: {
    'Alkalinity & ph': 'Alcalinité et pH',
    'Alkalinity is 0 when pH is below or equal to 4.5': 'L\'alcalinité est de 0 lorsque le pH est inférieur ou égal à 4,5',
    'Anion': 'Anion',
    'Balance': 'Équilibre',
    'Bicarbonate & pH': 'Bicarbonate et pH',
    'Brackish Surfacewater (Conventional)': 'Eaux saumâtres de surface (conventionnelles)',
    'Brackish Surfacewater (MF/UF)': 'Eaux saumâtres de surface (MF/UF)',
    'Brackish Water': 'Eau saumâtre',
    'Brackish Wellwater': 'Eau saumâtres de forage',
    'CO2 & Bicarbonate': 'CO2 & Bicarbonate',
    'Cancel': 'Annuler',
    'Cation': 'Cation',
    'Charge Balance': 'Equilibre des charges',
    'Clear Values': 'Effacer les valeurs',
    'Conductivity': 'Conductivité à 25°C',
    'Density': 'Densité',
    'Density, kg/m3': 'Densité, kg/m3',
    'Do you want clear all the values for the composition': 'Voulez-vous effacer toutes les valeurs de la composition ?',
    'Do you want close the Feed input page': 'Voulez-vous fermer la page de saisie du flux ?',
    'EDI': 'EDI',
    'Failed to fetch default units': 'Échec de la récupération des unités par défaut',
    'Feed': 'Alimentation',
    'Feed Compositions must be a positive number': 'La composition de l´alimentation doit être un nombre positif.',
    'Feed Water Analysis': 'Analyse de l\'eau d\'alimentation',
    'High ph RO 2nd pass': 'pH élevé OI 2ième passage',
    'High ph RO (city/well)': 'OI à pH élevé (ville/puits)',
    'High ph RO Wastewater': 'Eau usée OI à pH élevé',
    'Input': 'Saisir',
    'MBR Permeate': 'Perméat BRM',
    'OK': 'OK',
    'OR': 'OU',
    'Osmotic Pressure': 'Pression osmotique',
    'Parameters': 'Paramètres',
    'Parameters should not be empty': 'Les paramètres ne doivent pas être vides',
    'Please enter water composition': 'Veuillez entrer la composition d\'eau',
    'Pressure': 'Pression',
    'Pressure should not be empty': 'La pression ne doit pas être vide',
    'RO Permeate': 'Perméat OI',
    'Saturation Data (Feed water)': 'Données de saturation (eau d\'alimentation)',
    'Sea Water': 'Eau de mer',
    'Sea Wellwater': 'Eau de puits de mer',
    'Select Ion for Charge Balance': 'Sélectionnez Ion pour l\'équilibre de charge',
    'Select Water Source': 'Sélectionnez la source d\'eau',
    'Select Water Type': 'Sélectionnez le type d\'eau',
    'Sour Water': 'Eau acide',
    'Stiff-Davis Index': 'Indice de Stiff-Davis',
    'Struvite': 'struvite',
    'Supply Pressure': 'Pression d\'alimentation',
    'Surface Seawater (Conventional)': 'Eau de mer de surface (conventionnelle)',
    'Surface Seawater (MF/UF)': 'Eau de mer de surface (MF/UF)',
    'Surface Water': 'Eaux de surface',
    'Sweet Water': 'Eau douce',
    'Temperature': 'Température',
    'Tertiary Treated Wastewater (Conventional)': 'Eaux usées traitement tertiaire (conventionnelles)',
    'Tertiary Treated Wastewater (MF/UF)': 'Eaux usées traitement tertiaire (MF/UF)',
    'Total Alkalinity (ppm CaCO3)': 'Alcalinité totale (ppm CaCO3)',
    'Total Alkalinity is required': 'L\'alcalinité totale est requise',
    'Total Anions': 'Anions totaux',
    'Total Cations': 'Cations totaux',
    'Total Organic Carbon': 'Carbone Organique Total',
    'Upload Water Analysis': 'Télécharger l\'analyse de l\'eau',
    'User Defined': 'Défini par l\'utilisateur',
    'Well Water': 'Eau de forage',
    'pH should not be between 0-14': 'Le pH doit être compris entre 0 et 14',
  },
  EDI: {
    '# of E-Cell EDI Stacks': '# de piles EDI E-Cell',
    'AC Energy (kWh/ m3)': 'Énergie AC (kWh/m3)',
    'AC Power Consumption (kW)': 'Consommation électrique AC (kW)',
    'Apply': 'Appliquer',
    'Are you sure you want to close this form?': 'Voulez vous fermer ce formulaire ?',
    'Blower/Ventilation Sizing for Cl': 'Dimensionnement du ventilateur/ventilation pour Cl',
    'Blower/Ventilation Sizing for Cl2': 'Dimensionnement du ventilateur/ventilation pour Cl2',
    'Blower/Ventilation Sizing for H': 'Dimensionnement du ventilateur/ventilation pour H',
    'Calculated Output Parameters': 'Paramètres de sortie calculés',
    'Cancel': 'Annuler',
    'Co-Current': 'Co-courant',
    'Concentrate Bleed (m3/h)': 'Purge concentrat (m3/h)',
    'Current (Amps)': 'Courant (ampères)',
    'DC power (kW)': 'Puissance DC (kW)',
    'Design': 'Conception',
    'Design Safety Factor': 'Facteur de sécurité de conception',
    'E-Factor': 'Facteur E',
    'Effluent Silica Gaurantee (3 Series)': 'Garantie sur la silice des effluents (série 3, 5)',
    'Effluent Silica Gaurantee (7 Series)': 'Garantie sur la silice des effluents (série 9)',
    'Electrode Bleed': 'Purge d\'électrode',
    'Electrode Bleed (m3/h)': 'Purge d\'électrode (m3/h)',
    'Electrode Gas Generation': 'Génération de gaz d\'électrode',
    'Expected': 'Attendu',
    'Explosion Limit of H2 in Air': 'Limite d\'explosion du H2 dans l\'air',
    'Explosion limit of H2 in Air': 'Limite d\'explosion du H2 dans l\'air',
    'Exposure Limit of Cl2 in Air': 'Limite d\'exposition au Cl2 dans l\'air',
    'Feed Guarantee Guide': 'Guide des garanties d´alimentation',
    'Feed Inlet (m3/h)': 'Entrée d\'alimentation (m3/h)',
    'Feed Pressure (bar)': 'Pression d\'alimentation (bar)',
    'Feed TEA Limitations for Resistivity Gaurantee': 'Limites du TEA pour la garantie de résistivité',
    'Feed Water Specification': 'Spécification de l\'eau d\'alimentation',
    'Feedwater Parameters': 'Paramètres de sortie de l´eau d´alimentation',
    'Flow Per Stack': 'Flux par pile',
    'Gas': 'Gaz',
    'Input': 'Saisir',
    'Maximum': 'Maximum',
    'Maximum Allowable Recovery (%)': 'Récupération maximale autorisée (%)',
    'Note': 'Note',
    'OK': 'OK',
    'Output': 'Sortir',
    'Please enter the required fields': 'Veuillez entrer les champs obligatoires',
    'Please enter the values within range': 'Veuillez entrer les valeurs dans la plage',
    'Predicted Boron Product (ppb B)': 'Produit de bore prévu (ppb B)',
    'Predicted Product Outlet Pressure (bar)': 'Pression de sortie prévue du produit (bar)',
    'Predicted Product Silica Level (ppb SiO2)': 'Produit de silice prévu (ppb SiO2)',
    'Predicted Product Chloride Level (ppb Cl)': 'Niveau de garantie du produit chlorure (ppb Cl)',
    'Product Flow Rate': 'Débit du produit',
    'Product Resistivity (MΩ.cm)': 'Résistivité du produit (MΩ.cm)',
    'Product Silica Guarantee Level (ppb SiO2)': 'Niveau de garantie du produit silice (ppb SiO2)',
    'Predicted Product Sodium Level (ppb Na)': 'Niveau de garantie du sodium du produit (ppb Na)',
    'Predicted Product Sulfate Level (ppb SO4)': 'Niveau de garantie des sulfates du produit (ppb SO4)',
    'Range': 'Gamme',
    'Rectifier DC Output (Volts)': 'Sortie DC du redresseur (Volts)',
    'Rectifier DC Output': 'Sortie DC du redresseur',
    'Rectifier DC output': 'Sortie DC du redresseur',
    'Rectifier Efficiency': 'Efficacité du redresseur',
    'Rectifier efficiency': 'Efficacité du redresseur',
    'Select': 'Sélectionner',
    'Stack Model': 'Modèle de pile',
    'Status': 'Statut',
    'System Parameters': 'Paramètres de sortie du système',
    'Target Resistivity (MΩ.cm)': 'Résistivité cible (MΩ.cm)',
    'Target Resistivity': 'Résistivité cible',
    'Target Silica Gaurantee (ppb SiO2)': 'Garantie Target Silice (ppb SiO2)',
    'Target Silica Gaurantee': 'Garantie Target Silice',
    'Target Silica guarantee': 'Garantie Target Silice',
    'Units': 'Unités',
    'Value': 'Valeur',
    'Ventilation Blower/Fan Size': 'Taille du ventilateur/ventilateur',
    'Ventilation Sizing': 'Dimensionnement de la ventilation',
    'Voltage (Volts)': 'Tension (Volts)',
    'Upstream Interconnecting Piping Pressure Loss': "Perte de pression dans les tuyauteries d'interconnexion en amont",
    'RO permeate pressure must be at least 0.34 bar | 5 psi higher than E-Cell feed pressure to account for pressure loss in piping between RO permeate and E-Cell feed': "La pression du perméat RO doit être au moins 0,34 bar | 5 psi supérieure à la pression d'alimentation E-Cell pour tenir compte de la perte de pression dans la tuyauterie entre le perméat RO et l'alimentation E-Cell",
    'System Product Flow': 'Flux de produits du système',
    'Conductivity (µS/cm @ 25°C)': 'Conductivité (µS/cm à 25°C)'
  },
  RO: {
    'Recovery (%)': 'Récupération (%)',
    'Add New Row': 'Ajouter une nouvelle ligne',
    '0.5 Means that the elements only gives half the permeate flow rate as of the nominal element': '"0.5 signifie que l\'élément ne donne que la moitié du débit nominal de perméat de l\'élément"',
    '1.5 means that the salt passage is 1.5 times higher than that of the nominal element': '"1.5 signifie que le passage du sel est 1,5 fois supérieur à celui nominal de l\'élément"',
    'A-Value Factor': 'Facteur de valeur A',
    'Activate Argo Analyzer': 'Activer l\'analyseur Argo',
    'Aluminium in Conc (ppm)': 'Aluminium dans le concentrat (ppm)',
    'Antiscalant Dosage': 'Dosage de l\'antitartre',
    'Application': 'Application',
    'Apply': 'Appliquer',
    'Area': 'Zone',
    'Argo Analyzer': 'Analyseur Argo',
    'Array Recovery': 'Récupération de l´arrangement',
    'Average Flux': 'Flux moyen',
    'B-Value Factor': 'Facteur de valeur B',
    'Boost Energy Efficiency %': 'Efficacité énergétique du booster %',
    'Boost Energy Efficiency % must be in the range 10-100': 'L´efficacité énergétique doit être comprise entre 10 et 100',
    'CLRO Parameters': 'Paramètres CLRO',
    'Cancel': 'Annuler',
    'Compare': 'Comparer',
    'Concentrate composition calculated by Winflows': 'Composition du concentrat calculée par Winflows',
    'Copy RO Machine Configuration': 'Copier la configuration de la machine OI',
    'Design Guidelines': 'Directives de conception',
    'Do you want to close the RO input page?': 'Voulez-vous fermer le formulaire de saisie ?',
    'Element Age (yr)': 'Âge de l\'élément (an)',
    'Element Age (yr) must be in the range 0-10': 'L\'âge de l\'élément (année) doit être compris entre 0 et 10',
    'Element Age Calculator': 'Calculateur d\'âge des éléments',
    'Element Group': 'Groupe d\'éléments',
    'Element Info': 'Informations sur l\'élément',
    'Element Model': 'Modèle d\'élément',
    'Elements per Vessel': 'Éléments par tube de pression',
    'Elements per Vessel must be in the range 0-8': 'Les éléments par tube doivent être compris entre 0 et 8',
    'Enter valid data in Pressure Vessels, Elements Per Vessel and Element Type': 'Saisissez des données valides dans les champs Tube de pression, Éléments par tube et Type d\'élément',
    'Feed Pressure': 'Pression d\'alimentation',
    'Flux Annual % Change': 'Variation annuelle en %',
    'Input A Value Factor & B Value Factor': 'Entrez le facteur de valeur A et le facteur de valeur B',
    'InterStage Boost Pressure': 'Pression de suralimentation inter-étages',
    'InterStage Pressure Loss': 'Perte de pression entre les étages',
    'InterStage Pressure Loss must be in the range': 'La perte de pression entre les étages doit être comprise dans la plage',
    'Max Pressure': 'Pression maximale',
    'No options': 'Aucune option',
    'Nominal Flow': 'Débit nominal',
    'OK': 'OK',
    'OutPut': 'Produit',
    'Permeate Flow Rate': 'Débit de perméat',
    'Permeate Pressure': 'Pression du perméat',
    'Permeate Pressure must be in the range': 'La pression du perméat doit être comprise dans la plage',
    'Please populate the previous row(s) !': 'Veuillez remplir la ou les lignes précédentes !',
    'Pressure Vessels': 'Tubes de pression',
    'Pressure Vessels must be in the range 0-999': 'Les tubes de pression doivent être compris entre 0 et 999',
    'Pressure drop during brine purge': 'Perte de charge pendant la purge de la saumure',
    'Product TDS': 'TDS du perméat',
    'RO Element Data': 'Données des éléments d´OI',
    'RO Parameters': 'Paramètres OI',
    'RO Permeate': 'Perméat OI',
    'RO Recovery': 'Récupération OI',
    'RO Recovery, %': 'Récupération OI, %',
    'Recovery Per Circuit must be in the range 0-100%': 'La récupération par circuit doit être comprise entre 0 et 100 %',
    'Recovery must be in the range 0-100%': 'La récupération doit être comprise entre 0 et 100 %',
    'Recovery per circuit': 'Récupération par circuit',
    'Recycle Permeate from Last Stage to Feed Pump': 'Recycler le perméat du dernier étage vers la pompe d\'alimentation',
    'Rejection': 'Réjection',
    'Results': 'Résultats',
    'Salt Passage Annual % Change': 'Changement annuel en % du passage en sel',
    'Saturation Indices': 'Indices de saturation',
    'Select Hypersperse Products': 'Sélectionnez les produits Hypersperse',
    'Select Region': 'Choisissez une région',
    'Spacer per Vessel must be in the range 0-8': 'L\'espacement par tube doit être compris entre 0 et 8',
    'Spacers per Vessel': 'Espaceurs par tube',
    'Spec File is not available for this Element.': 'Le fichier de spécifications n\'est pas disponible pour cet élément',
    'Split Permeate (Upstream Part)': 'Perméat divisé (partie en amont)',
    'Stage': 'Etage',
    'Sum of Element per Vessel & Spacers per Vessel must be <= 8': 'La somme des éléments par tube et des entretoises par tube doit être <= 8',
    'Test': 'Test',
    'Test Pressure': 'Pression de test',
    'Total holdup Volume': 'Volume total de rétention',
    'Type': 'Type',
    'Use Element Age and Annual % Change': 'Utiliser l\'âge de l\'élément et le pourcentage de changement annuel',
    'Winflows Design Simulator RO Elements Design Guidelines': 'Simulateur de conception Winflows Directives de conception des éléments RO',
    'Winflows RO Elements Design Guidelines': 'Directives de conception des éléments Winflows OI',
    'by': 'par',
    'Winflows Report': 'Rapport Winflows',
    'Generate': 'Générer',
    'RO Permeate flow': 'Flux de perméat RO',
    'RO Recovery rate': 'Taux de récupération RO',
    'Recovery during brine purge': 'Récupération pendant la purge de saumure',
    'Feed Flow (per PV) during brine purge': 'Débit d\'alimentation (par PV) pendant la purge de saumure',
    'Recovery during brine purge should be between 0 – 20': 'La récupération pendant la purge de saumure doit être comprise entre 0 et 20'
  },
  Header: {
    'About': 'À propos',
    'Design Guidelines': 'Directives de conception',
    'Element Cross Reference List': "Liste de références croisées d'éléments",
    'Give File Name': 'Donnez le nom du fichier',
    'Help': 'Aide',
    'Language': 'Langue',
    'RO Design Guidelines Tips': 'Conseils sur les directives de conception OI',
  },
  Landing: {
    '# of Elements': '# d\'éléments',
    'All': 'Tous',
    'Application': 'Application',
    'Application Wizard': 'Assistant d\'application',
    'Apply': 'Appliquer',
    'Archive': 'Archive',
    'Are you sure you want to delete it?': 'Etes-vous sûr de vouloir le supprimer?',
    'Array': 'Tableau',
    'Choose any one parameter': 'Choisissez un des paramètres',
    'Choose any RO Machine to Display the Data': 'Choisissez ne des machines d´OI pour afficher les données',
    'Select Equipment Model': 'Sélectionnez le modèle d\'équipement',
    'Clear All': 'Tout effacer',
    'Created On': 'Créé sur',
    'Current': 'Actuel',
    'Design Flowsheet': 'Schéma de conception',
    'Element Model': 'Modèle d\'élément',
    'Enter name to Search': 'Entrez le nom pour rechercher',
    'Error while deleting file': 'Erreur lors de la suppression du fichier',
    'FactSheet': 'Fiche technique',
    'Failed to fetch Ro Machine record': 'Échec de la récupération de l\'enregistrement de la machine OI',
    'Feed Flow': 'Flux d\'alimentation',
    'Feed Water': 'Eau d\'alimentation',
    'File deleted succesfully': 'Fichier supprimé avec succès',
    'File Name': 'Nom de fichier',
    'File shared successfully!.': 'Fichier partagé avec succès !',
    'Flow Sheet Details': 'Détails du schéma de flux',
    'Flow Sheet Type': 'Type de schéma de traitement',
    'Flux': 'Flux',
    'Integrated RO-EDI': 'RO-EDI intégré',
    'Last Edited On': 'Dernière modification le',
    'Multi-Pass Design': 'Conception multi-passes',
    'My Projects': 'Mes projets',
    'No options': 'Aucune option',
    'No Result Found!': 'Aucun résultat trouvé!',
    'OR': 'OU',
    'Open': 'Ouvrir',
    'Open File': 'Fichier ouvert',
    'Permeate Flow Rate': 'Débit de perméat',
    'Permeate Flow Rate must not be empty': 'Le débit de perméat ne doit pas être vide.',
    'Pre Treatment': 'Pré-traitement',
    'Pre-Configured Design': 'Conception préconfigurée',
    'Project Details (Quick view)': 'Détails du projet (aperçu rapide)',
    'Project Name': 'Nom du projet',
    'Recent Files': 'Fichiers récents',
    'Recent Search': 'Recherche récente',
    'Result': 'Résultat',
    'RO-EDI Equipment Selector': 'Sélecteur d\'équipement OI-EDI',
    'See Result': 'Voir le résultat',
    'Shared by': 'Partagé par',
    'Shared Projects': 'Projets partagés',
    'Single-Pass Design': 'Conception à une passe',
    'Submit': 'Soumettre',
    'Template Library': 'Bibliothèque de modèles',
    'Tutorial': 'Didacticiel',
    'Type here…': 'Écrivez ici…',
    'Unread': 'Non lu',
    'Welcome to': 'Bienvenue à',
    'Nominal Permeate Flow Rate': 'Débit nominal de perméat',
    'Choose any RO-EDI Equipment Model to Display the Data': 'Choisissez un des modèles d’équipement OI-EDI pour afficher les données',
    'Please use the RO-EDI Equipment Selector. Please consult Veolia for further support.': 'Veuillez utiliser le sélecteur d\'équipement OI-EDI. Veuillez consulter Veolia pour obtenir une assistance supplémentaire.',
    'Potable Water': 'Eau Potable',
    'Beverage Production': 'Production de boissons',
    'Potable Water - Low Boron': 'Eau potable – Faible teneur en bore',
    'Demineralization': 'Déminéralisation',
    'Reuse': 'Réutilisation',
    'Reuse - High Purity': 'Réutilisation - Haute Pureté',
    'Ultrapure Water': 'Eau ultra pure',
    'RO Permeate Polishing': 'Polissage du perméat RO',
    'Water Softening': "Adoucissement de l'eau",
    'City Water': 'Eau de ville',
    'Conventional': 'Conventionnelle',
    'MF/UF': 'MF/UF',
    'Logout': 'Déconnexion',
    'Winflows Design Simulator': 'Simulateur de conception Winflows',
    'Received Projects': 'Projets reçus'
  },
  ProjectInfo: {
    'Email': 'E-mail',
    'Engineer': 'Ingénieur',
    'Enter Notes here...': 'Entrez les notes ici...',
    'Location': 'Emplacement',
    'Ok': 'OK',
    'Phone': 'Téléphone',
    'Project Info': 'Informations sur le projet',
    'Project Name*': 'Nom du projet*',
  },
  Pump: {
    'Are you sure you want to close this form?': 'Voulez-vous fermer ce formulaire ?',
    'Auto Efficiencies': 'Efficacités automatiques',
    'Average Discharge Pressure': 'Pression de décharge moyenne',
    'Cancel': 'Annuler',
    'Discharge Pressure': 'Décompresser',
    'Flow Rate': 'Débit',
    'Inlet Pressure': 'Pression d\'entrée',
    'Motor Efficiency': 'Efficacité du moteur',
    'OK': 'OK',
    'Power': 'Puissance',
    'Pump Efficiency': 'Efficacité de la pompe',
    'Pump Specification': 'Spécification de la pompe',
    'VFD Efficiency': 'Efficacité du VFD',
    'Power Consumption': 'Consommation d\'Énergie',
    'Combined Efficiency': 'Efficacité Combinée',
    'RO/NF Unit Attached': 'Unité RO/NF Attachée'
  },
  Cartridge: {
    'Actual Flow per TIE': 'Débit réel par TIE',
    'Cancel': 'Annuler',
    'Cartridge Filter': 'Filtre à cartouche',
    'Do you want to close the CF input page?': 'Voulez-vous fermer la page de saisie ?',
    'Filter': 'Filtre',
    'Filter DP': 'Perte de charge DP',
    'Flow per TIE': 'Débit par TIE',
    'Flow Sheet is not available for this Element.': 'La fiche technique de cet élément n\'est pas disponible actuellement.',
    'Micron': 'Micron',
    'Number of Filters': 'Nombre de filtres',
    'OK': 'OK',
    'View Fact Sheet': 'Voir la fiche technique',
    'Flow Capacity': 'Capacité de Débit',
    'Filter Type': 'Type de Filtre',
    'Design Flow Per TIE': 'Débit de Conception par TIE',
    'Outlet Pressure': 'Pression de Sortie',
    'Pressure Drop': 'Chute de Pression'
  },
  Stripper: {
    'Activate': 'Activer',
    'Are you sure you want to close this form?': 'Voulez-vous fermer ce formulaire ?',
    'Cancel': 'Annuler',
    'OK': 'OK',
    'Outlet CO2 concentration': 'Concentration de CO2 en sortie',
    'Outlet H2S concentration': 'Concentration de H2S en sortie',
    'Outlet NH3 concentration': 'Concentration de NH3 en sortie',
    'Stripper': 'Strippeur',
  },
  MixSplit: {
    'Apply': 'Appliquer',
    'Are you sure you want to close this form?': 'Voulez-vous fermer ce formulaire ?',
    'Cancel': 'Annuler',
    'Flow Rate': 'Débit',
    'Note': 'Note',
    'Number of Outlet Streams': 'Nombre de flux de sortie',
    'OK': 'OK',
    'Split Fraction': 'Fraction divisée',
    'Split Fraction of individual streams should be in the range of 0-1 and sum of all split fractions should be 1.': 'La fraction individuelle du flux divisé doit être comprise entre 0 et 1 et la somme de toutes les fractions doit être égale à 1.',
    'Split fraction(s) must not be empty': 'Les fractions ne doivent pas être vides',
    'Splitter': 'Séparateur',
    'Stream Name': 'Nom du flux',
    'Stream Values should be between 0 and 1': 'Les valeurs du flux doivent être comprises entre 0 et 1',
    'Sum of Split fraction(s) is 1 or more. Please review your input': 'La somme des fractions est supérieure à 1. Veuillez vérifier leurs distributions.',
    'Sum of split fraction(s) should be 1.0': 'La somme des fractions doit être égale à 1.',
    'Total stream values must be between 0 and 1': 'Les valeurs totales du flux doivent être comprises entre 0 et 1',
  },
  ChemDose: {
    'Apply': 'Appliquer',
    'Are you sure you want to close this form?': 'Voulez-vous fermer ce formulaire ?',
    'Average Consumption as Supplied': 'Consommation moyenne fournie',
    'Average Consumption as metered': 'Consommation moyenne mesurée',
    'Cancel': 'Annuler',
    'Carbon Dioxide': 'Gaz carbonique',
    // 'Caustic Soda': 'Soude Caustique',
    'Chemical': 'Chimique',
    'Chemical Dosing': 'Dosage de produits chimiques',
    'Chemical Selection': 'Sélection de produits chimiques',
    'Close': 'Fermer',
    'Dosage Rate': 'Taux de dosage',
    'Dosage Rate must be positive': 'Le débit de dosage doit être positif',
    'Dosing Control': 'Contrôle du dosage',
    'Hardness Leakage': 'Fuite de dureté',
    'Hardness Leakage must be positive': 'La fuite de dureté doit être positive',
    'Hydrochloric Acid': 'Acide hydrochlorique',
    'Input': 'Saisir',
    'LSI must be between -3 and 3': 'LSI doit être compris entre -3 et 3',
    'Mass flow Rate': 'Débit massique',
    'Mass Flow Rate': 'Débit massique',
    'Metered Concentration': 'Concentration mesurée',
    'Metered Concentration must be between 0 and 100': 'La concentration mesurée doit être comprise entre 0 et 100',
    'Metered Gravity at supplied Concentration must be positive': 'La gravité mesurée à la concentration fournie doit être positive',
    'Nitric Acid': 'Acide nitrique',
    'OK': 'OK',
    'Output': 'Produit',
    'Phosphoric Acid': 'Acide phosphorique',
    'Please enter the chemical name': 'Veuillez entrer le nom du chimique',
    'Please enter the required fields': 'Veuillez compléter les champs obligatoires',
    'Safety Factor': 'Facteur de sécurité',
    'Safety Factor must be positive': 'Le facteur de sécurité doit être positif',
    'Select': 'Sélectionner',
    'Slacked Lime': 'Chaux éteinte',
    'Sodium Cycle Softener': 'Adoucisseur du cycle de sodium',
    'Specific Gravity at metered Concentration': 'Gravité spécifique à la concentration mesurée',
    'Specific Gravity at supplied Concentration': 'Gravité spécifique à la concentration fournie',
    'Specific Gravity at supplied Concentration must be positive': 'La gravité spécifique à la concentration fournie doit être positive',
    'Sulfuric Acid': 'Acide sulfurique',
    'Supplied Concentration': 'Concentration fournie',
    'Supplied Concentration must be between 0 and 100': 'La concentration fournie doit être comprise entre 0 et 100',
    'Supplied Form': 'Formulaire fourni',
    'Supplied/Delivered consumption with safety factor': 'Fourniture/Consommation livrée avec facteur de sécurité',
    'Target Alkalinity': 'Alcalinité cible',
    'Target LSI': 'LSI cible',
    'Usage': 'Usage',
    'Usage must be between 0 and 100': 'L\'utilisation doit être comprise entre 0 et 100',
    'Volume Flow Rate': 'Débit volumique',
    'pH must be between 0 and 14': 'Le pH doit être compris entre 0 et 14',
  },
  ERD: {
    'Are you sure you want to close this form?': 'Voulez-vous fermer ce formulaire ?',
    'Circulation Pump Efficiency': 'Efficacité de la pompe de circulation',
    'Circulation Pump Motor Efficiencies': 'Efficacité du moteur de la pompe de circulation',
    'Circulation Pump VFD Efficiencies': 'Efficacité du VFD de la pompe de circulation',
    'Circulation/Booster Pump': 'Pompe de circulation/surpression',
    'Cost of Power': 'Coût de l\'électricité',
    'Differential Pressure HP Side': 'Pression différentielle côté HP',
    'Differential Pressure LP Side': 'Pression différentielle côté BP',
    'Efficiency': 'Efficacité',
    'Energy Recovery Device': 'Dispositif de récupération d\'énergie',
    'Feedwater Salinity': 'Salinité de l\'eau d\'alimentation',
    'HP Power Consumed': 'Puissance HP consommée',
    'HP Pump Efficiency': 'Efficacité de la pompe HP',
    'HP Pump Motor Efficiency': 'Efficacité du moteur de la pompe HP',
    'Input Parameters': 'Paramètres d\'entrée',
    'Leakage (reject in HP out stream)': 'Fuite (rejet dans HP out stream)',
    'Lubrication Flow': 'Flux de lubrification',
    'Lubrication Per Array': 'Lubrification par zone',
    'Manual or Auto Efficiencies': 'Efficacité manuelle ou automatique',
    'Membrane Differential Pressure': 'Pression différentielle membranaire',
    'Mixing at Membrane Feed': 'Mélange de l\'alimentation membranaire',
    'Model': 'Modèle',
    'Motor Efficiency': 'Efficacité du moteur',
    'Number of Units': 'Nombre d\'unités',
    'OK': 'OK',
    'Parameter': 'Paramètre',
    'Power Consumed': 'Puissance consommée',
    'Power Consumption': 'Puissance consommée',
    'Power Cost Saved': 'Coût de l\'énergie économisé',
    'Power Savings': 'Économies d\'énergie',
    'Pressure Exchanger': 'Échangeur de pression',
    'Pressure Exchanger Performance': 'Performances de l\'échangeur de pression',
    'Pressure Exchanger Power results': 'Résultats de puissance de l’échangeur de pression',
    'Pump Efficiency': 'Efficacité de la pompe',
    'RO Feed Pressure': 'Pression d\'alimentation RO',
    'RO Permeate Flow': 'Flux de perméat RO',
    'RO Recovery Rate': 'Taux de récupération RO',
    'Specific Power Consumption': 'Consommation d\'énergie spécifique',
    'Total Power Consumption': 'Consommation totale d\'énergie',
    'Unit': 'Unité',
    'Unit Flow': 'Débit unitaire',
    'VFD Efficiency': 'Efficacité du VFD',
    'Values': 'Valeurs',
    'Work Exchanger': 'Échange de travail',
    'Work Exchanger Performance': 'Performances de l\'échangeur de travail',
    'Work Exchanger Power results': 'Résultats de la puissance de l\'échangeur de travail',
  },
  PW: {
    'Are you sure you want to close this form?': 'Voulez-vous fermer ce formulaire ?',
    'Cost of Power': 'Coût de l\'électricité',
    'Electricity Generated (Mechanical Energy Recovered)': 'Électricité produite (énergie mécanique récupérée)',
    'Feedwater Salinity': 'Salinité de l\'eau d\'alimentation',
    'HP Motor Electrical Power': 'Puissance électrique du moteur HP',
    'HP Motor Shaft Power': 'Puissance de l\'arbre du moteur HP',
    'HP Pump Efficiency': 'Efficacité de la pompe HP',
    'HP Pump Motor Efficiency': 'Efficacité du moteur de la pompe HP',
    'HP Pump Shaft Power': 'Puissance de l\'arbre de la pompe HP',
    'Input Parameters': 'Paramètres d\'entrée',
    'Low P Discharge Pressure': 'Pression de décharge faible P',
    'Membrane Differential Pressure': 'Pression différentielle membranaire',
    'Net Transfer Efficiency': 'Efficacité de transfert nette',
    'OK': 'OK',
    'Parameter': 'Paramètre',
    'Pelton Wheel': 'Roue Pelton',
    'Pelton wheel Performance': 'Performances de la roue Pelton',
    'Power Cost Saved': 'Montant de l\'énergie économisé',
    'Power Savings': 'Économies d\'énergie',
    'RO Feed Pressure': 'Pression d\'alimentation OI',
    'RO Permeate Flow': 'Flux de perméat OI',
    'RO Recovery Rate': 'Taux de récupération OI',
    'Specific Power Consumption': 'Consommation d\'énergie spécifique',
    'Total Power Consumption': 'Consommation totale d\'énergie',
    'Turbine Efficiency': 'Efficacité des turbines',
    'Unit': 'Unité',
    'Values': 'Valeurs',
  },
  TC: {
    'Are you sure you want to close this form?': 'Voulez-vous fermer ce formulaire ?',
    'Boost Pressure': 'Pression de suralimentation',
    'Cost of Power': 'Coût de l\'électricité',
    'Energy Recovered': 'Énergie récupérée',
    'Feedwater Salinity': 'Salinité de l\'eau d\'alimentation',
    'HP Power Consumed': 'Puissance HP consommée',
    'HP Pump Efficiency': 'Efficacité de la pompe HP',
    'HP Pump Motor Efficiency': 'Efficacité du moteur de la pompe HP',
    'Input Parameters': 'Paramètres d\'entrée',
    'Low P Discharge Pressure': 'Pression de décharge faible P',
    'Membrane Differential Pressure': 'Pression différentielle membranaire',
    'Net Transfer Efficiency': 'Efficacité de transfert nette',
    'OK': 'OK',
    'Parameter': 'Paramètre',
    'Power Cost Saved': 'Coût de l\'énergie économisé',
    'Power Savings': 'Économies d\'énergie',
    'RO Feed Pressure': 'Pression d\'alimentation OI',
    'RO Permeate Flow': 'Flux de perméat OI',
    'RO Recovery Rate': 'Taux de récupération OI',
    'Specific Power Consumption': 'Consommation d\'énergie spécifique',
    'Total Power Consumption': 'Consommation totale d\'énergie',
    'Turbo Charger': 'Turbocompresseur',
    'Turbo Charger Performance': 'Performance du turbocompresseur',
    'Turbo Charger Placement': 'Placement du turbocompresseur',
    'Turbo Inlet Pressure': 'Pression d\'entrée du turbo',
    'Turbo Outlet Pressure': 'Pression de sortie du turbo',
    'Unit': 'Unité',
    'Values': 'Valeurs',
  },
  CIP: {
    'CIP Calculator': 'Calculateur CIP',
    'CIP Report': 'Rapport CIP',
    'Calculator': 'Calculateur',
    'Cleaner Strength': 'Force du nettoyant',
    'Cleaner Type': 'Type de nettoyant',
    'Cleaning Step': 'Étape de nettoyage',
    'Cleaning Strategies based on Foulant type': 'Stratégies de nettoyage en fonction du type d\'encrassement',
    'Element': 'Élément',
    'Element/Vessel': 'Élément/Tube',
    'Foulant Type': 'Foulant Type',
    'Get Report': 'Obtenir un rapport',
    'Liquid': 'Liquide',
    'Maintenance Clean': 'Nettoyage d\'entretien',
    'Membrane Material': 'Matériau de la membrane',
    'NSF Approved': 'Approuvé par NSF',
    'No of RO Trains': 'Nombre de trains d´OI',
    'No of Stages': 'Nombre d\'étages',
    'No of Vessels': 'Nombre de tube de pression',
    'Powder': 'Poudre',
    'Print': 'Imprimer',
    'Pump Flow rate': 'Débit de la pompe',
    'Quantity of Cleaner': 'Quantité de nettoyant',
    'Registration': 'Inscription',
    'Select': 'Sélectionner',
    'Single Product': 'Produit unique',
    'Solution Volume': 'Volume de la solution',
    'Stage': 'Etage',
    'Stages Cleaned in Parallel': 'Étages nettoyées en parallèle',
    'Stages Cleaned in Series': 'Étages nettoyées en série',
    'Standard': 'Standard',
    'System Design': 'Conception du système',
    'Total': 'Total',
    'Vol in CIP piping': 'Volume dans les tuyauteries CIP',
    'Vol in CIP tank': 'Volume dans le réservoir CIP',
    'Text 1 CIP': 'Le nettoyage est un processus complexe qui nécessite des informations sur le ou les salissures réelles afin de définir la meilleure stratégie CIP et les meilleurs produits à utiliser. Les recommandations fournies dans cet outil de sélection sont des lignes directrices générales destinées à faciliter la sélection des produits.',
    'Text 2 CIP': "Idéalement, une analyse des salissures devrait être utilisée dans le processus de sélection du nettoyant. Si une analyse des salissures n'est pas disponible, consultez le menu déroulant ci-dessus et faites une supposition éclairée.",
    'Text 3 CIP': "L'outil permet de sélectionner uniquement l'encrassement à la fois. Pour les combinaisons d'encrassements, consultez la « Sélection recommandée pour les encrassements mixtes » dans le menu déroulant.",
    'Text 4 CIP': "Pour des scénarios complexes ou s'il y a eu des difficultés à atteindre les résultats attendus, veuillez contacter l'équipe des applications de produits MemChem pour obtenir de l'aide dans l'identification d'options et de produits alternatifs."
  },
  Notification_Modal: {
    'Are you sure you want to close this form?': 'Voulez-vous fermer ce formulaire ?',
    'Choose Report Options': 'Choisissez les options du rapport',
    'Custom': 'Personnalisé',
    'Default units have been saved successfully.': 'Les unités par défaut ont été enregistrées avec succès.',
    'Display Units': 'Unités d\'affichage',
    'Do you want to clear the canvas?': 'Voulez-vous effacer la trame ?',
    'Do you want to close the page?': 'Voulez-vous fermer la page ?',
    'Do you want to delete this unitop?': 'Voulez-vous supprimer cet unité ?',
    'Do you want to save the file?': 'Voulez-vous enregistrer le fichier ?',
    'Failed to load Default units.': 'Échec du chargement des unités par défaut.',
    'Failed to load win files': 'Échec du chargement des fichiers Win',
    'Feed flow': 'Flux d\'alimentation',
    'Flow': 'Débit',
    'Flowsheet is either empty or incomplete...': 'Le schéma de traitement est soit vide, soit incomplet...',
    'Flowsheet is solved successfully.': 'Le schéma de traitement est résolu avec succès.',
    'Flowsheet solved with errors.': 'Schéma de traitement résolu avec des erreurs.',
    'Flowsheet solving has failed.': 'La résolution du schéma de traitement a échoué.',
    'Flux': 'Flux',
    'Generate PDF': 'Générer un PDF',
    'Generate Sheets': 'Générer en tableur',
    'International': 'International',
    'Ion Composition': 'Composition ionique',
    'Kindly enter valid filename!': 'Veuillez entrer un nom de fichier valide !',
    'Kindly save the file before sharing!': 'Veuillez enregistrer le fichier avant de le partager !',
    'Load': 'Charger',
    'Load Winflows Design Simulator file': 'Charger le fichier Winflows Design Simulator',
    'Loading Please wait...': 'Chargement, veuillez patienter...',
    'My Files': 'Mes dossiers',
    'No': 'Non',
    'OK': 'OK',
    'Please add/update specify flow values!': 'Veuillez ajouter/mettre à jour les valeurs de débit spécifiées !',
    'Power': 'Puissance',
    'Pressure': 'Pression',
    'Product flow': 'Écoulement du produit',
    'Product Flow': 'Écoulement du produit',
    'Reminder': 'Rappel',
    'Saturation Data': 'Données de saturation',
    'Save as Default': 'Enregistrer par défaut',
    'Select file to upload': 'Sélectionnez le fichier à télécharger',
    'Shared By Others': 'Partagé par d\'autres',
    'Solver Message': 'Message du solveur',
    'Specify Flow': 'Flux spécifié',
    'Stream Data': 'Flux de données',
    'Stream Properties': 'Propriétés du flux',
    'Streams': 'Courant',
    'System Recovery': 'Récupération du système',
    'Temperature': 'Température',
    'US': 'USA',
    'Upload File': 'Télécharger un fichier',
    'Volume': 'Volume',
    'Yes': 'Oui',
    'You cannot share empty flowsheet !': 'Vous ne pouvez pas partager un schéma vide !',
    'Successfully Done': 'Réalisé avec succès',
    'File saved successfully.': 'Fichier enregistré avec succès.',
    'File Share': 'Partage de fichiers',
    'Subject': 'Sujette',
    'Message': 'Message',
    'Share': 'Partager',
    'Enter all input fields': 'Entrez tous les champs de saisie',
    'Enter any one input field': "Entrez n'importe quel champ de saisie",
    'Automate Stream ID': "Automatiser l'identification du flux",
    'Quick Results': 'Résultats rapides',
    'ARGO Analyzer Report': "Rapport de l'analyseur ARGO",
    'Notifications': 'Notifications',
    'Do you want to save the file ?': 'Voulez-vous enregistrer le fichier ?',
    'Please select your country from the list given.': 'Veuillez sélectionner votre pays dans la liste proposée.',
    'This selection allows Winflows to provide you with region-specific antiscalant options.': 'Cette sélection permet à Winflows de vous proposer des options antitartre spécifiques à la région.',
    'Important: Your country selection is permanent and cannot be changed after submission.': 'Important : Votre sélection de pays est permanente et ne peut pas être modifiée après la soumission.',
    'Failed to load saved win file': 'Échec du chargement du fichier Win enregistré',
    'RO Machine not available': 'Machine RO non disponible',
    'Entered stream number is duplicated!': 'Le numéro de flux saisi est dupliqué !',
    'Failed to fetch Units': 'Échec de la récupération des unités',
    'Failed to fetch DB transaction record': 'Impossible de récupérer le journal des transactions de la base de données',
    'Failed to fetch feed input.': "Échec de la récupération de l'entrée du flux.",
    'File seems empty, please create the flowsheet!': 'Le fichier semble vide, veuillez créer le schéma de traitement !',
    'Failed to save flow file': "Échec de l'enregistrement du fichier de flux",
    'Failed to fetch file list': 'Échec de la récupération de la liste des fichiers',
    'Failed to save feed input.': "Échec de l'enregistrement de l'entrée de flux.",
    'Failed to load win-4 files': 'Échec du chargement des fichiers Win-4',
    'Somthing is wrong.': 'Quelque chose ne va pas.',
    'failed to download the file': 'échec du téléchargement du fichier',
    'Something went wrong': "Quelque chose s'est mal passé",
    'Failed to fetch Flowsheet Selection record': "Échec de la récupération de l'enregistrement de sélection de feuille de calcul",
    'No Data Found': 'Aucune donnée trouvée',
    'Please enter valid filename': 'Veuillez entrer un nom de fichier valide',
    'Please provide a new name for the unitop as the current one is already available on the flowsheet.': "Veuillez fournir un nouveau nom pour l'Unitop, car le nom actuel est déjà disponible sur le schéma de traitement.",
    'connections are incomplete!': 'les connexions sont incomplètes !',
    'Unitop inputs are either incomplete or incorrect!': 'Les entrées Unitop sont soit incomplètes, soit incorrectes !',
    'Only one instance of Argo Analyzer can be used in a flowsheet.': 'Une seule instance d’Argo Analyzer peut être utilisée dans un schéma de traitement.',
    'Winflows Design Simulator detects multiple feed sources on the current flowsheet. Please input the flow rate for the respective feed source.': "Winflows Design Simulator détecte plusieurs sources de flux sur le schéma de traitement actuel. Veuillez saisir le débit pour la source d'alimentation respective.",
    'Enter all input field values!': 'Entrez toutes les valeurs des champs de saisie !',
    'Permeate Flux': 'Flux de perméat',
    'Recovery': 'Récupération',
    'Explorer': 'Exploratrice',
    'Average': 'Moyenne',
    'Element Max': 'Élément maximum',
    'Vessels': 'Navires',
    'No. of Elements': "Nombre d'éléments",
    'Element Type': "Type d'élément",
    'Conc. Flow': 'Conc. Couler',
    'Perm Flow': 'Débit permanent',
    'Age': 'Âge',
    'Saturation Data(Concentrate)': 'Données de saturation (concentré)',
    'Last Element Beta': 'Bêta du dernier élément',
    'Delta Pressure': 'Pression Delta',
    'Avg.': 'Moy.',
    'Feed TDS': 'Nourrir le TDS',
    'Perm TDS': 'TDS permanent',
    'A-Value ACP': 'Valeur A ACP',
    'B-Value ACP': 'Valeur B ACP',
    'A-Factor': 'Facteur A',
    'B-Factor': 'Facteur B',
    'Element No.': "Numéro d'élément",
    'Net Pressure': 'Pression nette',
    'Update': 'Mise à jour',
    'Ionic Composition': 'Composition ionique',
    'Table Setting': 'Paramètre de table',
    'Stream Source': 'Source du flux',
    'Stream Destination': 'Destination du flux',
    'Export Table': 'Exporter le tableau',
    'Session has expired. Please login!': 'La session a expiré. Veuillez vous connecter !',
    'Your session will expire in 10 minutes. Please save your work and login again.': 'Votre session expirera dans 10 minutes. Veuillez enregistrer votre travail et vous reconnecter.',
    'Session Expiry Warning': "Avertissement d'expiration de session"

  },
  Help_Modal_Form: {
    '* or multiple of it': '* ou un multiple',
    'About': 'A propos',
    'Database Date': 'Date de la base de donnée',
    'Database Version': 'Version de la base de donnée',
    'Design Guidelines': 'Guide de design',
    'Determine approximate number of RO elements': 'Approximation du nombre d´élément d´OI',
    'Determine array.': 'Déterminer l´agencement',
    'Determine number of element housings.': 'Déterminer le nombre d´élément par tube',
    'Determine which RO elements to use.': 'Déterminer quel élément d´OI utiliser',
    'Housings in 1': 'Tube de pression en 1',
    'OK': 'OK',
    'Permeate Recovery, %': 'Récupération du perméat, %',
    'Program Date': 'Date du programme',
    'Run Winflows Design Simulator with the 24-12 array and look for': 'Exécutez Winflows Design Simulator avec la baie 24-12 et recherchez',
    'stage': 'Etage',
    'Text1': 'Les instructions ci-dessous sont un guide sur la façon de concevoir des unités RO simples où les débits sont suffisamment importants pour nécessiter 18 éléments ou plus, et la pression osmotique de l\'alimentation suffisamment faible pour permettre un fonctionnement supérieur à 65% de récupération de perméat. Dans ce cas, la tâche consiste à concevoir une unité RO qui, à 80% de récupération de perméat, produira 1,5x10.',
    'Text10': 'Le profil du flux de perméat (affiché dans Winflows Design Simulator Explorer) n\'est pas trop asymétrique (de préférence, le flux du dernier élément doit être au moins la moitié du flux de l\'élément principal). Il est possible qu\'une pompe de surpression inter-étages ou une contre-pression de perméat dans le premier étage soit nécessaire pour équilibrer le flux de perméat entre les étages.',
    'Text2': 'gpd perméat avec moins de 200 mg/L TDS à partir d\'eau de forage profond avec 2000 mg/L TDS.',
    'Text3': 'Des éléments de 8" de diamètre sont choisis. Ceux-ci sont généralement disponibles en 365, 400 et 440 pieds carré.',
    'Text4': 'versions de surface de membrane active. Typiquement, plus il y a de surface active de membrane, plus l\'espacement du canal d\'alimentation est mince, et plus la tendance à l\'encrassement de l\'élément est élevée. Dans ce cas, l\'alimentation est de l\'eau de forage avec un faible potentiel encrassant, donc un modèle d\'élément de 400 pieds carrés est choisi.',
    'Text5': 'Sélectionnez le flux moyen de perméat, par exemple à partir du guide de design. Dans cet exemple, l\'eau d\'alimentation est de l\'eau de forage avec une très faible tendance à l\'encrassement, donc un flux de perméat moyen de 15 gfd est choisi.',
    'Text6': 'Calculez le nombre d\'éléments requis (N) à partir du débit de perméat (Fp), du flux moyen de perméat (Jw) et de la surface de membrane active par élément (AA).',
    'Text7': 'Fp = N×AA×Jw, ce qui dans ce cas donne N = 250 éléments.',
    'Text8': 'Il y a généralement 6 ou 7 éléments par tube de pression. Dans ce cas, 7 éléments par tube sont choisis, ce qui donne 36 tubes de pression.',
    'Text9': 'À 80% de récupération de perméat, une configuration à deux étages fonctionnera probablement bien, ce qui signifie qu\'environ 2/3 des tubes de pression seront au premier étage. Ainsi, essayez une configuration 24-12.',
    'The below table is used to determine how to approximately arrange the housings.': 'Le tableau ci-dessous est utilisé pour déterminer comment agencer approximativement les tubes de pression.',
    'The predicted permeate TDS should be below the maximum allowed.': 'La TDS prédit du perméat doit être inférieure au maximum autorisé.',
    'The pressure drop over the elements': 'Perte de charge sur les éléments',
    'Tips on Designing RO Units Operating on Natural Waters with Below 5000 mg/L TDS': 'Conseils sur la conception d\'unités OI fonctionnant sur des eaux naturelles avec moins de 5000 mg/L TDS',
    'Typical array*': 'Arrangement typique*',
    'Warnings': 'Avertissement',
    'Winflows Design Simulator RO Elements Design Guidelines': 'Directives de conception des éléments RO du simulateur de conception Winflows',
  },
  Preface: {
    "Winflows": "Winflows",
    "Design Simulator": "Simulateur de conception",
    "Winflows Design Simulator": "Simulateur de conception Winflows",
    "Projection Report": "Rapport de projection",
    "WATER TECHNOLOGIES": "TECHNOLOGIES DE L'EAU",
    "Project Info": "Informations sur le projet",
    "Project Name": "Nom du projet",
    "Customer Name": "Nom du client",
    "Engineer": "Concepteur",
    "Location": "Emplacement",
    "Mail ID": "Email",
    "Phone No": "Téléphone",
    "Specify Flow Option": "Spécifier l'option de débit",
    "Notes": "Remarques",
    "Notifications": "Notifications",
    "None detected in the current design": "Aucun problème détecté dans la conception actuelle",
    "Trademark of Veolia": "*Marque déposée de Veolia ; peut être enregistrée dans un ou plusieurs pays. 2025 Veolia. Tous droits réservés",
    "Database": "Base de données",
    "Description": "Description",
    "Unit Op": "Opération unitaire",
    'Total Number of Warnings': 'Nombre total d’avertissements',
    'Total Number of Errors': 'Nombre total d’erreurs',
    'Disclaimer_text': 'Avertissement : Cette projection est fournie à titre de service gratuit et ne constitue pas une garantie de performance.'
  },
  Flowsheet_Design_Summary: {
    'Flowsheet Diagram': 'Diagramme de Flux',
    'Flowsheet Design Summary': 'Résumé de la conception du schéma de traitement',
    'Flowsheet Design': 'Conception du schéma de traitement',
    'Stream Property Summary': 'Résumé des propriétés du flux',
    'Stream Id': 'ID de flux',
    'Alkalinity, ppm CaCO3': 'Alcalinité, ppm CaCO3',
    'Hardness, ppm as CaCO3': 'Dureté, ppm as CaCO3',
    'Alkalinity': 'Alcalinité',
    'Hardness': 'Dureté',
    'Conductivity at 25°C': 'Conductivité à 25 °C',
    'FSD Flow Balance': 'Équilibre de flux FSD',
    'Unit ID (Stream no.)': 'ID d’unité (n° de flux)',
    'Overall Flow Sheet Recovery': 'Récupération globale de la feuille de flux',
    'Flow - Total': 'Débit - Total',
    'Incoming': 'Entrant',
    'Outgoing': 'Sortant',
    'Product': 'Produit',
    'Waste': 'Déchet',
    'ID': 'ID',
    'Conc.': 'Concentration',
    'Bleed': 'Purge',
    'Desalination_Demineralization': 'Résumé du débit au niveau de l’unité de dessalement / déminéralisation / séparateur à membrane (MEMS)',
  },
  Feed_Product_Waste_Summary: {
    'Feed-Product-Waste Summary': 'Résumé alimentation-produit-déchet',
    'Overall Flowsheet Recovery': 'Récupération globale de la feuille de flux',
    'Category': 'Catégorie',
    'Information': 'Information',
    'Ion Concentration': 'Concentration ionique',
    'Stream Property': 'Propriété du flux',
    'Water Source': 'Source d’eau',
    'Ionic Strength': 'Force ionique',
    'Osm.Pressure': 'Pression osmotique',
    'Osm. Pressure': 'Pression osmotique',
    'Softened Water': 'Eau adoucie',
    'Pump Unit Summary': "Résumé de l'unité de pompe"
  },
  RO_NF_Unit_System_Level_Summary: {
    'RO/NF Unit System-Level Summary': 'Résumé au niveau du système de l’unité RO/NF',
    'Docked Summary': 'Résumé amarré',
    'Total Number of RO/NF Unit': 'Nombre total d’unités RO/NF',
    'RO/NF Unit ID': 'ID d’unité RO/NF',
    'Upstream unit': 'Unité en amont',
    'Downstream unit': 'Unité en aval',
    'Permeate Flow': 'Débit de perméat',
    'Concentrate Flow': 'Débit de concentrat',
    'RO/NF Unit Recovery': 'Rendement de l’unité RO/NF',
    'Breakdown by Stage': 'Répartition par étape',
    'Total Membrane Area': 'Surface totale de membrane',
    'Feed Temperature': 'Température d’alimentation',
    'Interstage Pressure': 'Pression inter-étages',
    'Product Pressure *': 'Pression du produit*',
    'Feed pH': 'pH d’alimentation',
    'Permeate TDS': 'TDS du perméat',
    'Concentrate TDS': 'TDS du concentrat',
    'Concentrate pH': 'pH du concentrat',
    'Detailed Design': 'Conception détaillée',
    'Array Design': 'Conception en réseau',
    'Housing': 'Enveloppe',
    'Elements': 'Éléments',
    'Element Age(yr)': 'Âge de l’élément (ans)',
    'Pressure Change': 'Variation de pression',
    'Boost': 'Surpression',
    'Loss': 'Perte',
    'Permeate P': 'Pression du perméat',
    'Permeate pH': 'pH du perméat',
    'A-Value ACP': 'Valeur A ACP',
    'A-Factor': 'Facteur A',
    'B-Value ACP': 'Valeur B ACP',
    'B-Factor': 'Facteur B',
  },
  RO_NF_Unit_Stage_Level_Summary: {
    'RO/NF Unit Stage-Level Summary': 'Résumé au niveau de l’étape de l’unité RO/NF',
    'Element Type': 'Type d’élément',
    'Perm': 'Perméat',
    'dP': 'dP',
  },
  DSSRO_Section_Summary: {
    'DSSRO Section Summary': 'Résumé de section DSSRO',
    'DSSRO Overview': 'Vue d’ensemble DSSRO',
    'Overview': 'Vue d’ensemble',
    'DSSRO mode': 'Mode DSSRO',
    'CLRO': 'CLRO',
    'Elements per PV': 'Éléments par PV',
    'Spacers per PV': 'Entretoises par PV',
    'Length of PV': 'Longueur de PV',
    'CL Recovery': 'Récupération CL',
    'BP Recovery': 'Récupération BP',
    'CL Concentrate Flow': 'Débit de concentrat CL',
    'BP Concentrate Flow': 'Débit de concentrat BP',
    'CL Net Feed Flow': 'Débit net d’alimentation CL',
    'BP Feed Flow': 'Débit d’alimentation BP',
    'CL Permeate Flow': 'Débit de perméat CL',
    'Total Circuits': 'Circuits totaux',
    'BP Sequence Duration': 'Durée de séquence BP',
    'CL Sequence Duration': 'Durée de séquence CL',
    'Complete Cycle Duration': 'Durée de cycle complet',
    'CL System Volume': 'Volume du système CL',
    'S1 Volume': 'Volume S1',
    'S2 Volume': 'Volume S2',
    'S3 Volume': 'Volume S3',
    'DSSRO Flow Summary (Element Level)': 'Résumé de débit DSSRO (niveau élément)',
    'Flow Summary': 'Résumé de débit',
    'Circuit': 'Circuit',
    'Element': 'Élément',
    'Feed Press': 'Pression d’alimentation',
    'Conc Flow': 'Débit de concentrat',
    'CL 1': 'CL 1',
    'CL Final': 'CL final',
    'DSSRO Stream Composition': 'Composition de flux DSSRO',
    'Concentrations': 'Concentrations',
    'Concentrations (mg/L as ion)': 'Concentrations (mg/L en ion)',
    'Concentrate': 'Concentrat',
    'Permeate': 'Perméat',
    'Composition': 'Composition',
    'Schematic': 'Schéma',
    'Production Loop': 'Boucle de production',
    'High Pressure Centrifugal Pump (P2)': 'Pompe centrifuge haute pression (P2)',
    'Raw Feed Flow': 'Débit d’alimentation brute',
    'Feed Pump (P1)': 'Pompe d’alimentation (P1)',
    'RO Feed': 'Alimentation RO',
    'Cartridge Filter': 'Filtre à cartouche',
    'Feed Pressure': 'Pression d’alimentation',
    'Delta Pressure': 'Pression différentielle',
    'Circulation pump (P3)': 'Pompe de circulation (P3)',
    'CL Conc Flow': 'Débit de concentrat CL',
    'CL Perm Flow': 'Débit de perméat CL',
    'Brine Purge': 'Purge de saumure',
    'Conc Recirculation Flow': 'Débit de recirculation de concentrat',
    'BP Conc Flow': 'Débit de concentrat BP',
    'Brine Disposal': 'Élimination de la saumure',
    'DSSRO Loop Summary': 'Résumé de la boucle DSSRO',
    'Loop No': 'Numéro de boucle',
    'Permeate Stream (Loop wise) Summary': 'Résumé du flux de perméat (par boucle)',
    'Concentrate Stream (Loop wise) Summary': 'Résumé du flux de concentré (par boucle)',
  }, Pump_Summary: {
    'Pump Summary': 'Résumé des pompes',
    'Total Number of Pumps': 'Nombre total de pompes',
    'Pump Unit ID': 'ID d’unité de pompe',
    'RO/NF Unit Attached': 'Unité RO/NF attachée',
    'Combined Efficiency': 'Efficacité combinée',
    'Total Power Consumption': 'Consommation totale d’énergie (kW)',
  }, Detailed_Stream_Data: {
    'Detailed Stream Data': 'Données détaillées du flux',
    'LSI': 'LSI',
    'SDSI': 'SDSI',
    'Concentrate': 'Concentrat',
    'Inlet': 'Entrée',
    'Downstream Permeate': 'Perméat en aval',
    'Stream ID': 'ID de flux'
  },
  EDI_Unit_System_Level_Summary: {
    'EDI Unit System-Level Summary': 'Résumé au niveau du système de l’unité EDI',
    'Total Number of EDI Unit': 'Nombre total d’unités EDI',
    'EDI Unit ID': 'ID d’unité EDI',
    'System Product Flow Rate': 'Débit de produit du système',
    'Electrode Bleed Flow': 'Débit de purge des électrodes',
    'EDI Unit Recovery': 'Rendement de l’unité EDI',
    'No. of E-Cell EDI Stacks': 'Nombre d’empilements E-Cell EDI',
    'Concentrate Pressure': 'Pression du concentrat',
    'Product Outlet Pressure': 'Pression de sortie du produit',
    'Voltage': 'Tension',
    'AC Power': 'Puissance CA',
    'DC Power': 'Puissance CC',
    'DC power': 'Puissance CC',
    'Flow Configuration': 'Configuration d’écoulement',
    'Counter-Current/Co-Current': 'Contre-courant/Co-courant',
    'Counter-Current': 'Contre-courant',
    'Feed TDS': 'TDS d’alimentation',
    'Feed pH': 'pH d’alimentation',
    'Product Resistivity': 'Résistivité du produit',
    'Product pH': 'pH du produit',
    'Concentrate TDS': 'TDS du concentrat',
    'Concentrate pH': 'pH du concentrat',
    'Electrode Bleed TDS': 'TDS de purge des électrodes',
    'Electrode Bleed pH': 'pH de purge des électrodes',
    'H2': 'H2',
    'Cl2': 'Cl2',
    'Blower/Ventilation Sizing for H2': 'Dimensionnement ventilateur/ventilation pour H2',
    'Ventilation Blower/Fan': 'Ventilateur de ventilation',
    'Size': 'Taille',
    'Electrode_stream_vented_hydrogen': 'Le flux d’électrodes doit être ventilé car il contient de petites quantités d’hydrogène, d’oxygène et éventuellement de chlore (s’il y a des ions chlorure).',
    'hydrogen_oxygen_gas_edi': 'Un mélange 2:1 d’hydrogène et d’oxygène est produit à un débit maximal de 11,4 ml/A/min/empilement (gaz sec à 25 °C, 1,0 bar), dont 7,6 ml d’H2 et 3,8 ml d’O2. Veiller à maintenir l’hydrogène en dessous de 4 %.',
    'EDI Design Parameters': 'Paramètres de conception EDI',
    'Product Flow Rate per Stack': 'Débit de produit par empilement',
    'Upstream Interconnecting Piping': 'Tuyauterie interconnectée en amont',
    'Pressure Loss': 'Perte de pression',
    'TEA': 'TEA',
    'TEC': 'TEC',
    'Silica': 'Silice',
    'Conductvity': 'Conductivité',
    'Product Silica guarantee level': 'Niveau garanti de silice du produit',
    'Predicted Product Silica Level': 'Niveau prévu de silice du produit',
    'Predicted Product Sodium level': 'Niveau prévu de sodium du produit',
    'Predicted Product Chloride level': 'Niveau prévu de chlorure du produit',
    'Predicted Product Sulfate level': 'Niveau prévu de sulfate du produit',
    'Maximum Allowable Recovery': 'Récupération maximale admissible',
    'AC power consumption': 'Consommation de puissance CA',
    'AC energy': 'Énergie CA',
    'Predicted Product outlet pressure': 'Pression de sortie prévue du produit',
    'Feed Inlet': 'Entrée d’alimentation',
    'Concentrate Outlet': 'Sortie de concentrat',
    'Electrode Bleed': 'Purge des électrodes',
    'EDI Schematic': 'Schéma EDI',
    'Current/Stack': 'Courant/empilement',
    'Stack Voltage': 'Tension de l’empilement',
    'Energy Consumption': 'Consommation d’énergie',
    'Maximum Recovery': 'Récupération maximale',
    'Max. Conc. outlet pressure': 'Pression de sortie maximale du concentrat',
    'Conc. Bleed flow': 'Débit de purge du concentrat',
    'Product pressure': 'Pression du produit',
    'Max. Conc. inlet pressure': 'Pression d’entrée maximale du concentrat',
    'Max. Electrode Bleed Pressure': 'Pression maximale de purge des électrodes',
    'Dilute': 'Dilué',
    'Concentrate': 'Concentrat',
    'Electrode': 'Électrode',
  },
  CF_Unit_Summary: {
    'CF Unit Summary': 'Résumé de l’unité CF',
    'Total Number of CF Unit': 'Nombre total d’unités CF',
    'CF Unit ID': 'ID d’unité CF',
    'Flow Capacity': 'Capacité de débit',
    'Filter Type': 'Type de filtre',
    'Design Flow Per TIE': 'Débit de conception par TIE',
    'Outlet Pressure': 'Pression de sortie',
    'Pressure Drop': 'Perte de pression',
  },
  Chemical_Dosing_Unit_Summary: {
    'Chemical Dosing Unit Summary': 'Résumé de l’unité de dosage chimique',
    'Total Number of Chemical Dosing': 'Nombre total de dosages chimiques',
    'Dosing Endpoint': 'Point de dosage final',
    'Target Value': 'Valeur cible',
    'Concentration as Metered': 'Concentration mesurée',
    'Specific Gravity as Metered': 'Densité spécifique mesurée',
    'Metered Flow Rate': 'Débit mesuré',
    'Avg Cons.As Metered': 'Consommation moyenne mesurée',
    'Avg Cons.As Supplied': 'Consommation moyenne fournie',
    'Avg Cons.As Supplied with SF': 'Consommation moyenne avec facteur de sécurité',
    'Sulfuric Acid': 'Acide sulfurique',
    'Hydrochloric Acid': 'Acide chlorhydrique',
    'Phosphoric Acid': 'Acide phosphorique',
    'Nitric Acid': 'Acide nitrique',
    'Carbon Dioxide': 'Dioxyde de carbone',
    'Ammonia': 'Ammoniac',
    'Caustic Soda': 'Soude caustique',
    'Slaked Lime': 'Chaux éteinte',
    'Sodium Carbonate': 'Carbonate de sodium',
    'Calclium Carbonate': 'Carbonate de calcium',
    'Sodium Sulfate': 'Sulfate de sodium',
    'Sodium Cycle Softener': 'Adoucisseur à cycle de sodium',
    'Target pH': 'pH cible',
    'Total Number of Chemical Type': 'Nombre total de types chimiques',
    'Aggregated by Chemical Type – Supplied Form': 'Agrégé par type chimique – Forme fournie',
    'Chemical Type': 'Type chimique',
    'Chemical Dosing Unit ID': 'ID de l’unité de dosage chimique',
    'Concentration as Supplied': 'Concentration fournie',
    'Specific Gravity as Supplied': 'Densité spécifique fournie',
    'Total Consumption': 'Consommation totale',
    'As Supplied': 'Selon forme fournie',
    'As Supplied with SF': 'Selon forme fournie avec facteur de sécurité',
  },
  Antiscalant_Dosage_Summary: {
    'Antiscalant Dosage Summary': 'Résumé de dosage d’antiscalant',
    'Dosed In': 'Dosé dans',
    'Antiscalant': 'anticalcaire',
    'Dosage in Feed': 'Dosage dans l’alimentation'
  },
  ERD_Unit_Summary: {
    'ERD Unit Summary (WIP)': 'Résumé de l’unité ERD (en cours)',
    'Total Number of ERD Unit': 'Nombre total d’unités ERD',
    'ERD Unit ID': 'ID d’unité ERD',
    'ERD Type': 'Type d’ERD',
    'RO/NF Unit Attached': 'Unité RO/NF attachée',
    'Installed Location': 'Emplacement installé',
    'LP Discharge Pressure': 'Pression de refoulement BP',
    'Net Transfer Efficiency': 'Efficacité nette de transfert',
    'Boost Pressure': 'Pression d’appoint',
    'Leakage (Reject in HP OUT)': 'Fuite (rejet en sortie HP)',
    'Mixing at Membrane Feed': 'Mélange à l’alimentation de membrane',
    'Total Power Consumption': 'Consommation totale d’énergie',
    'HP Pump': 'Pompe haute pression',
    'Circulation Pump': 'Pompe de circulation',
    'Energy Recovered': 'Énergie récupérée',
    'Power Saving': 'Économie d’énergie',
    'Work Exchanger (WX)': 'Échangeur de travail (WX)',
  },
  Mixer_Splitter_Unit_Summary: {
    'Mixer-Splitter Unit Summary': 'Résumé de l’unité Mélangeur-Séparateur',
    'Total Number of Mixer-Splitter': 'Nombre total de Mélangeur-Séparateur',
    'Mixer-Splitter Unit ID': 'ID d’unité Mélangeur-Séparateur',
    'Inlet Stream ID': 'ID du flux d’entrée',
    'Outlet Stream ID': 'ID du flux de sortie',
    'Mode': 'Mode',
    'Mix Ratios': 'Rapports de mélange',
    'Split Ratios': 'Rapports de séparation',
    'calculated': 'calculé',
    'user input': 'saisie utilisateur',
    'Mix only': 'Mélange uniquement',
    'Split only': 'Séparation uniquement',
  },
  Detailed_RO_NF_Element_Level_Data: {
    'Detailed RO/NF Element-Level Data': 'Données détaillées par élément RO/NF',
    'Parameter': 'Paramètre',
    'Stage No.': 'Numéro d\'étape',
    'Element Pos.': 'Position de l\'élément',
    'Other': 'Autre',
    'Stream Property': 'Propriété du flux',
    'Permeate Ion Concentration': 'Concentration ionique du perméat',
    'Net Driving': 'Force motrice nette',
    'Delta Pressure': 'Pression différentielle',
    'Feed Osm. Pressure': 'Pression osmotique d’alimentation'
  },
  Winflows_Design_Simulator_Program_Details: {
    'Winflows Design Simulator Program Details': 'Détails du programme simulateur Winflows Design',
    'Program Version': 'Version du programme',
    'Program Last Update': 'Dernière mise à jour du programme',
    'Database Last Update': 'Dernière mise à jour de la base de données',
    'Contact for Technical Support': 'Contact pour support technique',
  },
  Stripper_Unit_Summary: {
    'Stripper Unit Summary': 'Résumé de l’unité de dégazage',
    'Total Number of Stripper': 'Nombre total de dégazeurs',
    'Outlet CO2 Concentration': 'Concentration de CO₂ en sortie',
    'Stripper Unit ID': 'ID de l’unité de dégazage',
    'Outlet H2S Concentration': 'Concentration de H₂S en sortie',
    'Outlet NH3 Concentration': 'Concentration de NH₃ en sortie',
  },
  Notification: {
    'FATAL ERROR!! Transmembrane Pressure Limit Exceeded! in ROHP_1 of Stage 1 of element 1 at given temperature.\n\nPlease change design!\nThe applied feed pressure exceeds the limit recommended for at least one of the elements selected. Operation above the maximum pressure can result in element damage, specifically, collapsed permeate channels, which will result in loss of element permeate productivity.\nExcessive pressure can also cause central tube collapse and subsequent element failure. To reduce the operating pressure for the system:\n1) increase the number of elements in the system,\n2) reduce the system recovery,\n3) increase the system feed temperature.': 'ERREUR FATALE ! Limite de pression transmembranaire dépassée ! dans ROHP_1, étape 1, élément 1 à la température donnée.\n\nVeuillez modifier la conception !\nLa pression d’alimentation appliquée dépasse la limite recommandée pour au moins un des éléments sélectionnés. Une pression excessive peut entraîner des dommages, notamment l’effondrement des canaux de perméat, entraînant une perte de productivité.\nElle peut aussi provoquer l’effondrement du tube central et la défaillance de l’élément. Pour réduire la pression de fonctionnement :\n1) augmenter le nombre d’éléments dans le système,\n2) réduire la récupération du système,\n3) augmenter la température d’alimentation.'
  }
};
export const German = {
  Feed: {
    'Alkalinity & ph': 'Alkalinität und pH-Wert',
    'Alkalinity is 0 when pH is below or equal to 4.5': 'Die Alkalinität beträgt 0, wenn der pH-Wert unter oder gleich 4,5 liegt.',
    'Anion': 'Anion',
    'Balance': 'Gleichgewicht',
    'Bicarbonate & pH': 'Bikarbonat & pH',
    'Brackish Surfacewater (Conventional)': 'Brackiges Oberflächenwasser (konventionell)',
    'Brackish Surfacewater (MF/UF)': 'Brackiges Oberflächenwasser (MF/UF)',
    'Brackish Water': 'Brackwasser',
    'Brackish Wellwater': 'Brackiges Grundwasser',
    'CO2 & Bicarbonate': 'CO2 und Bikarbonat',
    'Cancel': 'Abbrechen',
    'Cation': 'Kation',
    'Charge Balance': 'Ladebilanz',
    'Clear Values': 'Werte löschen',
    'Conductivity': 'Leitfähigkeit bei 25°C',
    'Density': 'Dichte',
    'Density, kg/m3': 'Dichte, kg/m3',
    'Do you want clear all the values for the composition': 'Möchten Sie alle Werte für die Zusammensetzung löschen?',
    'Do you want close the Feed input page': 'Möchten Sie die Eingabe zur Wasseranalyse schließen?',
    'EDI': 'EDI',
    'Failed to fetch default units': 'Standardeinheiten konnten nicht abgerufen werden',
    'Feed': 'Zulauf',
    'Feed Compositions must be a positive number': 'Die Zulaufzusammensetzung muss eine positive Zahl sein',
    'Feed Water Analysis': 'Speisewasseranalyse',
    'High ph RO 2nd pass': 'UO mit hohem pH Wert Permeatstufe',
    'High ph RO (city/well)': 'UO mit hohem pH-Wert (Stadt/Brunnen)',
    'High ph RO Wastewater': 'UO-Abwasser mit hohem pH-Wert',
    'Input': 'Eingabe',
    'MBR Permeate': 'MBR-Permeat',
    'OK': 'OK',
    'OR': 'ODER',
    'Osmotic Pressure': 'Osmotischer Druck',
    'Parameters': 'Parameter',
    'Parameters should not be empty': 'Parameter dürfen nicht leer sein',
    'Please enter water composition': 'Bitte geben Sie Wasseranalyse ein',
    'Pressure': 'Druck',
    'Pressure should not be empty': 'der Druck sollte nicht leer sein',
    'RO Permeate': 'UO-Permeat',
    'Saturation Data (Feed water)': 'Sättigungsdaten (Zulauf)',
    'Sea Water': 'Meerwasser',
    'Sea Wellwater': 'Meeresbrunnenwasser',
    'Select Ion for Charge Balance': 'Wählen Sie Ion für den Ladungsausgleich',
    'Select Water Source': 'Wasserquelle auswählen',
    'Select Water Type': 'Wasserart auswählen',
    'Sour Water': 'Saures Wasser',
    'Stiff-Davis Index': 'Stiff-Davis Index',
    'Struvite': 'Struvit',
    'Supply Pressure': 'Versorgungsdruck',
    'Surface Seawater (Conventional)': 'Oberflächenmeerwasser (konventionell)',
    'Surface Seawater (MF/UF)': 'Oberflächenmeerwasser (MF/UF)',
    'Surface Water': 'Oberflächenwasser',
    'Sweet Water': 'Süßwasser',
    'Temperature': 'Temperatur',
    'Tertiary Treated Wastewater (Conventional)': 'Tertiär behandeltes Abwasser (konventionell)',
    'Tertiary Treated Wastewater (MF/UF)': 'Tertiär behandeltes Abwasser (MF/UF)',
    'Total Alkalinity (ppm CaCO3)': 'Gesamtalkalität (ppm CaCO3)',
    'Total Alkalinity is required': 'die Gesamtalkalität ist erforderlich',
    'Total Anions': 'Gesamtanionen',
    'Total Cations': 'Gesamtkationen',
    'Total Organic Carbon': 'Organischer Kohlenstoff insgesamt',
    'Upload Water Analysis': 'Wasseranalyse hochladen',
    'User Defined': 'Benutzerdefiniert',
    'Well Water': 'Grundwasser',
    'pH should not be between 0-14': 'Der pH-Wert sollte zwischen 0 und 14 liegen.',
  },
  EDI: {
    '# of E-Cell EDI Stacks': 'Anzahl der E-Cell EDI-Stapel',
    'AC Energy (kWh/ m3)': 'Wechselstromenergie (kWh/m3)',
    'AC Power Consumption (kW)': 'AC-Leistungsaufnahme (kW)',
    'Apply': 'Anwenden',
    'Are you sure you want to close this form?': 'Möchten Sie dieses Formular wirklich schließen?',
    'Blower/Ventilation Sizing for Cl': 'Gebläse-/Lüftungsdimensionierung für Cl',
    'Blower/Ventilation Sizing for Cl2': 'Gebläse-/Lüftungsdimensionierung für Cl2',
    'Blower/Ventilation Sizing for H': 'Gebläse-/Lüftungsdimensionierung für H',
    'Calculated Output Parameters': 'Berechnete Ausgabeparameter',
    'Cancel': 'Abbrechen',
    'Co-Current': 'Gleichstrom',
    'Concentrate Bleed (m3/h)': 'Konzentratentnahme (m3/h)',
    'Current (Amps)': 'Strom (Ampere)',
    'DC power (kW)': 'Gleichstromleistung (kW)',
    'Design': 'Design',
    'Design Safety Factor': 'Konstruktionssicherheitsfaktor',
    'E-Factor': 'E-Faktor',
    'Effluent Silica Gaurantee (3 Series)': 'Garantie für Kieselsäure im Abwasser (Serie 3, 5)',
    'Effluent Silica Gaurantee (7 Series)': 'Garantie für Kieselsäure im Abwasser (Serie 9)',
    'Electrode Bleed': 'Elektrodenentlüftung',
    'Electrode Bleed (m3/h)': 'Elektrodenentlüftung (m3/h)',
    'Electrode Gas Generation': 'Elektrodengaserzeugung',
    'Expected': 'Erwartet',
    'Explosion Limit of H2 in Air': 'Explosionsgrenze von H2 in Luft',
    'Explosion limit of H2 in Air': 'Explosionsgrenze von H2 in Luft',
    'Exposure Limit of Cl2 in Air': 'Expositionsgrenzwert für Cl2 in der Luft',
    'Feed Guarantee Guide': 'Feed & Garantie-Leitfaden',
    'Feed Inlet (m3/h)': 'Zulauf (m3/h)',
    'Feed Pressure (bar)': 'Zulaufdruck (bar)',
    'Feed TEA Limitations for Resistivity Gaurantee': 'Feed-TEA-Einschränkungen für die Widerstandsgarantie',
    'Feed Water Specification': 'Speisewasserspezifikation',
    'Feedwater Parameters': 'Speisewasser-Ausgangsparameter',
    'Flow Per Stack': 'Durchfluss pro Stack',
    'Gas': 'Gas',
    'Input': 'Eingang',
    'Maximum': 'Maximal',
    'Maximum Allowable Recovery (%)': 'Maximal zulässige Ausbeute (%)',
    'Note': 'Notiz',
    'OK': 'OK',
    'Output': 'Ausgabe',
    'Please enter the required fields': 'Bitte füllen Sie die Pflichtfelder aus',
    'Please enter the values within range': 'Bitte geben Sie Werte innerhalb des Bereichs ein',
    'Predicted Boron Product (ppb B)': 'Vorhergesagt Bor Produkt (ppb B)',
    'Predicted Product Outlet Pressure (bar)': 'Voraussichtlicher Produktauslassdruck (bar)',
    'Predicted Product Silica Level (ppb SiO2)': 'Vorhergesagt Silica Produkt (ppb SiO2)',
    'Predicted Product Chloride Level (ppb Cl)': 'Garantierter Chloridgehalt des Produkts (ppb Cl)',
    'Product Flow Rate': 'Produktdurchflussrate',
    'Product Resistivity (MΩ.cm)': 'Produktspezifischer Widerstand (MΩ.cm)',
    'Product Silica Guarantee Level (ppb SiO2)': 'Garantierter Siliciumdioxidgehalt des Produkts (ppb SiO2)',
    'Predicted Product Sodium Level (ppb Na)': 'Garantierter Natriumgehalt des Produkts (ppb Na)',
    'Predicted Product Sulfate Level (ppb SO4)': 'Garantierter Sulfatgehalt des Produkts (ppb SO4)',
    'Range': 'Reichweite',
    'Rectifier DC Output (Volts)': 'Gleichrichter-DC-Ausgang (Volts)',
    'Rectifier DC Output': 'Gleichrichter-DC-Ausgang',
    'Rectifier DC output': 'Gleichrichter-DC-Ausgang',
    'Rectifier Efficiency': 'Gleichrichtereffizienz',
    'Rectifier efficiency': 'Gleichrichtereffizienz',
    'Select': 'Wählen',
    'Stack Model': 'Stack Modell',
    'Status': 'Status',
    'System Parameters': 'Systemausgabeparameter',
    'Target Resistivity (MΩ.cm)': 'Zielwiderstand (MΩ.cm)',
    'Target Resistivity': 'Zielwiderstand',
    'Target Silica Gaurantee (ppb SiO2)': 'Zielsilikatengarantie (ppb SiO2)',
    'Target Silica Gaurantee': 'Zielsilikatengarantie',
    'Target Silica guarantee': 'Ziel-Silicium-Garantie',
    'Units': 'Einheiten',
    'Value': 'Wert',
    'Ventilation Blower/Fan Size': 'Größe des Lüftungsgebläses/-lüfters',
    'Ventilation Sizing': 'Dimensionierung der Belüftung',
    'Voltage (Volts)': 'Spannung (Volt)',
    'Upstream Interconnecting Piping Pressure Loss': 'Druckverlust der vorgelagerten Verbindungsrohrleitung',
    'RO permeate pressure must be at least 0.34 bar | 5 psi higher than E-Cell feed pressure to account for pressure loss in piping between RO permeate and E-Cell feed': 'Der RO-Permeatdruck muss mindestens 0,34 bar | 5 psi höher sein als der E-Cell-Zufuhrdruck, um den Druckverlust in der Rohrleitung zwischen RO-Permeat und E-Cell-Zufuhr auszugleichen',
    'System Product Flow': 'Systemproduktfluss',
    'Conductivity (µS/cm @ 25°C)': 'Leitfähigkeit (µS/cm bei 25 °C)'
  },
  RO: {
    'Recovery (%)': 'Wiederherstellung (%)',
    'Add New Row': 'Neue Zeile hinzufügen',
    '0.5 Means that the elements only gives half the permeate flow rate as of the nominal element': '0,5 bedeutet, dass das Element nur die halbe Permeatflussrate des nominalen Elements liefert',
    '1.5 means that the salt passage is 1.5 times higher than that of the nominal element': '1,5 bedeutet, dass der Salzdurchgang 1,5 mal höher ist als der des nominalen Elements',
    'A-Value Factor': 'A-Wert Faktor',
    'Activate Argo Analyzer': 'Argo Analyzer aktivieren',
    'Aluminium in Conc (ppm)': 'Aluminium im Konzentrat (ppm)',
    'Antiscalant Dosage': 'Antiscalant Dosierung',
    'Application': 'Anwendung',
    'Apply': 'Anwenden',
    'Area': 'Bereich',
    'Argo Analyzer': 'Argo-Analysator',
    'Array Recovery': 'Ausbeute der Anordnung',
    'Average Flux': 'Durchschnittlicher Fluss',
    'B-Value Factor': 'B-Wert Faktor',
    'Boost Energy Efficiency %': 'Energieeffizienz Booster %',
    'Boost Energy Efficiency % must be in the range 10-100': 'Die Energieeffizienz des Boosters muss in % im Bereich 10-100 liegen',
    'CLRO Parameters': 'CLRO-Parameter',
    'Cancel': 'Abbrechen',
    'Compare': 'Vergleichen',
    'Concentrate composition calculated by Winflows': 'Konzentratzusammensetzung berechnet durch Winflows',
    'Copy RO Machine Configuration': 'UO-Maschinenkonfiguration kopieren',
    'Design Guidelines': 'Designrichtlinien',
    'Do you want to close the RO input page?': 'Möchten Sie die UO-Eingabeseite schließen?',
    'Element Age (yr)': 'Elementalter (Jahre)',
    'Element Age (yr) must be in the range 0-10': 'Das Elementalter (Jahr) muss im Bereich 0-10 liegen',
    'Element Age Calculator': 'Elementalter-Rechner',
    'Element Group': 'Elementgruppe',
    'Element Info': 'Elementinformationen',
    'Element Model': 'Elementmodell',
    'Elements per Vessel': 'Elemente pro Druckrohr',
    'Elements per Vessel must be in the range 0-8': 'Die Elemente pro Druckrohr müssen im Bereich 0-8 liegen',
    'Enter valid data in Pressure Vessels, Elements Per Vessel and Element Type': 'Geben Sie gültige Daten in Druckrohr, Elemente pro Behälter und Elementtyp ein',
    'Feed Pressure': 'Druck Zulauf',
    'Flux Annual % Change': 'Fluss: Jährliche %-Änderung',
    'Input A Value Factor & B Value Factor': 'Geben Sie die Werte für Faktor A und B ein',
    'InterStage Boost Pressure': 'InterStage- Booster Pumpe',
    'InterStage Pressure Loss': 'Druckverlust zwischen den Stufen',
    'InterStage Pressure Loss must be in the range': 'Der InterStage-Druckverlust muss im Bereich liegen',
    'Max Pressure': 'Maximaler Druck',
    'No options': 'Keine Optionen',
    'Nominal Flow': 'Nominalfluss',
    'OK': 'OK',
    'OutPut': 'Ausgabe',
    'Permeate Flow Rate': 'Permeatflussrate',
    'Permeate Pressure': 'Permeatdruck',
    'Permeate Pressure must be in the range': 'Der Permeatdruck muss im Bereich liegen',
    'Please populate the previous row(s) !': 'Bitte füllen Sie die vorherige(n) Zeile(n) aus!',
    'Pressure Vessels': 'Druckrohr',
    'Pressure Vessels must be in the range 0-999': 'Druckrohre müssen im Bereich 0-999 liegen',
    'Pressure drop during brine purge': 'Druckabfall während der Konzentratspülung',
    'Product TDS': 'Produkt TDS',
    'RO Element Data': 'UO-Elementdaten',
    'RO Parameters': 'UO-Parameter',
    'RO Permeate': 'UO-Permeat',
    'RO Recovery': 'UO-Rückgewinnung',
    'RO Recovery, %': 'UO-Rückgewinnung, %',
    'Recovery Per Circuit must be in the range 0-100%': 'Die Ausbeute pro Zyklus muss im Bereich 0–100 % liegen',
    'Recovery must be in the range 0-100%': 'Die Ausbeute muss im Bereich 0–100 % liegen',
    'Recovery per circuit': 'Ausbeute pro Zyklus',
    'Recycle Permeate from Last Stage to Feed Pump': 'Permeat aus der letzten Stufe zur Förderpumpe zurückführen',
    'Rejection': 'Rückhalt',
    'Results': 'Ergebnisse',
    'Salt Passage Annual % Change': 'Jährliche Veränderung in % Salzpassage',
    'Saturation Indices': 'Sättigungsindizes',
    'Select Hypersperse Products': 'Wählen Sie Hypersperse-Produkte',
    'Select Region': 'Region wählen',
    'Spacer per Vessel must be in the range 0-8': 'Der Abstandshalter pro Druckrohr muss im Bereich 0-8 liegen',
    'Spacers per Vessel': 'Abstandshalter pro Druckrohr',
    'Spec File is not available for this Element.': 'Für dieses Element ist keine Spezifikationsdatei verfügbar.',
    'Split Permeate (Upstream Part)': 'Geteiltes Permeat (Upstream-Teil)',
    'Stage': 'Konzentratstufe',
    'Sum of Element per Vessel & Spacers per Vessel must be <= 8': 'Die Summe der Elemente + Abstandshalter muss pro Druckrohr <= 8 sein.',
    'Test': 'Test',
    'Test Pressure': 'Prüfdruck',
    'Total holdup Volume': 'Gesamtes Holdup-Volumen',
    'Type': 'Typ',
    'Use Element Age and Annual % Change': 'Elementalter und jährliche %-Änderung',
    'Winflows Design Simulator RO Elements Design Guidelines': 'Winflows Design Simulator RO Elements Designrichtlinien',
    'Winflows RO Elements Design Guidelines': 'Designrichtlinien für Winflows UO-Elemente',
    'by': 'von',
    'Winflows Report': 'Winflow-Bericht',
    'Generate': 'Erzeugen',
    'RO Permeate flow': 'RO-Permeatfluss',
    'RO Recovery rate': 'RO-Wiederherstellungsrate',
    'Recovery during brine purge': 'Rückgewinnung während der Sole-Spülung',
    'Feed Flow (per PV) during brine purge': 'Zulaufstrom (pro PV) während der Sole-Spülung',
    'Recovery during brine purge should be between 0 – 20': 'Die Rückgewinnung während der Sole-Spülung sollte zwischen 0 und 20 liegen'
  },
  Header: {
    'About': 'Um',
    'Design Guidelines': 'Designrichtlinien',
    'Element Cross Reference List': 'Element-Querverweisliste',
    'Give File Name': 'Dateinamen eingebene',
    'Help': 'Hilfe',
    'Language': 'Sprache',
    'RO Design Guidelines Tips': 'Tipps zu den RO-Designrichtlinien',
  },
  Landing: {
    '# of Elements': 'Anzahl der Elemente',
    'All': 'Alle',
    'Application': 'Anwendung',
    'Application Wizard': 'Anwendungsassistent',
    'Apply': 'Anwenden',
    'Archive': 'Archiv',
    'Are you sure you want to delete it?': 'Möchten Sie es wirklich löschen?',
    'Array': 'Anordnung',
    'Choose any one parameter': 'Wählen Sie einen beliebigen Parameter',
    'Choose any RO Machine to Display the Data': 'Wählen Sie zur Anzeige der Daten eine Umkehrosmoseanlage aus',
    'Select Equipment Model': 'Wählen Sie Gerätemodell',
    'Clear All': 'Alles löschen',
    'Created On': 'Erstellt am',
    'Current': 'Aktuell',
    'Design Flowsheet': 'Entwurfs-Flussdiagramm',
    'Element Model': 'Elementmodell',
    'Enter name to Search': 'Geben Sie den Namen für die Suche ein',
    'Error while deleting file': 'Fehler beim Löschen der Datei',
    'FactSheet': 'Datenblatt',
    'Failed to fetch Ro Machine record': 'Der UO Machine-Datensatz konnte nicht abgerufen werden.',
    'Feed Flow': 'Zulauf',
    'Feed Water': 'Speisewasser',
    'File deleted succesfully': 'Datei erfolgreich gelöscht',
    'File Name': 'Dateiname',
    'File shared successfully!.': 'Datei erfolgreich freigegeben!',
    'Flow Sheet Details': 'Details zum Flussdiagramm',
    'Flow Sheet Type': 'Flussdiagrammtyp',
    'Flux': 'Fluss',
    'Integrated RO-EDI': 'Integriertes RO-EDI',
    'Last Edited On': 'Zuletzt bearbeitet am',
    'Multi-Pass Design': 'Mehrere Permeatstufen',
    'My Projects': 'Meine Projekte',
    'No options': 'Keine Optionen',
    'No Result Found!': 'Keine Einträge gefunden!',
    'OR': 'oder',
    'Open': 'Offen',
    'Open File': 'Datei öffnen',
    'Permeate Flow Rate': 'Permeatflussrate',
    'Permeate Flow Rate must not be empty': 'Die Permeatflussrate darf nicht leer sein',
    'Pre Treatment': 'Vorbehandlung',
    'Pre-Configured Design': 'Vorkonfiguriertes Design',
    'Project Details (Quick view)': 'Projektdetails (Schnellansicht)',
    'Project Name': 'Projektname',
    'Recent Files': 'Zuletzt verwendete Dateien',
    'Recent Search': 'Letzte Suche',
    'Result': 'Ergebnis',
    'RO-EDI Equipment Selector': 'UO-EDI-Geräteauswahl',
    'See Result': 'Ergebnis ansehen',
    'Shared by': 'Geteilt von',
    'Shared Projects': 'Gemeinsame Projekte',
    'Single-Pass Design': 'Auslegung mit einer Permeatstufe',
    'Submit': 'Einreichen',
    'Template Library': 'Vorlagenbibliothek',
    'Tutorial': 'Lernprogramm',
    'Type here…': 'Geben Sie hier ein …',
    'Unread': 'Ungelesen',
    'Welcome to': 'Willkommen zu',
    'Nominal Permeate Flow Rate': 'Nominale Permeatdurchflussrate',
    'Choose any RO-EDI Equipment Model to Display the Data': 'Wählen Sie ein beliebiges UO-EDI-Gerätemodell zur Anzeige der Daten',
    'Please use the RO-EDI Equipment Selector. Please consult Veolia for further support.': 'Bitte nutzen Sie den UO-EDI Equipment Selector. Für weitere Unterstützung wenden Sie sich bitte an Veolia.',
    'Potable Water': 'Trinkwasser',
    'Beverage Production': 'Getränkeproduktion',
    'Potable Water - Low Boron': 'Trinkwasser – borarm',
    'Demineralization': 'Entmineralisierung',
    'Reuse': 'Wiederverwendung',
    'Reuse - High Purity': 'Wiederverwendung – Hohe Reinheit',
    'Ultrapure Water': 'Reinstwasser',
    'RO Permeate Polishing': 'RO-Permeatpolieren',
    'Water Softening': "Wasserenthärtung",
    'City Water': 'Stadtwasser',
    'Conventional': 'Konventionell',
    'MF/UF': 'MF/UF',
    'Logout': 'Abmelden',
    'Winflows Design Simulator': 'Winflows Design Simulator',
    'Received Projects': 'Erhaltene Projekte'
  },
  ProjectInfo: {
    'Email': 'Email',
    'Engineer': 'Ingenieur',
    'Enter Notes here...': 'Geben Sie hier Notizen ein ...',
    'Location': 'Standort',
    'Ok': 'OK',
    'Phone': 'Telefon',
    'Project Info': 'Projektinfo',
    'Project Name*': 'Projektname*',
  },
  Pump: {
    'Are you sure you want to close this form?': 'Möchten Sie dieses Formular wirklich schließen?',
    'Auto Efficiencies': 'Auto Effizienz',
    'Average Discharge Pressure': 'Durchschnittlicher Auslassdruck',
    'Cancel': 'Abbrechen',
    'Discharge Pressure': 'Abgabedruck',
    'Flow Rate': 'Fließrate',
    'Inlet Pressure': 'Eingangsdruck',
    'Motor Efficiency': 'Motoreffizienz',
    'OK': 'OK',
    'Power': 'Leistung',
    'Pump Efficiency': 'Pumpeneffizienz',
    'Pump Specification': 'Pumpenspezifikation',
    'VFD Efficiency': 'VFD-Effizienz',
    'Power Consumption': 'Stromverbrauch',
    'Combined Efficiency': 'Kombinierte Effizienz',
    'RO/NF Unit Attached': 'RO/NF-Einheit Angeschlossen'
  },
  Cartridge: {
    'Actual Flow per TIE': 'Tatsächlicher Durchfluss pro TIE',
    'Cancel': 'Abbrechen',
    'Cartridge Filter': 'Kartuschenfilter',
    'Do you want to close the CF input page?': 'Möchten Sie die CF-Eingabeseite schließen?',
    'Filter': 'Filter',
    'Filter DP': 'Druckverlust (DP)',
    'Flow per TIE': 'Durchfluss pro TIE',
    'Flow Sheet is not available for this Element.': 'Für dieses Modell ist kein Datenblatt verfügbar.',
    'Micron': 'Mikron',
    'Number of Filters': 'Anzahl der Filter',
    'OK': 'OK',
    'View Fact Sheet': 'Datenblatt anzeigen',
    'Flow Capacity': 'Durchflusskapazität',
    'Filter Type': 'Filtertyp',
    'Design Flow Per TIE': 'Auslegungsdurchfluss pro TIE',
    'Outlet Pressure': 'Ausgangsdruck',
    'Pressure Drop': 'Druckabfall'
  },
  Stripper: {
    'Activate': 'Aktivieren',
    'Are you sure you want to close this form?': 'Möchten Sie dieses Formular wirklich schließen?',
    'Cancel': 'Abbrechen',
    'OK': 'OK',
    'Outlet CO2 concentration': 'CO2-Konzentration Ablauf',
    'Outlet H2S concentration': 'H2S-Konzentration Ablauf',
    'Outlet NH3 concentration': 'NH3-Konzentration Ablauf',
    'Stripper': 'Entgaser',
  },
  MixSplit: {
    'Apply': 'Anwenden',
    'Are you sure you want to close this form?': 'Möchten Sie dieses Formular wirklich schließen?',
    'Cancel': 'Abbrechen',
    'Flow Rate': 'Fließrate',
    'Note': 'Notiz',
    'Number of Outlet Streams': 'Anzahl der Auslassströme',
    'OK': 'OK',
    'Split Fraction': 'Anteil',
    'Split Fraction of individual streams should be in the range of 0-1 and sum of all split fractions should be 1.': 'Der Anteil einzelner Streams sollte im Bereich zwischen 0 und 1 liegen und die Summe aller Anteile sollte 1 ergeben.',
    'Split fraction(s) must not be empty': 'Anteil(e) dürfen nicht leer sein',
    'Splitter': 'Verteiler',
    'Stream Name': 'Names des Stroms',
    'Stream Values should be between 0 and 1': 'Anteile sollten zwischen 0 und 1 liegen',
    'Sum of Split fraction(s) is 1 or more. Please review your input': 'Die Summe der Anteile beträgt 1 oder mehr. Bitte überprüfen Sie Ihre Eingabe',
    'Sum of split fraction(s) should be 1.0': 'Die Summe der Anteile sollte 1,0 betragen.',
    'Total stream values must be between 0 and 1': 'Die Gesamtstreamwerte der Ströme müssen zwischen 0 und 1 liegen',
  },
  ChemDose: {
    'Apply': 'Anwenden',
    'Are you sure you want to close this form?': 'Möchten Sie dieses Formular wirklich schließen?',
    'Average Consumption as Supplied': 'Durchschnittlicher Verbrauch im Lieferzustand',
    'Average Consumption as metered': 'Gemessener durchschnittlicher Verbrauch',
    'Cancel': 'Abbrechen',
    'Carbon Dioxide': 'Kohlendioxid',
    // 'Caustic Soda': 'Natronlauge',
    'Chemical': 'Chemisch',
    'Chemical Dosing': 'Chemische Dosierung',
    'Chemical Selection': 'Chemische Auswahl',
    'Close': 'Schließen',
    'Dosage Rate': 'Dosierung',
    'Dosage Rate must be positive': 'Die Dosierungsrate muss positiv sein',
    'Dosing Control': 'Dosierkontrolle',
    'Hardness Leakage': 'Härteverlust',
    'Hardness Leakage must be positive': 'Härteverlust muss positiv sein',
    'Hydrochloric Acid': 'Salzsäure',
    'Input': 'Zulauf',
    'LSI must be between -3 and 3': 'LSI muss zwischen -3 und 3 liegen',
    'Mass flow Rate': 'Massendurchsatz',
    'Mass Flow Rate': 'Massendurchsatz',
    'Metered Concentration': 'Dosierte Konzentration',
    'Metered Concentration must be between 0 and 100': 'Die gemessene Konzentration muss zwischen 0 und 100 liegen',
    'Metered Gravity at supplied Concentration must be positive': 'Die dosierte Dichte muss bei der gelieferten Konzentration positiv sein',
    'Nitric Acid': 'Salpetersäure',
    'OK': 'OK',
    'Output': 'Ergebniss',
    'Phosphoric Acid': 'Phosphorsäure',
    'Please enter the chemical name': 'Bitte geben Sie den chemischen Namen ein',
    'Please enter the required fields': 'Bitte füllen Sie die Pflichtfelder aus',
    'Safety Factor': 'Sicherheitsfaktor',
    'Safety Factor must be positive': 'Der Sicherheitsfaktor muss positiv sein',
    'Select': 'Wählen',
    'Slacked Lime': 'Kalk',
    'Sodium Cycle Softener': 'Enthärter im Natriumzyklus',
    'Specific Gravity at metered Concentration': 'Spezifisches Gewicht bei dosierter Konzentration',
    'Specific Gravity at supplied Concentration': 'Spezifisches Gewicht bei angegebener Konzentration',
    'Specific Gravity at supplied Concentration must be positive': 'Das spezifische Gewicht muss bei der angegebenen Konzentration positiv sein',
    'Sulfuric Acid': 'Schwefelsäure',
    'Supplied Concentration': 'Gelieferte Konzentration',
    'Supplied Concentration must be between 0 and 100': 'Die angegebene Konzentration muss zwischen 0 und 100 liegen',
    'Supplied Form': 'Gelieferter Zustand',
    'Supplied/Delivered consumption with safety factor': 'Gelieferter/gelieferter Verbrauch mit Sicherheitsfaktor',
    'Target Alkalinity': 'Zielalkalität',
    'Target LSI': 'Ziel-LSI',
    'Usage': 'Verwendung',
    'Usage must be between 0 and 100': 'Die Nutzung muss zwischen 0 und 100 liegen',
    'Volume Flow Rate': 'Volumenstrom',
    'pH must be between 0 and 14': 'Der pH-Wert muss zwischen 0 und 14 liegen',
  },
  ERD: {
    'Are you sure you want to close this form?': 'Möchten Sie dieses Formular wirklich schließen?',
    'Circulation Pump Efficiency': 'Effizienz der Umwälzpumpe',
    'Circulation Pump Motor Efficiencies': 'Wirkungsgrad der Umwälzpumpenmotoren',
    'Circulation Pump VFD Efficiencies': 'Wirkungsgrad der Umwälzpumpen mit variablem Frequenzumrichter',
    'Circulation/Booster Pump': 'Umwälz-/Druckerhöhungspumpe',
    'Cost of Power': 'Stromkosten',
    'Differential Pressure HP Side': 'Differenzdruck HP-Seite',
    'Differential Pressure LP Side': 'Differenzdruck LP-Seite',
    'Efficiency': 'Effizienz',
    'Energy Recovery Device': 'Energierückgewinnungsgerät',
    'Feedwater Salinity': 'Salzgehalt Zulauf',
    'HP Power Consumed': 'Verbrauchter HP-Strom',
    'HP Pump Efficiency': 'Effizienz der Hochdruckpumpe',
    'HP Pump Motor Efficiency': 'Wirkungsgrad des HP-Pumpenmotors',
    'Input Parameters': 'Eingabeparameter',
    'Leakage (reject in HP out stream)': 'Leckage (Abfall im HP-Abfluss)',
    'Lubrication Flow': 'Schmiermittelfluss',
    'Lubrication Per Array': 'Schmierung pro Array',
    'Manual or Auto Efficiencies': 'Manuelle oder automatische Effizienz',
    'Membrane Differential Pressure': 'UO Membran-Differenzdruck',
    'Mixing at Membrane Feed': 'Mischen in den Zulauf zur UO',
    'Model': 'Modell',
    'Motor Efficiency': 'Motoreffizienz',
    'Number of Units': 'Anzahl der Einheiten',
    'OK': 'OK',
    'Parameter': 'Parameter',
    'Power Consumed': 'Stromverbrauch',
    'Power Consumption': 'Stromverbrauch',
    'Power Cost Saved': 'Eingesparte Stromkosten',
    'Power Savings': 'Energieeinsparungen',
    'Pressure Exchanger': 'Druckaustauscher',
    'Pressure Exchanger Performance': 'Leistung des Druckaustauschers',
    'Pressure Exchanger Power results': 'Druckaustauscher Leistungsergebnisse',
    'Pump Efficiency': 'Pumpeneffizienz',
    'RO Feed Pressure': 'UO-Zufuhrdruck',
    'RO Permeate Flow': 'UO-Permeatfluss',
    'RO Recovery Rate': 'UO-Rückgewinnungsrate',
    'Specific Power Consumption': 'Spezifischer Stromverbrauch',
    'Total Power Consumption': 'Gesamtstromverbrauch',
    'Unit': 'Einheit',
    'Unit Flow': 'Fluss pro Einheit',
    'VFD Efficiency': 'VFD-Effizienz',
    'Values': 'Werte',
    'Work Exchanger': 'Work Exchanger',
    'Work Exchanger Performance': 'Leistung des Work Exchanger',
    'Work Exchanger Power results': 'Ergebnisse der Work Exchanger Power',
  },
  PW: {
    'Are you sure you want to close this form?': 'Möchten Sie dieses Formular wirklich schließen?',
    'Cost of Power': 'Stromkosten',
    'Electricity Generated (Mechanical Energy Recovered)': 'Erzeugter Strom (gewonnene mechanische Energie)',
    'Feedwater Salinity': 'Salzgehalt Zulauf',
    'HP Motor Electrical Power': 'Elektrische Leistung des HP-Motors',
    'HP Motor Shaft Power': 'PS-Motorwellenleistung',
    'HP Pump Efficiency': 'Effizienz der Hochdruckpumpe',
    'HP Pump Motor Efficiency': 'Wirkungsgrad des HP-Pumpenmotors',
    'HP Pump Shaft Power': 'HP-Pumpenwellenleistung',
    'Input Parameters': 'Eingabeparameter',
    'Low P Discharge Pressure': 'Niedriger P-Entladedruck',
    'Membrane Differential Pressure': 'UO Membran-Differenzdruck',
    'Net Transfer Efficiency': 'Netto-Transfereffizienz',
    'OK': 'OK',
    'Parameter': 'Parameter',
    'Pelton Wheel': 'Pelton-Rad',
    'Pelton wheel Performance': 'Leistung des Peltonrads',
    'Power Cost Saved': 'Eingesparte Stromkosten',
    'Power Savings': 'Energieeinsparungen',
    'RO Feed Pressure': 'UO-Zufuhrdruck',
    'RO Permeate Flow': 'UO-Permeatfluss',
    'RO Recovery Rate': 'UO-Rückgewinnungsrate',
    'Specific Power Consumption': 'Spezifischer Stromverbrauch',
    'Total Power Consumption': 'Gesamtstromverbrauch',
    'Turbine Efficiency': 'Turbinenwirkungsgrad',
    'Unit': 'Einheit',
    'Values': 'Werte',
  },
  TC: {
    'Are you sure you want to close this form?': 'Möchten Sie dieses Formular wirklich schließen?',
    'Boost Pressure': 'Zusatzdruck',
    'Cost of Power': 'Stromkosten',
    'Energy Recovered': 'Energie zurückgewonnen',
    'Feedwater Salinity': 'Salzgalt Zulauf',
    'HP Power Consumed': 'Verbrauchter HP-Strom',
    'HP Pump Efficiency': 'Effizienz der Hochdruckpumpe',
    'HP Pump Motor Efficiency': 'Wirkungsgrad des HP-Pumpenmotors',
    'Input Parameters': 'Eingabeparameter',
    'Low P Discharge Pressure': 'Niedriger P-Entladedruck',
    'Membrane Differential Pressure': 'Membran-Differenzdruck',
    'Net Transfer Efficiency': 'Netto-Transfereffizienz',
    'OK': 'OK',
    'Parameter': 'Parameter',
    'Power Cost Saved': 'Eingesparte Stromkosten',
    'Power Savings': 'Energieeinsparungen',
    'RO Feed Pressure': 'UO-Zufuhrdruck',
    'RO Permeate Flow': 'UO-Permeatfluss',
    'RO Recovery Rate': 'UO-Rückgewinnungsrate',
    'Specific Power Consumption': 'Spezifischer Stromverbrauch',
    'Total Power Consumption': 'Gesamtstromverbrauch',
    'Turbo Charger': 'Turbolader',
    'Turbo Charger Performance': 'Leistung des Turboladers',
    'Turbo Charger Placement': 'Platzierung des Turboladers',
    'Turbo Inlet Pressure': 'Turbolader-Einlassdruck',
    'Turbo Outlet Pressure': 'Turbolader-Auslassdruck',
    'Unit': 'Einheit',
    'Values': 'Werte',
  },
  CIP: {
    'CIP Calculator': 'CIP-Rechner',
    'CIP Report': 'CIP-Bericht',
    'Calculator': 'Rechner',
    'Cleaner Strength': 'Reinigerstärke',
    'Cleaner Type': 'Reinigertyp',
    'Cleaning Step': 'Reinigungsschritt',
    'Cleaning Strategies based on Foulant type': 'Reinigungsstrategien basierend auf dem Verschmutzungstyp',
    'Element': 'Element',
    'Element/Vessel': 'Element/Druckrohr',
    'Foulant Type': 'Vollständig typisiert',
    'Get Report': 'Bericht abrufen',
    'Liquid': 'Flüssig',
    'Maintenance Clean': 'Wartungsreinigung',
    'Membrane Material': 'Membranmaterial',
    'NSF Approved': 'NSF-Zulassung',
    'No of RO Trains': 'Anzahl der UO-Züge',
    'No of Stages': 'Anzahl der Konzentratstufen',
    'No of Vessels': 'Anzahl der Druckrohre',
    'Powder': 'Pulver',
    'Print': 'Drucken',
    'Pump Flow rate': 'Pumpendurchflussrate',
    'Quantity of Cleaner': 'Reinigermenge',
    'Registration': 'Anmeldung',
    'Select': 'Wählen',
    'Single Product': 'Einzelnes Produkt',
    'Solution Volume': 'Lösungsvolumen',
    'Stage': 'Stufe',
    'Stages Cleaned in Parallel': 'Parallel gereinigte Stufen',
    'Stages Cleaned in Series': 'Stufen in Serie gereinigt',
    'Standard': 'Standard',
    'System Design': 'Systemdesign',
    'Total': 'Gesamt',
    'Vol in CIP piping': 'Volumen in CIP-Rohrleitungen',
    'Vol in CIP tank': 'Volumen im CIP-Tank',
    'Text 1 CIP': 'Die Reinigung ist ein komplexer Prozess, der Informationen über die tatsächlichen Verschmutzungsstoffe erfordert, um die beste CIP-Strategie und die besten zu verwendenden Produkte festzulegen. Die in diesem Auswahltool bereitgestellten Empfehlungen sind allgemeine Richtlinien zur Unterstützung bei der Produktauswahl.',
    'Text 2 CIP': 'Idealerweise sollte bei der Reinigerauswahl eine Verschmutzungsanalyse eingesetzt werden. Wenn keine Verschmutzungsanalyse verfügbar ist, konsultieren Sie das Dropdown-Menü oben und treffen Sie eine fundierte Vermutung.',
    'Text 3 CIP': 'Das Tool ermöglicht die Auswahl jeweils nur eines Schmutzmittels. Informationen zu Kombinationen von Verschmutzungen finden Sie im Dropdown-Menü unter „Empfohlene Auswahl für gemischte Verschmutzungen“.',
    'Text 4 CIP': 'Bei komplexen Szenarien oder wenn Schwierigkeiten beim Erreichen der erwarteten Ergebnisse aufgetreten sind, wenden Sie sich bitte an das MemChem-Produktanwendungsteam, um Unterstützung bei der Identifizierung alternativer Optionen und Produkte zu erhalten.'
  },
  Notification_Modal: {
    'Are you sure you want to close this form?': 'Möchten Sie dieses Formular wirklich schließen?',
    'Choose Report Options': 'Wählen Sie eine Berichtsoption',
    'Custom': 'Spezifisch',
    'Default units have been saved successfully.': 'Standardeinheiten wurden erfolgreich gespeichert.',
    'Display Units': 'Anzeigeeinheiten',
    'Do you want to clear the canvas?': 'Möchten Sie die Eingaben löschen?',
    'Do you want to close the page?': 'Möchten Sie die Seite schließen?',
    'Do you want to delete this unitop?': 'Möchten Sie diese Einheit löschen?',
    'Do you want to save the file?': 'Möchten Sie die Datei speichern?',
    'Failed to load Default units.': 'Standardeinheiten konnten nicht geladen werden.',
    'Failed to load win files': 'Fehler beim Laden der Win-Dateien',
    'Feed flow': 'Zulaufmenge',
    'Flow': 'Zulauf',
    'Flowsheet is either empty or incomplete...': 'Das Flussdiagramm ist entweder leer oder unvollständig',
    'Flowsheet is solved successfully.': 'Das Flussdiagramm wurde erfolgreich gelöst.',
    'Flowsheet solved with errors.': 'Flussdiagramm mit Fehlern gelöst.',
    'Flowsheet solving has failed.': 'Das Lösen des Flussdiagramms ist fehlgeschlagen.',
    'Flux': 'Fluss',
    'Generate PDF': 'PDF erzeugen',
    'Generate Sheets': 'Tabellenblätter erstellen',
    'International': 'International',
    'Ion Composition': 'Ionenzusammensetzung',
    'Kindly enter valid filename!': 'Bitte geben Sie einen gültigen Dateinamen ein!',
    'Kindly save the file before sharing!': 'Bitte speichern Sie die Datei vor dem Teilen!',
    'Load': 'Laden',
    'Load Winflows Design Simulator file': 'Laden Sie die Winflows-Designsimulatordatei',
    'Loading Please wait...': 'Laden, bitte warten...',
    'My Files': 'Meine Dateien',
    'No': 'Nein',
    'OK': 'OK',
    'Please add/update specify flow values!': 'Bitte geben Sie die Werte unter Fluss Spezifizierung ein bzw. aktualisieren Sie sie',
    'Power': 'Leistung',
    'Pressure': 'Druck',
    'Product flow': 'Produkt Fluss',
    'Product Flow': 'Produkt Fluss',
    'Reminder': 'Erinnerung',
    'Saturation Data': 'Sättigungsdaten',
    'Save as Default': 'Als Standard speichern',
    'Select file to upload': 'Zum Hochladen die Datei auswählen',
    'Shared By Others': 'Von anderen geteilt',
    'Solver Message': 'Solver-Nachricht',
    'Specify Flow': 'Fluss spezifizieren',
    'Stream Data': 'Fluss Daten',
    'Stream Properties': 'Fluss Eigenschaften',
    'Streams': 'Fluesse',
    'System Recovery': 'Systemwiederherstellung',
    'Temperature': 'Temperatur',
    'US': 'US Einheiten',
    'Upload File': 'Datei hochladen',
    'Volume': 'Volumen',
    'Yes': 'Ja',
    'You cannot share empty flowsheet !': 'Sie können kein leeres Flussdiagramm teilen!',
    'Successfully Done': 'Erfolgreich erledigt',
    'File saved successfully.': 'Datei erfolgreich gespeichert.',
    'File Share': 'Dateifreigabe',
    'Subject': 'Thema',
    'Message': 'Nachricht',
    'Share': 'Aktie',
    'Enter all input fields': 'Füllen Sie alle Eingabefelder aus',
    'Enter any one input field': 'Geben Sie ein beliebiges Eingabefeld ein',
    'Automate Stream ID': 'Automatisieren Sie die Stream-ID',
    'Quick Results': 'Schnelle Ergebnisse',
    'ARGO Analyzer Report': 'ARGO-Analysatorbericht',
    'Notifications': 'Benachrichtigungen',
    'Do you want to save the file ?': 'Möchten Sie die Datei speichern?',
    'Please select your country from the list given.': 'Bitte wählen Sie Ihr Land aus der angezeigten Liste aus.',
    'This selection allows Winflows to provide you with region-specific antiscalant options.': 'Diese Auswahl ermöglicht es Winflows, Ihnen regionsspezifische Antiscalant-Optionen bereitzustellen.',
    'Important: Your country selection is permanent and cannot be changed after submission.': 'Wichtig: Ihre Länderauswahl ist dauerhaft und kann nach der Übermittlung nicht mehr geändert werden.',
    'Failed to load saved win file': 'Die gespeicherte Win-Datei konnte nicht geladen werden',
    'RO Machine not available': 'RO-Maschine nicht verfügbar',
    'Entered stream number is duplicated!': 'Die eingegebene Stream-Nummer ist doppelt vorhanden!',
    'Failed to fetch Units': 'Einheiten konnten nicht abgerufen werden',
    'Failed to fetch DB transaction record': 'Das Transaktionsprotokoll konnte nicht aus der Datenbank abgerufen werden',
    'Failed to fetch feed input.': 'Die Feed-Eingabe konnte nicht abgerufen werden.',
    'File seems empty, please create the flowsheet!': 'Die Datei scheint leer zu sein. Bitte erstellen Sie das Flussdiagramm!',
    'Failed to save flow file': 'Flow-Datei konnte nicht gespeichert werden',
    'Failed to fetch file list': 'Dateiliste konnte nicht abgerufen werden',
    'Failed to save feed input.': 'Die Feed-Eingabe konnte nicht gespeichert werden.',
    'Failed to load win-4 files': 'Win-4-Dateien konnten nicht geladen werden',
    'Somthing is wrong.': 'Etwas stimmt nicht.',
    'failed to download the file': 'Die Datei konnte nicht heruntergeladen werden',
    'Something went wrong': 'Etwas ist schief gelaufen',
    'Failed to fetch Flowsheet Selection record': 'Der Flowsheet-Auswahldatensatz konnte nicht abgerufen werden',
    'No Data Found': 'Keine Daten gefunden',
    'Please enter valid filename': 'Bitte geben Sie einen gültigen Dateinamen ein',
    'Please provide a new name for the unitop as the current one is already available on the flowsheet.': 'Bitte geben Sie einen neuen Namen für das Unitop ein, da der aktuelle bereits im Flowsheet verfügbar ist.',
    'connections are incomplete!': 'Verbindungen sind unvollständig!',
    'Unitop inputs are either incomplete or incorrect!': 'Unitop-Eingaben sind entweder unvollständig oder falsch!',
    'Only one instance of Argo Analyzer can be used in a flowsheet.': 'In einem Flussdiagramm kann nur eine Instanz von Argo Analyzer verwendet werden.',
    'Winflows Design Simulator detects multiple feed sources on the current flowsheet. Please input the flow rate for the respective feed source.': 'Der Winflows-Designsimulator erkennt mehrere Feedquellen im aktuellen Flowsheet. Bitte geben Sie die Durchflussrate für die jeweilige Futterquelle ein.',
    'Enter all input field values!': 'Geben Sie alle Eingabefeldwerte ein!',
    'Permeate Flux': 'Permeatfluss',
    'Recovery': 'Erholung',
    'Explorer': 'Forscherin',
    'Average': 'Durchschnitt',
    'Element Max': 'Element max',
    'Vessels': 'Schiffe',
    'No. of Elements': "Anzahl der Elemente",
    'Element Type': "Elementtyp",
    'Conc. Flow': 'Konz. Fließen',
    'Perm Flow': 'Perm-Flow',
    'Age': 'Alter',
    'Saturation Data(Concentrate)': 'Sättigungsdaten (Konzentrat)',
    'Last Element Beta': 'Letzte Element-Beta',
    'Delta Pressure': 'Delta-Druck',
    'Avg.': 'Durchschn.',
    'Feed TDS': 'TDS füttern',
    'Perm TDS': 'Perm TDS',
    'A-Value ACP': 'A-Wert ACP',
    'B-Value ACP': 'B-Wert ACP',
    'A-Factor': 'A-Faktor',
    'B-Factor': 'B-Faktor',
    'Element No.': "Element Nr.",
    'Net Pressure': 'Nettodruck',
    'Update': 'Aktualisieren',
    'Ionic Composition': 'Ionische Zusammensetzung',
    'Table Setting': 'Tabelleneinstellung',
    'Stream Source': 'Stream-Quelle',
    'Stream Destination': 'Stream-Ziel',
    'Export Table': 'Tabelle exportieren',
    'Session has expired. Please login!': 'Sitzung ist abgelaufen. Bitte melden Sie sich an!',
    'Your session will expire in 10 minutes. Please save your work and login again.': 'Ihre Sitzung läuft in 10 Minuten ab. Bitte speichern Sie Ihre Eingabe und melden Sie sich erneut an.',
    'Session Expiry Warning': "Warnung vor Ablauf der Sitzung"
  },
  Help_Modal_Form: {
    '* or multiple of it': '* oder ein Vielfaches davon',
    'About': 'Um',
    'Database Date': 'Datenbankdatum',
    'Database Version': 'Datenbankversion',
    'Design Guidelines': 'Designrichtlinien',
    'Determine approximate number of RO elements': 'Ungefähre Anzahl der RO-Elemente bestimmen',
    'Determine array.': 'Array bestimmen.',
    'Determine number of element housings.': 'Anzahl der Elementgehäuse bestimmen.',
    'Determine which RO elements to use.': 'Bestimmen Sie, welche RO-Elemente verwendet werden sollen.',
    'Housings in 1': 'Gehäuse in 1',
    'OK': 'OK',
    'Permeate Recovery, %': 'Permeatrückgewinnung, %',
    'Program Date': 'Programmdatum',
    'Run Winflows Design Simulator with the 24-12 array and look for': 'Führen Sie den Winflows Design Simulator mit dem 24-12-Array aus und suchen Sie nach',
    'stage': 'Bühne',
    'Text1': 'Die folgenden Anweisungen sind eine Anleitung zum Entwurf einfacher RO-Einheiten, bei denen die Durchflussraten groß genug sind, sodass 18 oder mehr Elemente erforderlich sind, und der osmotische Druck des Zulaufs klein genug ist, um einen Betrieb mit einer Permeatrückgewinnung von über 65 Prozent zu ermöglichen. In diesem Fall besteht die Aufgabe darin, eine RO-Einheit zu entwerfen, die bei einer Permeatrückgewinnung von 80 Prozent 1,5 x 10 produziert.',
    'Text10': 'Das Permeatflussprofil (angezeigt im Winflows Design Simulator Explorer) ist nicht zu stark verzerrt (vorzugsweise sollte der Fluss des letzten Elements mindestens halb so groß sein wie der Fluss des führenden Elements). Möglicherweise ist eine Druckerhöhungspumpe zwischen den Stufen oder ein Permeatgegendruck in der ersten Stufe erforderlich, um den Permeatfluss zwischen den Stufen auszugleichen.',
    'Text2': 'gpd-Permeat mit unter 200 mg/l TDS aus Tiefbrunnenwasser mit 2000 mg/l TDS.',
    'Text3': 'Es werden Elemente mit 8 Zoll Durchmesser gewählt. Diese sind in der Regel in den Längen 365, 400 und 430 Fuß erhältlich.',
    'Text4': 'Versionen mit aktiver Membranfläche. Normalerweise gilt: Je größer die aktive Membranfläche, desto dünner ist der Abstandshalter des Zufuhrkanals und desto höher ist die Verschmutzungsneigung des Elements. In diesem Fall handelt es sich bei der Zufuhr um Tiefbrunnenwasser mit geringer Verschmutzungsneigung, daher wird ein 400-ft2-Elementmodell gewählt.',
    'Text5': 'Wählen Sie den durchschnittlichen Permeatfluss, beispielsweise aus den Designrichtlinien. In diesem Beispiel ist das Zulaufwasser Tiefbrunnenwasser mit sehr geringer Verschmutzungstendenz, daher wird ein durchschnittlicher Permeatfluss von 15 gfd gewählt.',
    'Text6': 'Berechnen Sie die Anzahl der erforderlichen Elemente (N) aus der Permeatflussrate (Fp), dem durchschnittlichen Permeatfluss (Jw) und der aktiven Membranfläche pro Element (AA).',
    'Text7': 'Fp = N×AA×Jw, was in diesem Fall N = 250 Elemente ergibt.',
    'Text8': 'Normalerweise gibt es 6 oder 7 Elemente pro Gehäuse. In diesem Fall werden 7 Elemente pro Gehäuse gewählt, was 36 Elementgehäuse ergibt.',
    'Text9': 'Bei einer Permeatrückgewinnung von 80 Prozent wird ein zweistufiges Array wahrscheinlich gut funktionieren, was bedeutet, dass sich etwa 2/3 der Gehäuse in der ersten Stufe befinden. Versuchen Sie es also mit einem 24-12-Array.',
    'The below table is used to determine how to approximately arrange the housings.': 'Zur Ermittlung der ungefähren Anordnung der Gehäuse dient die nachfolgende Tabelle.',
    'The predicted permeate TDS should be below the maximum allowed.': 'Der vorhergesagte Permeat-TDS sollte unter dem zulässigen Maximum liegen.',
    'The pressure drop over the elements': 'Der Druckabfall über den Elementen',
    'Tips on Designing RO Units Operating on Natural Waters with Below 5000 mg/L TDS': 'Tipps zur Konstruktion von Umkehrosmoseanlagen für den Betrieb mit natürlichem Wasser mit einem TDS-Wert unter 5000 mg/l',
    'Typical array*': 'Typisches Array*',
    'Warnings': 'Warnhinweise',
    'Winflows Design Simulator RO Elements Design Guidelines': 'Winflows Design Simulator RO Elements Designrichtlinien',
  },
  Preface: {
    "Winflows": "Winflows",
    "Design Simulator": "Designsimulator",
    "Winflows Design Simulator": "Winflows Designsimulator",
    "Projection Report": "Prognosebericht",
    "WATER TECHNOLOGIES": "WASSERTECHNOLOGIEN",
    "Project Info": "Projektinformationen",
    "Project Name": "Projektname",
    "Customer Name": "Kundenname",
    "Engineer": "Designer",
    "Location": "Standort",
    "Mail ID": "E-Mail",
    "Phone No": "Telefon",
    "Specify Flow Option": "Durchflussoption angeben",
    "Notes": "Notizen",
    "Notifications": "Benachrichtigungen",
    "None detected in the current design": "Keine Probleme im aktuellen Design erkannt",
    "Trademark of Veolia": "*Markenzeichen von Veolia; möglicherweise in einem oder mehreren Ländern registriert. 2025 Veolia. Alle Rechte vorbehalten",
    "Database": "Datenbank",
    "Description": "Beschreibung",
    "Unit Op": "Prozesseinheit",
    'Total Number of Warnings': 'Gesamtzahl der Warnungen',
    'Total Number of Errors': 'Gesamtzahl der Fehler',
    'Disclaimer_text': 'Haftungsausschluss: Diese Prognose wird als kostenloser Service bereitgestellt und stellt keine Leistungs­garantie dar.'
  },
  Flowsheet_Design_Summary: {
    'Flowsheet Diagram': 'Fließschema',
    'Flowsheet Design Summary': 'Zusammenfassung des Fließschemas',
    'Flowsheet Design': 'Fließschema',
    'Stream Property Summary': 'Zusammenfassung der Fluss-Eigenschaft',
    'Stream Id': 'Fluss-ID',
    'Alkalinity, ppm CaCO3': 'Alkalinität, ppm CaCO3',
    'Hardness, ppm as CaCO3': 'Härte, ppm as CaCO3',
    'Alkalinity': 'Alkalinität',
    'Hardness': 'Härte',
    'Conductivity at 25°C': 'Leitfähigkeit bei 25 °C',
    'FSD Flow Balance': 'FSD-Durchflussbilanz',
    'Unit ID (Stream no.)': 'Einheiten-ID (Strom-Nr.)',
    'Overall Flow Sheet Recovery': 'Gesamte Fließschema-Rückgewinnung',
    'Flow - Total': 'Durchfluss – Gesamt',
    'Incoming': 'Eingang',
    'Outgoing': 'Ausgang',
    'Product': 'Produkt',
    'Waste': 'Rest',
    'ID': 'ID',
    'Conc.': 'Konzentration',
    'Bleed': 'Ablass',
    'Desalination_Demineralization': 'Zusammenfassung des Durchflusses auf Einheitsebene – Entsalzung / Entmineralisierung / Membranabscheider (MEMS)',
  },
  Feed_Product_Waste_Summary: {
    'Feed-Product-Waste Summary': 'Zusammenfassung Zulauf-Produkt-Rest',
    'Overall Flowsheet Recovery': 'Gesamte Fließschema-Rückgewinnung',
    'Category': 'Kategorie',
    'Information': 'Information',
    'Ion Concentration': 'Ionenkonzentration',
    'Stream Property': 'Stromeigenschaft',
    'Water Source': 'Wasserquelle',
    'Ionic Strength': 'Ionenstärke',
    'Osm.Pressure': 'Osmotischer Druck',
    'Osm. Pressure': 'Osmotischer Druck',
    'Softened Water': 'Weiches Wasser',
    'Pump Unit Summary': "Zusammenfassung der Pumpeneinheit"
  },
  RO_NF_Unit_System_Level_Summary: {
    'RO/NF Unit System-Level Summary': 'Systemübersicht RO/NF-Einheit',
    'Docked Summary': 'Angefügte Zusammenfassung',
    'Total Number of RO/NF Unit': 'Gesamtanzahl RO/NF-Einheiten',
    'RO/NF Unit ID': 'RO/NF-Einheiten-ID',
    'Upstream unit': 'Vorgeschaltete Einheit',
    'Downstream unit': 'Nachgeschaltete Einheit',
    'Permeate Flow': 'Permeatstrom',
    'Concentrate Flow': 'Konzentratstrom',
    'RO/NF Unit Recovery': 'Rückgewinnung der RO/NF-Einheit',
    'Breakdown by Stage': 'Auflistung nach Stufe',
    'Total Membrane Area': 'Gesamtmembranfläche',
    'Feed Temperature': 'Zulauftemperatur',
    'Interstage Pressure': 'Druck zwischen den Stufen',
    'Product Pressure *': 'Produktdruck*',
    'Feed pH': 'Zulauf-pH',
    'Permeate TDS': 'Permeat-TDS',
    'Concentrate TDS': 'Konzentrat-TDS',
    'Concentrate pH': 'pH des Konzentrats',
    'Detailed Design': 'Detaillierte Auslegung',
    'Array Design': 'Array-Design',
    'Housing': 'Gehäuse',
    'Elements': 'Elemente',
    'Element Age(yr)': 'Elementalter (Jahre)',
    'Pressure Change': 'Druckänderung',
    'Boost': 'Druckerhöhung',
    'Loss': 'Verlust',
    'Permeate P': 'Permeatdruck',
    'Permeate pH': 'Permeat-pH',
    'A-Value ACP': 'A-Wert ACP',
    'A-Factor': 'A-Faktor',
    'B-Value ACP': 'B-Wert ACP',
    'B-Factor': 'B-Faktor',
  },
  RO_NF_Unit_Stage_Level_Summary: {
    'RO/NF Unit Stage-Level Summary': 'Stufenübersicht RO/NF-Einheit',
    'Element Type': 'Elementtyp',
    'Perm': 'Permeat',
    'dP': 'dP',
  },
  DSSRO_Section_Summary: {
    'DSSRO Section Summary': 'Abschnittszusammenfassung DSSRO',
    'DSSRO Overview': 'Überblick DSSRO',
    'Overview': 'Überblick',
    'DSSRO mode': 'DSSRO-Modus',
    'CLRO': 'CLRO',
    'Elements per PV': 'Elemente pro PV',
    'Spacers per PV': 'Abstandshalter pro PV',
    'Length of PV': 'Länge des PV',
    'CL Recovery': 'CL-Rückgewinnung',
    'BP Recovery': 'BP-Rückgewinnung',
    'CL Concentrate Flow': 'CL-Konzentratstrom',
    'BP Concentrate Flow': 'BP-Konzentratstrom',
    'CL Net Feed Flow': 'CL-Nettozulaufstrom',
    'BP Feed Flow': 'BP-Zulaufstrom',
    'CL Permeate Flow': 'CL-Permeatstrom',
    'Total Circuits': 'Gesamtzyklen',
    'BP Sequence Duration': 'BP-Sequenzdauer',
    'CL Sequence Duration': 'CL-Sequenzdauer',
    'Complete Cycle Duration': 'Gesamte Zyklusdauer',
    'CL System Volume': 'CL-Systemvolumen',
    'S1 Volume': 'Volumen S1',
    'S2 Volume': 'Volumen S2',
    'S3 Volume': 'Volumen S3',
    'DSSRO Flow Summary (Element Level)': 'DSSRO-Durchflussübersicht (Elementebene)',
    'Flow Summary': 'Durchflussübersicht',
    'Circuit': 'Zyklus',
    'Element': 'Element',
    'Feed Press': 'Zulaufdruck',
    'Conc Flow': 'Konzentratstrom',
    'CL 1': 'CL 1',
    'CL Final': 'CL-Ende',
    'DSSRO Stream Composition': 'DSSRO-Stromzusammensetzung',
    'Concentrations': 'Konzentrationen',
    'Concentrations (mg/L as ion)': 'Konzentrationen (mg/L als Ion)',
    'Concentrate': 'Konzentrat',
    'Permeate': 'Permeat',
    'Composition': 'Zusammensetzung',
    'Schematic': 'Schema',
    'Production Loop': 'Produktionskreislauf',
    'High Pressure Centrifugal Pump (P2)': 'Hochdruck-Kreiselpumpe (P2)',
    'Raw Feed Flow': 'Rohzulaufstrom',
    'Feed Pump (P1)': 'Zulaufpumpe (P1)',
    'RO Feed': 'RO-Zulauf',
    'Cartridge Filter': 'Filterkartusche',
    'Feed Pressure': 'Zulaufdruck',
    'Delta Pressure': 'Differenzdruck',
    'Circulation pump (P3)': 'Umwälzpumpe (P3)',
    'CL Conc Flow': 'CL-Konzentratstrom',
    'CL Perm Flow': 'CL-Permeatstrom',
    'Brine Purge': 'Solepurge',
    'Conc Recirculation Flow': 'Konzentrat-Rücklaufstrom',
    'BP Conc Flow': 'BP-Konzentratstrom',
    'Brine Disposal': 'Soleentsorgung',
    'DSSRO Loop Summary': 'DSSRO-Kreislaufzusammenfassung',
    'Loop No': 'Schleifen-Nr.',
    'Permeate Stream (Loop wise) Summary': 'Zusammenfassung des Permeatstroms (schleifenweise)',
    'Concentrate Stream (Loop wise) Summary': 'Zusammenfassung des Konzentratstroms (schleifenweise)',
  },
  Pump_Summary: {
    'Pump Summary': 'Pumpenübersicht',
    'Total Number of Pumps': 'Gesamtanzahl der Pumpen',
    'Pump Unit ID': 'Pumpen-Einheiten-ID',
    'RO/NF Unit Attached': 'Angeschlossene RO/NF-Einheit',
    'Combined Efficiency': 'Kombinierter Wirkungsgrad',
    'Total Power Consumption': 'Gesamtstromverbrauch (kW)',
  }, Detailed_Stream_Data: {
    'Detailed Stream Data': 'Detaillierte Stromdaten',
    'LSI': 'LSI',
    'SDSI': 'SDSI',
    'Concentrate': 'Konzentrat',
    'Inlet': 'Einlass',
    'Downstream Permeate': 'Nachgeschaltetes Permeat',
    'Stream ID': 'Strom-ID'
  },
  EDI_Unit_System_Level_Summary: {
    'EDI Unit System-Level Summary': 'Systemübersicht EDI-Einheit',
    'Total Number of EDI Unit': 'Gesamtanzahl EDI-Einheiten',
    'EDI Unit ID': 'EDI-Einheiten-ID',
    'System Product Flow Rate': 'System-Produktdurchfluss',
    'Electrode Bleed Flow': 'Elektroden-Ablassstrom',
    'EDI Unit Recovery': 'Rückgewinnung der EDI-Einheit',
    'No. of E-Cell EDI Stacks': 'Anzahl E-Cell EDI-Stacks',
    'Concentrate Pressure': 'Konzentratdruck',
    'Product Outlet Pressure': 'Produkt-Austrittsdruck',
    'Voltage': 'Spannung',
    'AC Power': 'Wechselstromleistung',
    'DC Power': 'Gleichstromleistung',
    'DC power': 'Gleichstromleistung',
    'Flow Configuration': 'Durchflusskonfiguration',
    'Counter-Current/Co-Current': 'Gegenstrom/Gleichstrom',
    'Counter-Current': 'Gegenstrom',
    'Feed TDS': 'Zulauf-TDS',
    'Feed pH': 'Zulauf-pH',
    'Product Resistivity': 'Produkt-Resistivität',
    'Product pH': 'Produkt-pH',
    'Concentrate TDS': 'Konzentrat-TDS',
    'Concentrate pH': 'pH des Konzentrats',
    'Electrode Bleed TDS': 'Elektroden-Ablass-TDS',
    'Electrode Bleed pH': 'pH des Elektroden-Ablasses',
    'H2': 'H2',
    'Cl2': 'Cl2',
    'Blower/Ventilation Sizing for H2': 'Gebläse-/Lüftungsauslegung für H2',
    'Ventilation Blower/Fan': 'Lüftungsgebläse/Ventilator',
    'Size': 'Größe',
    'Electrode_stream_vented_hydrogen': 'Der Elektrodenstrom muss entlüftet werden, da er geringe Mengen Wasserstoff, Sauerstoff und ggf. Chlor enthält (bei Chloridionen).',
    'hydrogen_oxygen_gas_edi': 'Ein 2:1-Gemisch aus Wasserstoff und Sauerstoff wird mit max. 11,4 ml/A/min/Stack erzeugt (Trocken­gas bei 25 °C, 1,0 bar), davon 7,6 ml H2 und 3,8 ml O2. Sicherstellen, dass H2 unter 4 % bleibt.',
    'EDI Design Parameters': 'EDI-Designparameter',
    'Product Flow Rate per Stack': 'Produktdurchfluss pro Stack',
    'Upstream Interconnecting Piping': 'Oberstrom-Verbindungsrohrleitung',
    'Pressure Loss': 'Druckverlust',
    'TEA': 'TEA',
    'TEC': 'TEC',
    'Silica': 'Silica (Kieselsäure)',
    'Conductvity': 'Leitfähigkeit',
    'Product Silica guarantee level': 'Garantierter Silica-Gehalt des Produkts',
    'Predicted Product Silica Level': 'Prognostizierter Silica-Gehalt des Produkts',
    'Predicted Product Sodium level': 'Prognostizierter Natriumgehalt des Produkts',
    'Predicted Product Chloride level': 'Prognostizierter Chloridgehalt des Produkts',
    'Predicted Product Sulfate level': 'Prognostizierter Sulfatgehalt des Produkts',
    'Maximum Allowable Recovery': 'Maximal zulässige Rückgewinnung',
    'AC power consumption': 'Wechselstrom-Leistungsaufnahme',
    'AC energy': 'Wechselstromenergie',
    'Predicted Product outlet pressure': 'Prognostizierter Produktaustrittsdruck',
    'Feed Inlet': 'Zulaufeintritt',
    'Concentrate Outlet': 'Konzentrat-Austritt',
    'Electrode Bleed': 'Elektroden-Ablass',
    'EDI Schematic': 'EDI-Schema',
    'Current/Stack': 'Strom/Stack',
    'Stack Voltage': 'Stack-Spannung',
    'Energy Consumption': 'Energieverbrauch',
    'Maximum Recovery': 'Maximale Rückgewinnung',
    'Max. Conc. outlet pressure': 'Max. Konzentrat-Austrittsdruck',
    'Conc. Bleed flow': 'Konzentrat-Ablassstrom',
    'Product pressure': 'Produktdruck',
    'Max. Conc. inlet pressure': 'Max. Konzentrat-Eintrittsdruck',
    'Max. Electrode Bleed Pressure': 'Max. Elektroden-Ablassdruck',
    'Dilute': 'Verdünnt',
    'Concentrate': 'Konzentrat',
    'Electrode': 'Elektrode',
  },
  CF_Unit_Summary: {
    'CF Unit Summary': 'CF-Einheitsübersicht',
    'Total Number of CF Unit': 'Gesamtanzahl der CF-Einheiten',
    'CF Unit ID': 'CF-Einheiten-ID',
    'Flow Capacity': 'Durchflusskapazität',
    'Filter Type': 'Filtertyp',
    'Design Flow Per TIE': 'Auslegungsdurchfluss pro TIE',
    'Outlet Pressure': 'Austrittsdruck',
    'Pressure Drop': 'Druckabfall',
  },
  Chemical_Dosing_Unit_Summary: {
    'Chemical Dosing Unit Summary': 'Zusammenfassung der Chemikaliendosierungseinheit',
    'Total Number of Chemical Dosing': 'Gesamtanzahl der Chemikaliendosierungen',
    'Dosing Endpoint': 'Dosierungsendpunkt',
    'Target Value': 'Zielwert',
    'Concentration as Metered': 'Gemessene Konzentration',
    'Specific Gravity as Metered': 'Gemessene Dichte',
    'Metered Flow Rate': 'Gemessene Durchflussrate',
    'Avg Cons.As Metered': 'Durchschnittlicher Verbrauch (gemessen)',
    'Avg Cons.As Supplied': 'Durchschnittlicher Verbrauch (geliefert)',
    'Avg Cons.As Supplied with SF': 'Durchschnittlicher Verbrauch mit Sicherheitsfaktor',
    'Sulfuric Acid': 'Schwefelsäure',
    'Hydrochloric Acid': 'Salzsäure',
    'Phosphoric Acid': 'Phosphorsäure',
    'Nitric Acid': 'Salpetersäure',
    'Carbon Dioxide': 'Kohlendioxid',
    'Ammonia': 'Ammoniak',
    'Caustic Soda': 'Natronlauge',
    'Slaked Lime': 'Gelöschter Kalk',
    'Sodium Carbonate': 'Natriumcarbonat',
    'Calclium Carbonate': 'Calciumcarbonat',
    'Sodium Sulfate': 'Natriumsulfat',
    'Sodium Cycle Softener': 'Natrium-Zyklus-Weichmacher',
    'Target pH': 'Ziel-pH',
    'Total Number of Chemical Type': 'Gesamtanzahl der Chemikalientypen',
    'Aggregated by Chemical Type – Supplied Form': 'Nach Chemikalientyp aggregiert – Lieferform',
    'Chemical Type': 'Chemikalientyp',
    'Chemical Dosing Unit ID': 'Kennung der Chemikaliendosierungseinheit',
    'Concentration as Supplied': 'Konzentration (geliefert)',
    'Specific Gravity as Supplied': 'Dichte (geliefert)',
    'Total Consumption': 'Gesamtverbrauch',
    'As Supplied': 'In Lieferform',
  },
  Antiscalant_Dosage_Summary: {
    'Antiscalant Dosage Summary': 'Zusammenfassung der Antiscalant-Dosierung',
    'Dosed In': 'Dosiert in',
    'Antiscalant': 'Antikalkmittel',
    'Dosage in Feed': 'Dosierung im Zulauf'
  },
  ERD_Unit_Summary: {
    'ERD Unit Summary (WIP)': 'ERD-Einheitsübersicht (in Bearbeitung)',
    'Total Number of ERD Unit': 'Gesamtanzahl der ERD-Einheiten',
    'ERD Unit ID': 'ERD-Einheiten-ID',
    'ERD Type': 'ERD-Typ',
    'RO/NF Unit Attached': 'Angeschlossene RO/NF-Einheit',
    'Installed Location': 'Installationsort',
    'LP Discharge Pressure': 'LP-Auslassdruck',
    'Net Transfer Efficiency': 'Netto-Übertragungseffizienz',
    'Boost Pressure': 'Boost-Druck',
    'Leakage (Reject in HP OUT)': 'Leckage (Ablehnung im HP-Ausgang)',
    'Mixing at Membrane Feed': 'Mischung am Membranzulauf',
    'Total Power Consumption': 'Gesamtenergieverbrauch',
    'HP Pump': 'HP-Pumpe',
    'Circulation Pump': 'Umlaufpumpe',
    'Energy Recovered': 'Zurückgewonnene Energie',
    'Power Saving': 'Energieeinsparung',
    'Work Exchanger (WX)': 'Wärmeaustauscher (WX)',
  },
  Mixer_Splitter_Unit_Summary: {
    'Mixer-Splitter Unit Summary': 'Zusammenfassung der Mischer-Teiler-Einheit',
    'Total Number of Mixer-Splitter': 'Gesamtanzahl Mischer-Teiler',
    'Mixer-Splitter Unit ID': 'Mischer-Teiler Einheiten-ID',
    'Inlet Stream ID': 'Einlassstrom-ID',
    'Outlet Stream ID': 'Auslassstrom-ID',
    'Mode': 'Modus',
    'Mix Ratios': 'Mischverhältnisse',
    'Split Ratios': 'Teilungsverhältnisse',
    'calculated': 'berechnet',
    'user input': 'Benutzereingabe',
    'Mix only': 'Nur Mischen',
    'Split only': 'Nur Teilen',
  },
  Detailed_RO_NF_Element_Level_Data: {
    'Detailed RO/NF Element-Level Data': 'Detaillierte RO/NF-Elementdaten',
    'Parameter': 'Parameter',
    'Stage No.': 'Stufennummer',
    'Element Pos.': 'Elementposition',
    'Other': 'Andere',
    'Stream Property': 'Strömeigenschaft',
    'Permeate Ion Concentration': 'Ionenkonzentration im Permeat',
    'Net Driving': 'Nettoantrieb',
    'Delta Pressure': 'Differenzdruck',
    'Feed Osm. Pressure': 'Osmotischer Druck des Zulaufs'
  },
  Winflows_Design_Simulator_Program_Details: {
    'Winflows Design Simulator Program Details': 'Winflows Design-Simulationsprogramm Details',
    'Program Version': 'Programmversion',
    'Program Last Update': 'Letzte Programmaktualisierung',
    'Database Last Update': 'Letzte Datenbankaktualisierung',
    'Contact for Technical Support': 'Kontakt für technischen Support',
  },
  Stripper_Unit_Summary: {
    'Stripper Unit Summary': 'Zusammenfassung der Strippereinheit',
    'Total Number of Stripper': 'Gesamtanzahl der Strippereinheiten',
    'Outlet CO2 Concentration': 'CO₂-Konzentration am Ausgang',
    'Stripper Unit ID': 'Kennung der Strippereinheit',
    'Outlet H2S Concentration': 'H₂S-Konzentration am Ausgang',
    'Outlet NH3 Concentration': 'NH₃-Konzentration am Ausgang',
  },
  Notification: {
    'FATAL ERROR!! Transmembrane Pressure Limit Exceeded! in ROHP_1 of Stage 1 of element 1 at given temperature.\n\nPlease change design!\nThe applied feed pressure exceeds the limit recommended for at least one of the elements selected. Operation above the maximum pressure can result in element damage, specifically, collapsed permeate channels, which will result in loss of element permeate productivity.\nExcessive pressure can also cause central tube collapse and subsequent element failure. To reduce the operating pressure for the system:\n1) increase the number of elements in the system,\n2) reduce the system recovery,\n3) increase the system feed temperature.': 'FATALER FEHLER! Transmembraner Druckgrenzwert überschritten! in ROHP_1, Stufe 1, Element 1 bei gegebener Temperatur.\n\nBitte ändern Sie das Design!\nDer angewendete Zulaufdruck überschreitet den empfohlenen Grenzwert für mindestens ein ausgewähltes Element. Ein Betrieb über dem Maximaldruck kann zu Schäden führen, insbesondere zum Kollaps der Permeatkanäle, was die Produktivität verringert.\nÜbermäßiger Druck kann auch zum Zusammenbruch des Zentralrohrs und zum Versagen des Elements führen. Zur Senkung des Betriebsdrucks:\n1) Anzahl der Elemente im System erhöhen,\n2) Systemrückgewinnung reduzieren,\n3) Zulauftemperatur erhöhen.'
  }
};